(function(){
  'use strict';
  var ROOT = document.getElementById('gs-elig');
  if (!ROOT) return;

  /* ---- Scoreboard embed ("#uploadbill-scoreboard") ----
     A closer or setter uploads the homeowner's bill from inside the Scoreboard. Only the bill sheet shows:
     no close button and no way back to this page's home screen, and Done hands control back to the
     Scoreboard. Shopify refuses to be framed by URL, so the Scoreboard frames this section through srcdoc,
     where location has no query or hash — the link code and the mode arrive in window.__GS_EMBED instead.
     The same mode works on the real URL as …?c=CODE#uploadbill-scoreboard. ---- */
  var EMB = window.__GS_EMBED || {};
  var EMBED_BILL = EMB.mode === 'uploadbill-scoreboard' || /uploadbill-scoreboard/i.test(location.hash || '');
  function embedPost(type, extra){
    if (!EMBED_BILL) return;
    var m = { type: type }, k; if (extra) for (k in extra) m[k] = extra[k];
    var o = window.origin || location.origin;   // window.origin first: inside the srcdoc frame location.origin is the string "null"
    if (!o || o === 'null') return;
    try { if (window.parent && window.parent !== window) window.parent.postMessage(m, o); } catch (e) {}
    try { if (window.opener) window.opener.postMessage(m, o); } catch (e) {}
  }
  if (EMBED_BILL){
    ROOT.classList.add('gse-embed-bill');
    // no context menu: in the Setter Browser it offers "Open Frame in New Window", a way out of the popup
    document.addEventListener('contextmenu', function(e){ e.preventDefault(); }, true);
    // the home screen stays out of sight and out of the tab order
    ['.gss-chrome', '.gss-stage'].forEach(function(sel){ var el = ROOT.querySelector(sel); if (el) el.style.display = 'none'; });
  }

  /* JS-robust copy fix: this spoilage sub-line lives in the liquid; patch it here too so it reads
     correctly even when the liquid wasn't re-uploaded. Idempotent. */
  (function fixSpoilCopy(){
    try {
      Array.prototype.forEach.call(ROOT.querySelectorAll('.gss-vpp-step strong'), function(st){
        if (/coordinator files it with you/i.test(st.textContent)){
          var span = st.parentNode && st.parentNode.querySelector('span');
          if (span && !/all the proof you need/i.test(span.textContent)) span.textContent = 'Your photos are all the proof you need.';
        }
      });
    } catch (e) {}
  })();

  /* ---- initial loading veil: cycles messages, hides once stats are ready ---- */
  var gssLoadStart = Date.now(), gssLoadDone = false, leadPending = false;
  var gssLoadMsgs = ['Verifying account…', 'Pulling local grid data…', 'Checking your eligibility…'];
  var gssLoadMsgI = 0;
  var gssLoadTimer = setInterval(function(){
    gssLoadMsgI = (gssLoadMsgI + 1) % gssLoadMsgs.length;
    var t = document.getElementById('gseLoadTxt'); if (t) t.textContent = gssLoadMsgs[gssLoadMsgI];
  }, 950);
  function hideLoading(){
    if (gssLoadDone || leadPending) return; gssLoadDone = true;   // keep the veil up until the account loads (or an error shows)
    clearInterval(gssLoadTimer);
    var wait = Math.max(0, 850 - (Date.now() - gssLoadStart)); // brief minimum so it reads as intentional
    setTimeout(function(){
      var el = document.getElementById('gseLoading'); if (!el) return;
      el.classList.add('gss-hide');
      setTimeout(function(){ el.style.display = 'none'; }, 480);
    }, wait);
  }
  setTimeout(hideLoading, 4500); // safety: never trap the user behind the veil (no-op while an account is still loading)

  // The account link failed to load after several retries — show an explicit error + Retry instead of
  // silently dropping the visitor onto the generic "Neighbor" page with a dead CTA.
  function showLoadError(notFound){
    embedPost('gs-uploadbill-error', { notFound: !!notFound });
    var veil = document.getElementById('gseLoading'); if (!veil) return;
    clearInterval(gssLoadTimer);
    var ring = veil.querySelector('.gss-load-ring'); if (ring) ring.style.display = 'none';
    var txt = document.getElementById('gseLoadTxt');
    if (txt){
      txt.textContent = notFound
        ? 'This link has expired or is no longer valid. Please reach out to your coordinator for a new one.'
        : 'We couldn’t load your details. Check your connection and try again.';
      txt.style.maxWidth = '300px'; txt.style.textAlign = 'center';
    }
    if (!notFound && !document.getElementById('gseLoadRetry')){   // retrying only helps transient failures, not a dead link
      var b = document.createElement('button'); b.id = 'gseLoadRetry'; b.type = 'button'; b.textContent = 'Retry';
      b.style.cssText = 'padding:13px 30px;border-radius:999px;border:0;background:var(--ok,#34c759);color:#04210f;font:800 15px/1 -apple-system,system-ui,Arial;cursor:pointer';
      b.addEventListener('click', function(){ location.reload(); });
      veil.appendChild(b);
    }
  }

  /* remember where the section lives so we can restore it on desktop */
  var gssOrigParent = ROOT.parentNode, gssOrigNext = ROOT.nextSibling;
  var gssMqFull = window.matchMedia('(max-width: 820px)');

  var CFG = window.GSE_CFG || {};

  /* ---- full-screen on mobile only: pin to the viewport & cover the site chrome.
         Desktop keeps the normal in-flow layout and the site header. ---- */
  function fitViewport(){
    if (gssMqFull.matches){ ROOT.style.height = ''; fitStats(); return; } // gss-fs (fixed inset:0) fills the real viewport — avoids the iOS svh gap
    var top = ROOT.getBoundingClientRect().top + window.scrollY;
    var hdr = document.querySelector('header.header, .header-wrapper, sticky-header');
    var off = hdr ? hdr.getBoundingClientRect().height : 0;
    var gtop = Math.max(off, Math.min(top, 140));
    ROOT.style.height = 'calc(100svh - ' + gtop + 'px)';
    ROOT.style.setProperty('--gse-hdr', gtop + 'px');   // the full-screen sheets put their back button just under the site header
    fitStats();
  }

  // Shrink the stat pills (mobile only) until the intro content fits above the
  // reserved CTA space — so there's always a gap between the pills and the button.
  function setPillScale(s){
    ROOT.querySelectorAll('.gss-zpill').forEach(function(p){ p.style.padding = (11 * s).toFixed(1) + 'px 8px'; });
    ROOT.querySelectorAll('.gss-zpill strong').forEach(function(el){ el.style.fontSize = (22 * s).toFixed(1) + 'px'; });
    ROOT.querySelectorAll('.gss-zpill span').forEach(function(el){ el.style.fontSize = (9.5 * Math.max(s, 0.82)).toFixed(1) + 'px'; });
  }
  var GSE_PANELS = ['gseSat','gseVPP','gseLive','gseMapWrap','gseSpoil'];
  // Whichever visual panel is currently on screen (only one is ever visible).
  function gseVisiblePanel(){
    for (var i = 0; i < GSE_PANELS.length; i++){
      var el = ROOT.querySelector('#' + GSE_PANELS[i]);
      if (el && !el.hidden && el.offsetParent !== null) return el;
    }
    return null;
  }
  // Natural (content) height of a panel, ignoring its aspect-ratio box.
  function gseNaturalH(el){
    var ar = el.style.aspectRatio, mh = el.style.maxHeight;
    el.style.aspectRatio = 'auto'; el.style.maxHeight = 'none';
    var h = el.scrollHeight;
    el.style.aspectRatio = ar; el.style.maxHeight = mh;
    return h;
  }
  function fitStats(){
    var slide = ROOT.querySelector('.gss-slide[data-slide="intro"]');
    if (!slide) return;
    setPillScale(1);
    GSE_PANELS.forEach(function(id){ var el = ROOT.querySelector('#' + id); if (el) el.style.maxHeight = ''; });
    if (!gssMqFull.matches) return;       // desktop keeps full size
    var over = function(){ return slide.scrollHeight - slide.clientHeight; };
    // 1) shrink the pills a little
    var s = 1, guard = 0;
    while (over() > 1 && s > 0.78 && guard < 8){ s -= 0.05; setPillScale(s); guard++; }
    // 2) if still tight, trim whichever visual panel is on screen so the stats
    //    clear the sticky CTA. The satellite is an image (safe to crop hard);
    //    the text cards (Live / Why-VPP) only shrink to their content height.
    var vis = gseVisiblePanel();
    if (vis && over() > 1){
      var h = vis.getBoundingClientRect().height;
      var floor = (vis.id === 'gseSat') ? h * 0.52 : gseNaturalH(vis);
      vis.style.maxHeight = Math.max(floor, h - over() - 6) + 'px';
    }
  }
  function applyFullscreen(){
    if (EMBED_BILL || gssMqFull.matches){
      if (ROOT.parentElement !== document.body) document.body.appendChild(ROOT);
      ROOT.classList.add('gss-fs');
    } else {
      ROOT.classList.remove('gss-fs');
      if (ROOT.parentElement === document.body && gssOrigParent) gssOrigParent.insertBefore(ROOT, gssOrigNext);
    }
    fitViewport();
  }
  applyFullscreen();
  window.addEventListener('resize', fitViewport);
  if (gssMqFull.addEventListener) gssMqFull.addEventListener('change', applyFullscreen);
  else if (gssMqFull.addListener) gssMqFull.addListener(applyFullscreen);

  /* ---- day/night adaptive (matches Program Benefits page) ---- */
  var GSE_FORCE_DAY = true;   // Dion 2026-10-07: day mode for everyone for now; flip to false to bring back the evening theme
  function applyTheme(){
    if (gssSim && gssSim.state && gssSim.state.theme === 'dark'){ ROOT.classList.add('gse-dark'); return; }   // simulated night (re-runs every minute)
    if (GSE_FORCE_DAY){ ROOT.classList.remove('gse-dark'); return; }
    if (!CFG.nightTheme) return;
    var m = new Date().getHours()*60 + new Date().getMinutes();
    ROOT.classList.toggle('gse-dark', (m < 6*60+30) || (m >= 18*60+45));
  }
  applyTheme(); setInterval(applyTheme, 60000);

  /* ============================================================
     LEAD HYDRATION
     Primary: ?c=CODE → Worker /lead resolves the GHL contact live
     (cid never reaches the browser). Fallbacks: ?h= token, plain
     params for testing, then the default demo address.
  ============================================================ */
  var P = new URLSearchParams(location.search);
  var leadCode = P.get('c') || (typeof EMB.c === 'string' && EMB.c) || null;
  /* Short texted link: gridstability.co/vpp/CODE lands here as ?c=CODE&via=vpp (Shopify URL redirect) or
     &via=vpp404 (theme 404 hand-off). Put /vpp/CODE back in the address bar, hash kept. Safe this early: the
     query is only ever read through the P snapshot above, later hash reads see the same hash, and a reload
     (Retry, cancel, simulator) goes back through /vpp/ to the same query. Any other param (test, h, fn…)
     or a plain ?c= link leaves the URL alone.
     window.history: the slide engine's `var history` (below) shadows the global in this whole IIFE. */
  (function vppAddressBar(){
    var via = P.get('via'), c = P.get('c') || '', only = true;
    if ((via !== 'vpp' && via !== 'vpp404') || window.__GS_EMBED || location.protocol !== 'https:' || location.hostname !== 'gridstability.co') return;
    P.forEach(function(v, k){ if (k !== 'c' && k !== 'via') only = false; });
    if (!only || !/^[A-Za-z0-9]{5,10}$/.test(c)) return;   // never build a path from anything but a code
    try { window.history.replaceState(window.history.state, '', '/vpp/' + c + location.hash); } catch (e) {}
  })();
  var lead = { fn:null, adr:null, city:null, zip:null };

  function finalizeLead(){
    leadPending = false;
    if (leadCode && CFG.workerBase) embedPost('gs-uploadbill-ready');
    else embedPost('gs-uploadbill-error', { notFound: true });   // no account behind the frame → nothing to upload to
    setTimeout(hideLoading, 4500);   // re-arm the safety now that we're past the account load (reveal even if stats are slow)
    try {
      if (!lead.adr && P.get('h')) {
        lead = Object.assign(lead, JSON.parse(atob(P.get('h').replace(/-/g,'+').replace(/_/g,'/'))));
      }
    } catch(e){}
    ['fn','adr','city','zip'].forEach(function(k){ lead[k] = lead[k] || P.get(k); });
    if (!lead.adr) { lead.adr = '11057 Madrigal St'; lead.city = 'San Diego'; lead.zip = '92129'; }
    lead.fn   = lead.fn   || 'Neighbor';
    lead.city = lead.city || 'San Diego';
    lead.zip  = lead.zip  || '92129';
    initPage();
  }

  if (leadCode && CFG.workerBase) {
    // A real account link: keep the loading veil up and RETRY on any failure (network blip, worker
    // cold-start, transient 5xx, or a freshly-minted code that hasn't propagated to the edge) instead
    // of silently dropping the visitor onto the generic "Neighbor" page. Any 200 = account found.
    leadPending = true;
    var LEAD_MAX = 5, leadAttempt = 0, leadSettled = false;
    var tryLead = function(){
      if (leadSettled) return;
      leadAttempt++;
      var done = false;
      var ac = ('AbortController' in window) ? new AbortController() : null;
      var to = setTimeout(function(){ if (done) return; done = true; if (ac){ try { ac.abort(); } catch (e) {} } leadFail(); }, 6500); // don't abandon a slow-but-working fetch too early
      fetch(CFG.workerBase.replace(/\/$/, '') + '/lead?c=' + encodeURIComponent(leadCode), { cache: 'no-store', signal: ac ? ac.signal : undefined })
        .then(function(r){ if (!r.ok){ var err = new Error('status ' + r.status); err.status = r.status; throw err; } return r.json(); })
        .then(function(d){ if (done || leadSettled) return; done = true; leadSettled = true; clearTimeout(to); lead = Object.assign(lead, d || {}); finalizeLead(); })
        .catch(function(err){ if (done) return; done = true; clearTimeout(to); leadFail(err && err.status); });
    };
    var leadFail = function(status){
      if (leadSettled) return;
      // A 404 is definitive (unknown/expired code) — retrying can't fix it. Allow ONE quick retry to cover a
      // just-minted code still propagating to the edge, then fail fast instead of a ~30s "Verifying…" stall.
      var notFound = status === 404;
      if (leadAttempt < (notFound ? 2 : LEAD_MAX)) setTimeout(tryLead, notFound ? 600 : Math.min(700 * leadAttempt, 2500)); // back off, then retry — veil stays up
      else showLoadError(notFound);                                                       // give up → explicit error, never the dead "Neighbor" CTA
    };
    tryLead();
  } else {
    // No account code → the generic page is the legit default; defer so the rest of the IIFE
    // (satellite refs, slide engine, listeners) is wired before initPage() runs.
    Promise.resolve().then(finalizeLead);
  }

  var fullAddr, displayAddr, utility, rng;

  // Long first names can push the headline to 4 lines (which shoves the stats
  // under the fixed CTA on mobile). Shrink the font until it fits 3 lines.
  function fitHeadline(){
    var h1 = ROOT.querySelector('.gss-h1');
    if (!h1) return;
    h1.style.fontSize = '';
    var lh = parseFloat(getComputedStyle(h1).lineHeight) || 0;
    if (!lh) return;
    var maxH = lh * 3 + 2, guard = 0;
    var size = parseFloat(getComputedStyle(h1).fontSize);
    while (h1.scrollHeight > maxH && size > 16 && guard < 40){
      size -= 1; h1.style.fontSize = size + 'px'; guard++;
    }
  }
  window.addEventListener('resize', function(){ if (typeof fitHeadline === 'function') fitHeadline(); });

  function initPage(){
    fullAddr = [lead.adr, lead.city, 'CA', lead.zip].join(', ');
    displayAddr = lead.adr + ', ' + lead.city;
    utility = deriveUtility(lead.zip);
    rng = seeded(lead.zip + lead.adr);

    ROOT.querySelectorAll('[data-gse="fn"]').forEach(function(el){ el.textContent = lead.fn; });
    ROOT.querySelectorAll('[data-gse="addr"]').forEach(function(el){ el.textContent = displayAddr; });
    ROOT.querySelectorAll('[data-gse="utility"]').forEach(function(el){ el.textContent = utility; });
    try { ROOT.dispatchEvent(new CustomEvent('gse:lead')); } catch (e) {}   // lets late-bound UI (bill examples) react to the utility
    // point the disqualified-screen food-spoilage claim link at the homeowner's own utility
    var dqClaim = document.getElementById('gseDqClaim');
    if (dqClaim){
      // most-direct online claim form per utility (verified 2026-06-18)
      var claimUrls = {
        'PG&E':  'https://claims.ss.pge.com/',
        'SCE':   'https://www.sce.com/apps/cmr',
        'SDG&E': 'https://webformprdsempra.dxc-ins.com/webform/Pagebuilder.aspx?SiteNum=2',
        'LADWP': 'https://www.ladwp.com/account/report-problem/claims-procedure'
      };
      if (claimUrls[utility]) dqClaim.href = claimUrls[utility];
    }
    fitHeadline();

    if (leadCode) {
      var appId = leadCode.toUpperCase();
      var fine = document.getElementById('gssIntroFine');
      if (fine) fine.textContent = 'Application #' + appId + ' · 2 questions · 20 seconds';
      var chip = document.getElementById('gssAppIdChip');
      if (chip) { chip.hidden = false; document.getElementById('gseConfAppId').textContent = '#' + appId; }
    }

    if (gssSim) gssSim.apply(lead);   // the GSTEST / #test simulator overrides what /lead returned
    billUploaded = !!(lead && lead.billUploaded);
    if (lead.appointment && lead.appointment.when) applyBookedState(lead.appointment);
    // Power and Spoilage are mutually exclusive: live-outage homes get the Power tab
    // (with an in-card coordinator claim note); everyone else gets the Spoilage tab.
    if (lead.liveOutage) enableLiveOutage(lead.liveOutage);
    else { var spoilTab = document.getElementById('gseSpoilTab'); if (spoilTab) spoilTab.hidden = false; }

    if (EMBED_BILL){ hideLoading(); return; }   // closer embed: the home screen is never shown, so skip its stats, satellite and insights
    track('page_view', (CLOSER_VIEW || STAFF_VIEW) ? null : { dev: gseDeviceClass() });   // dev: Phone / Tablet / Computer on the dashboard
    initStats();
    initSatellite();
    initInsights();
    // No review booked and no live outage: land on Learn too (Dion 2026-10-10; it was the outage map since 10-07). A
    // booking (future day or today) lands on Learn in applyBookedState, a past review stays on Your home, and a live
    // outage takes Power (enableLiveOutage), all already applied above.
    var booked = !!(lead.appointment && lead.appointment.when), learnTab = document.querySelector('.gss-vtab[data-view="vpp"]');
    if (!booked && !lead.liveOutage && learnTab && typeof gssShowView === 'function') gssShowView('vpp', learnTab);
    // Opening on Learn counts in the dashboard's LEARN column like a tap on the tab (Dion 2026-10-10): one tab_view,
    // which the worker only stamps on the D1 lead row (vpp_at; no GHL tag or field). Only Learn: landing on Your home
    // (a past review) or Power stays uncounted, as before. Not for a coordinator's #claimsubmission look; track() drops
    // everything from the dashboard's #staff anyway, and the closer embed returned above.
    if (learnTab && learnTab.classList.contains('on') && !CLOSER_VIEW) track('tab_view', { view: 'vpp', landed: true });
  }

  // Live outage card: when the contact's outage started today, reveal a "Live"
  // tab (first + default) showing the current status pulled from the grid DB.
  function enableLiveOutage(o){
    if (!o) return;
    var tab = document.getElementById('gseLiveTab'); if (!tab) return;
    var restored = !o.active;
    // Worker only returns liveOutage when the outage started today, so always show
    // the Live tab — active or already restored (no "restored too long ago" hiding).
    var card = document.getElementById('gseLive');
    if (card) card.classList.toggle('gss-live-restored', restored);
    var cust = document.getElementById('gseLiveCustomers');
    if (cust) cust.textContent = Number(o.customers || 0).toLocaleString();
    var head = document.getElementById('gseLiveHeadLabel');
    if (head) head.textContent = restored ? 'Power restored' : 'Live outage';
    var tag = document.getElementById('gseLiveTag');
    if (tag) tag.textContent = restored ? 'Back on' : 'Active';
    var mainL = document.getElementById('gseLiveMainLabel');
    if (mainL) mainL.textContent = restored ? 'homes were affected near you' : 'homes without power near you';
    var note = document.getElementById('gseLiveNote'); if (note) note.hidden = restored;
    setLiveRow('gseLiveCauseRow', 'gseLiveCause', o.cause || null);
    var etrL = document.getElementById('gseLiveEtrLabel');
    if (restored){
      if (etrL) etrL.textContent = 'Restored';
      setLiveRow('gseLiveEtrRow', 'gseLiveEtr', o.restored_time ? fmtLiveTime(o.restored_time) : null);
    } else {
      if (etrL) etrL.textContent = 'Est. restoration';
      setLiveRow('gseLiveEtrRow', 'gseLiveEtr', o.etr ? fmtLiveTime(o.etr) : null);
    }
    setLiveRow('gseLiveStartRow', 'gseLiveStart', o.start_time ? fmtLiveTime(o.start_time) : null);
    // A live-outage visitor is actively without power — lead with the Power card (and its
    // food-spoilage note) so they see it without having to hunt for the tab. (No outage →
    // enableLiveOutage isn't called, so "Your home" stays the default view.)
    tab.hidden = false;
    // Power and Spoilage are mutually exclusive — never show the Spoilage tab alongside Power.
    var spoilTab = document.getElementById('gseSpoilTab'); if (spoilTab) spoilTab.hidden = true;
    if (typeof gssShowView === 'function') gssShowView('live', tab);
  }
  function setLiveRow(rowId, valId, val){
    var row = document.getElementById(rowId), v = document.getElementById(valId);
    if (!row) return;
    if (val){ if (v) v.textContent = val; row.hidden = false; } else { row.hidden = true; }
  }
  function fmtLiveTime(iso){
    try {
      var d = new Date(iso); if (isNaN(d.getTime())) return '';
      var todayPT = new Date().toLocaleDateString('en-CA', { timeZone:'America/Los_Angeles' });
      var dPT = d.toLocaleDateString('en-CA', { timeZone:'America/Los_Angeles' });
      var time = d.toLocaleTimeString('en-US', { hour:'numeric', minute:'2-digit', timeZone:'America/Los_Angeles' });
      return (dPT === todayPT ? 'Today ' : (d.toLocaleDateString('en-US', { weekday:'short', timeZone:'America/Los_Angeles' }) + ' ')) + time;
    } catch(e){ return ''; }
  }
  function relTime(iso){
    try {
      var m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
      if (m < 1) return 'just now';
      if (m < 60) return m + ' min ago';
      var h = Math.round(m / 60);
      if (h < 24) return h + ' hr ago';
      return Math.round(h / 24) + ' d ago';
    } catch(e){ return 'recently'; }
  }

  // Returning visitor who already booked: reframe the intro to show their
  // appointment and turn the CTA into a "Join Meeting" link (no re-running the funnel).
  var bookedAppt = null;
  var pastMode = false;
  var billUploaded = false;   // from lead.billUploaded; flips true after an in-session upload
  var ctaMode = 'join';       // 'join' | 'reqs' — what the primary booked-CTA button does
  var confirmBack = false;    // true when the confirm screen is opened via "Know Before Appointment" → show the back arrow home
  var openBill = null;        // initBill sets this so the booked CTA can open the bill overlay
  var openClaim = null;       // initClaim sets this so the confirm screen can open the spoilage claim
  function applyBookedState(a){
    bookedAppt = a;
    pastMode = !!a.past;
    if (typeof gssPaintLearn === 'function') gssPaintLearn();   // Upload Bill shows for a booked home with no bill on file
    var sub = ROOT.querySelector('.gss-sub');
    var ni = ROOT.querySelector('.gss-noinfo'); if (ni) ni.style.display = 'none';
    var fine = document.getElementById('gssIntroFine'); if (fine) fine.style.display = 'none';

    if (a.past) {
      // Meeting time has passed — neutral "schedule another time" state (no
      // assumptions about whether they attended). Reuses the main CTA.
      if (sub) sub.innerHTML = 'Your review was on <strong>' + a.when + '</strong>' +
        (a.coordinator ? ' with <strong>' + a.coordinator + '</strong>' : '') +
        '. Need to meet again? Pick a new time below.';
      var pmain = ROOT.querySelector('#gssStart .gss-cta-main');
      if (pmain) pmain.innerHTML = 'Schedule another time <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
      var psub = ROOT.querySelector('#gssStart .gss-cta-sub'); if (psub) psub.style.display = 'none';
      return;
    }

    if (sub) sub.innerHTML = 'Your home review is booked for <strong>' + a.when + '</strong>' +
      (a.coordinator ? ' with <strong>' + a.coordinator + '</strong>' : '') +
      '. Join from a computer or tablet — not a phone.';
    var startBtn = document.getElementById('gssStart'); if (startBtn) startBtn.style.display = 'none';
    var split = document.getElementById('gssBookedCta'); if (split) split.hidden = false;
    renderBookedCta();
    // A homeowner with a review booked lands on Learn (Dion, 2026-10-07), and since 2026-10-10 the day of the review
    // does too: Learn then carries the Join Meeting split button under the Tesla link (paintLearn). A live outage still
    // takes over (enableLiveOutage runs after this); a past review returned above and keeps "Your home" with its
    // reschedule button. Switched only now, with the booked copy in place, so paintLearn holds the copy at the height
    // the other tabs really show. The closer embed keeps what it had: no Learn switch for a review today.
    var learnTab = ROOT.querySelector('.gss-vtab[data-view="vpp"]');
    if ((!a.sameDay || !EMBED_BILL) && learnTab && ROOT.querySelector('.gss-vtab[data-view="roof"].on') && typeof gssShowView === 'function') gssShowView('vpp', learnTab);
    else if (typeof gssPaintLearn === 'function') gssPaintLearn();   // already on Learn (the #test switches): re-place the dock
  }

  // Booked CTA, two states: review TODAY → "Join Meeting" (taps the live link); any future day →
  // "Know Before Appointment" (sub = date/time; it read "Requirements" until Dion 2026-10-10, no arrow so it stays on
  // one line beside the caret on a 360 px phone) which opens the full "You're booked" screen. The dropdown always
  // keeps Reschedule/Cancel + "Upload bill" (so a bill can still be sent — including for multiple homes).
  function renderBookedCta(){
    var a = bookedAppt; if (!a || a.past) return;
    var mainEl = ROOT.querySelector('#gssJoinBtn .gss-cta-main');
    var subEl = document.getElementById('gssJoinSub');
    var uploadItem = document.getElementById('gssUploadBill');
    var arrow = ' <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    if (!a.sameDay){
      ctaMode = 'reqs';
      if (mainEl) mainEl.textContent = 'Know Before Appointment';
      if (subEl) subEl.textContent = a.when || '';
    } else {
      ctaMode = 'join';
      if (mainEl) mainEl.innerHTML = 'Join Meeting' + arrow;
      if (subEl) subEl.textContent = a.link ? (a.when || '') : 'Link arrives by text & email';
    }
    if (uploadItem){ uploadItem.style.display = ''; uploadItem.textContent = 'Upload Bill'; }
    var copyItem = document.getElementById('gssCopyLink'); if (copyItem) copyItem.style.display = a.link ? '' : 'none';
  }

  // "Know Before Appointment" → open the full "You're booked" screen (appointment details + the plan-for checklist
  // + Spoilage Claim / Upload Bill actions). This isn't the post-booking terminal state, so the back arrow returns home.
  function showBookedReqs(){
    var a = bookedAppt; if (!a) return;
    var w = document.getElementById('gseConfWhen'); if (w) w.textContent = a.when || '';
    var c = document.getElementById('gseConfCoord'); if (c) c.textContent = a.coordinator || 'Your coordinator';
    var chip = document.getElementById('gssAppIdChip');
    if (chip && leadCode){ var ai = document.getElementById('gseConfAppId'); if (ai) ai.textContent = '#' + leadCode.toUpperCase(); chip.hidden = false; }
    confirmBack = true;
    goTo('confirm');
  }

  /* ---- reschedule / cancel for an already-booked visitor ---- */
  var rescheduleMode = false;
  var rescheduleApptId = null;

  function startReschedule(){
    if (!bookedAppt) return;
    rescheduleMode = true;
    rescheduleApptId = bookedAppt.appointmentId;
    var h = ROOT.querySelector('.gss-slide[data-slide="cal"] .gss-h2');
    if (h) h.textContent = 'Pick a new time for your review';
    var cbw = document.getElementById('gseCallbackWrap'); if (cbw) cbw.hidden = true; // reschedule isn't a new qualification
    buildCalendar();
    goTo('cal');
  }

  var cancelModalEl = document.getElementById('gseCancelModal');
  function openCancelModal(){
    if (!bookedAppt) return;
    var w = document.getElementById('gseCancelWhen'); if (w) w.textContent = bookedAppt.when || '';
    var er = document.getElementById('gseCancelErr'); if (er) er.textContent = '';
    var ca = document.getElementById('gseCancelAnyway'); if (ca){ ca.disabled = false; ca.textContent = 'Cancel anyway'; }
    if (cancelModalEl) cancelModalEl.hidden = false;
  }
  function closeCancelModal(){ if (cancelModalEl) cancelModalEl.hidden = true; }
  if (cancelModalEl) cancelModalEl.addEventListener('click', function(e){ if (e.target === cancelModalEl) closeCancelModal(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && cancelModalEl && !cancelModalEl.hidden) closeCancelModal(); });

  function doCancel(){
    if (!bookedAppt) return;
    var btn = document.getElementById('gseCancelAnyway');
    var er = document.getElementById('gseCancelErr'); if (er) er.textContent = '';
    if (btn){ btn.disabled = true; btn.textContent = 'Cancelling…'; }
    fetch(CFG.workerBase.replace(/\/$/,'') + '/cancel', {
      method:'POST', headers:{'Content-Type':'text/plain'},
      body: JSON.stringify({ c: leadCode, appointmentId: bookedAppt.appointmentId })
    })
    .then(function(r){ return r.json().catch(function(){ return {}; }); })
    .then(function(res){
      if (!res || !res.ok) throw new Error('cancel failed');
      track('appointment_cancelled', { appointmentId: bookedAppt.appointmentId });
      bookedAppt = null;
      location.reload();
    })
    .catch(function(){ if (btn){ btn.disabled = false; btn.textContent = 'Cancel anyway'; } if (er) er.textContent = 'Could not cancel just now — please try again.'; });
  }

  // split-button dropdown (Join Meeting + caret → Reschedule / Cancel)
  var splitEl = document.getElementById('gssBookedCta');
  var menuEl = document.getElementById('gssCtaMenu');
  var toggleEl = document.getElementById('gssCtaToggle');
  function closeCtaMenu(){ if (menuEl) menuEl.hidden = true; if (splitEl) splitEl.classList.remove('open'); if (toggleEl) toggleEl.setAttribute('aria-expanded','false'); }
  function toggleCtaMenu(){ if (!menuEl) return; var willOpen = menuEl.hidden; if (willOpen) collapseMore(); menuEl.hidden = !willOpen; if (splitEl) splitEl.classList.toggle('open', willOpen); if (toggleEl) toggleEl.setAttribute('aria-expanded', willOpen ? 'true' : 'false'); }
  if (toggleEl) toggleEl.addEventListener('click', function(e){ e.stopPropagation(); toggleCtaMenu(); });
  document.addEventListener('click', function(e){ if (menuEl && !menuEl.hidden && splitEl && !splitEl.contains(e.target)) closeCtaMenu(); });

  // Small floating toast that fades itself out after ~2s — used to confirm a copied meeting link.
  function showToast(msg){
    var t = document.createElement('div'); t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:96px;transform:translateX(-50%);z-index:2147483647;background:rgba(18,20,26,.96);color:#fff;font:600 14px/1.2 -apple-system,system-ui,Arial;padding:11px 18px;border-radius:999px;box-shadow:0 12px 30px rgba(0,0,0,.32);opacity:0;transition:opacity .22s ease;pointer-events:none';
    (document.body || ROOT).appendChild(t);
    requestAnimationFrame(function(){ t.style.opacity = '1'; });
    setTimeout(function(){ t.style.opacity = '0'; setTimeout(function(){ if (t.parentNode) t.parentNode.removeChild(t); }, 260); }, 2000);
  }

  // "Copy Meeting Link" menu item — the review must be joined from a computer/tablet, so people often
  // copy the link to open it on another device. Injected here if an older liquid lacks it (idempotent).
  var _copyBtn = document.getElementById('gssCopyLink');
  if (menuEl && !_copyBtn){
    _copyBtn = document.createElement('button'); _copyBtn.type = 'button'; _copyBtn.id = 'gssCopyLink';
    _copyBtn.setAttribute('role', 'menuitem'); _copyBtn.textContent = 'Copy Meeting Link';
    var _ub = document.getElementById('gssUploadBill');                                                 // sit just below Upload Bill
    if (_ub) _ub.insertAdjacentElement('afterend', _copyBtn); else menuEl.insertBefore(_copyBtn, menuEl.firstChild);
  }
  if (_copyBtn) _copyBtn.addEventListener('click', function(e){
    e.stopPropagation();
    closeCtaMenu();                                        // close the dropdown, then confirm with a floating toast
    var link = bookedAppt && bookedAppt.link;
    if (!link){ showToast('Link not ready yet'); return; }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(link).then(function(){ showToast('Copied'); }, function(){ showToast('Copy failed'); }); }
      else { showToast('Copy failed'); }
    } catch (err){ showToast('Copy failed'); }
    try { track('meeting_link_copied', { appointmentId: bookedAppt && bookedAppt.appointmentId }); } catch (e2){}
  });

  // "More Options" gate — keep Reschedule/Cancel out of the default menu so they're a deliberate
  // two-step action (fewer accidental reschedules/cancels), without removing them. Injected if missing.
  var _moBtn = document.getElementById('gssMoreOpts');
  if (menuEl && !_moBtn){
    _moBtn = document.createElement('button'); _moBtn.type = 'button'; _moBtn.id = 'gssMoreOpts';
    _moBtn.setAttribute('role', 'menuitem'); _moBtn.textContent = 'More Options';
    _moBtn.style.borderTop = '1px solid var(--border)';                      // divider above (holds even if the CSS isn't re-uploaded)
    var _rs0 = document.getElementById('gssReschedule');
    if (_rs0) menuEl.insertBefore(_moBtn, _rs0); else menuEl.appendChild(_moBtn);
  }
  function collapseMore(){
    var mo = document.getElementById('gssMoreOpts'), rs = document.getElementById('gssReschedule'), cn = document.getElementById('gssCancel');
    if (mo) mo.style.display = ''; if (rs) rs.style.display = 'none'; if (cn) cn.style.display = 'none';
  }
  function expandMore(){
    var mo = document.getElementById('gssMoreOpts'), rs = document.getElementById('gssReschedule'), cn = document.getElementById('gssCancel');
    if (mo) mo.style.display = 'none'; if (rs) rs.style.display = ''; if (cn) cn.style.display = '';
  }
  if (_moBtn) _moBtn.addEventListener('click', function(e){ e.stopPropagation(); expandMore(); });
  collapseMore();   // start gated

  var _joinBtn = document.getElementById('gssJoinBtn');
  if (_joinBtn) _joinBtn.addEventListener('click', function(){
    if (ctaMode === 'reqs'){ showBookedReqs(); return; }
    // only open the meeting link when the review is actually today — a future-day link isn't live yet
    if (bookedAppt && bookedAppt.sameDay && bookedAppt.link) window.open(bookedAppt.link, '_blank', 'noopener');
  });

  var _resBtn = document.getElementById('gssReschedule');
  if (_resBtn) _resBtn.addEventListener('click', function(){ closeCtaMenu(); startReschedule(); });
  var _resBtn2 = document.getElementById('gseRescheduleInstead');
  if (_resBtn2) _resBtn2.addEventListener('click', function(){ closeCancelModal(); startReschedule(); });
  var _canBtn = document.getElementById('gssCancel');
  if (_canBtn){ _canBtn.textContent = 'Cancel'; _canBtn.addEventListener('click', function(){ closeCtaMenu(); openCancelModal(); }); }
  var _keepBtn = document.getElementById('gseKeepAppt');
  if (_keepBtn) _keepBtn.addEventListener('click', closeCancelModal);
  var _cancelAnyway = document.getElementById('gseCancelAnyway');
  if (_cancelAnyway) _cancelAnyway.addEventListener('click', doCancel);

  function deriveUtility(zip){
    var z = parseInt(String(zip||'').slice(0,3), 10);
    if (!z) return 'your utility';
    if (z >= 919 && z <= 921) return 'SDG&E';
    if (z >= 900 && z <= 918) return (z === 900 || z === 901) ? 'LADWP' : 'SCE';
    if (z >= 922 && z <= 935) return 'SCE';
    if (z >= 936 && z <= 961) return 'PG&E';
    return 'SCE';
  }
  // Tesla's Virtual Power Plant program for the homeowner's utility. LADWP homes are in SCE
  // territory (Dion), and SCE is the default while the zip is unknown.
  function teslaVppUtility(){ return (utility === 'PG&E' || utility === 'SDG&E') ? utility : 'SCE'; }
  var TESLA_VPP_BASE = 'https://www.tesla.com/support/energy/virtual-power-plant/';
  function teslaVppUrl(){
    var slug = { 'PG&E': 'pge', 'SDG&E': 'sdge' }[teslaVppUtility()] || 'sce';
    return TESLA_VPP_BASE + slug;
  }

  /* ============================================================
     GHL TRACKING — identifies the contact by the short code only
  ============================================================ */
  function track(event, data){
    if (EMBED_BILL) return;   // a closer opening the sheet is not a homeowner visit: no elig-clicked tag, no Reviewed stamp, no 'viewed' lead
    if (STAFF_VIEW) return;   // nor is Dion opening a row from the dashboard (#staff): nothing at all is recorded for the homeowner
    if (CLOSER_VIEW && ENGAGE_EVENT.test(event)) return;   // nor is staff watching or clicking: the dashboard's video / VPP / Upload Bill columns are the homeowner's alone
    var payload = Object.assign({
      c: leadCode, event: event, zip: lead.zip, utility: utility,
      page: 'eligibility-check', ts: new Date().toISOString()
    }, data || {});
    var target = CFG.workerBase ? CFG.workerBase.replace(/\/$/, '') + '/track' : CFG.webhook;
    if (target) {
      // Use text/plain so the cross-origin POST stays a CORS "simple request"
      // (no preflight). application/json forces a preflight that sendBeacon
      // drops on some browsers, silently losing the event. The Worker parses
      // the body as JSON regardless of content-type.
      var body = JSON.stringify(payload);
      var sent = false;
      try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(target, new Blob([body], {type:'text/plain'}))); } catch(e){}
      if (!sent) {
        try { fetch(target, {method:'POST', headers:{'Content-Type':'text/plain'}, body: body, keepalive:true}); } catch(e){}
      }
    } else { console.log('[GS track]', payload); }
  }

  /* ---- engagement for the dashboard (D1 only: the worker never turns these into GHL tags or fields) ----
     Devices: page_view carries the device class; the worker checks Phone / Tablet / Computer for every class the
     homeowner ever opens the link on. Tablets first: iPadOS Safari asks for the desktop site by default (a Mac UA,
     but a touch screen), and an Android UA without "Mobile" is a tablet (a folded Fold or any phone sends "Mobile").
     A short screen side under 600 CSS px is a phone that asked for the desktop site. Touch laptops (Windows, Mac,
     Chromebook) stay computers ("Tablet PC" is an old Windows UA token, not a tablet); a touch Linux desktop, rare,
     reads as a tablet (the price of catching Android's desktop-site tablets). */
  function gseDeviceClass(){
    var nav = window.navigator || {}, ua = String(nav.userAgent || ''), tp = nav.maxTouchPoints || 0;
    var sc = window.screen, side = (sc && sc.width && sc.height) ? Math.min(sc.width, sc.height) : 0;
    var small = side > 0 && side < 600;
    if ((nav.platform === 'MacIntel' || /Macintosh/.test(ua)) && tp > 1) return small ? 'phone' : 'tablet';
    if (/iPad|Tablet(?! PC)|PlayBook|Silk|Kindle/.test(ua)) return 'tablet';
    if (/Android/.test(ua) && !/Mobile/.test(ua)) return small ? 'phone' : 'tablet';
    if (/iPhone|iPod|Windows Phone|Mobi/.test(ua)) return 'phone';
    if (nav.userAgentData && nav.userAgentData.mobile === true) return 'phone';
    // Android's own "desktop site" (Chrome's default on 10"+ tablets, or a phone that turned it on): a Linux desktop
    // UA with no "Android" or "Mobile" and userAgentData.mobile false, but a touch screen. Chromebooks send CrOS.
    if (tp > 1 && /\bLinux\b/.test(ua) && !/CrOS/.test(ua)) return small ? 'phone' : 'tablet';
    return 'computer';
  }
  // A coordinator opening the customer's link for #claimsubmission is not the homeowner: page_view still goes out
  // as before, without a device, so the coordinator's computer never checks Computer on the homeowner's row.
  var CLOSER_VIEW = /claimsubmission/i.test(location.hash || '');
  // Nor is Dion opening a lead from the worker's /dashboard: its rows open BASE?c=CODE#staff (the worker's half of
  // this contract). Stricter than CLOSER_VIEW: track() records nothing at all — no page_view, no device, no video or
  // click — so a look from the dashboard never touches the lead's row (views, time on page, devices, engagement).
  var STAFF_VIEW = /(^|#)staff\b/i.test(location.hash || '');
  var ENGAGE_EVENT = /^(?:video_play|video_progress|video_complete|vpp_click|upload_click)$/;
  // "Virtual Power Plant with {utility}": the Learn dock's link (from 'learn') or a Tesla VPP link on the bill sheet
  // (from 'bill'). Capture phase on the document, so nothing on the way can swallow it, and no preventDefault: the
  // link still opens in its new tab while this page sends the beacon. A middle click (auxclick) opens it too.
  function vppClick(e){
    if (e.type === 'auxclick' && e.button !== 1) return;
    var a = e.target, from = null;
    while (a && a.nodeName !== 'A') a = a.parentNode;
    if (!a || String(a.getAttribute('href') || '').indexOf(TESLA_VPP_BASE) !== 0) return;
    for (var el = a; el && el !== document; el = el.parentNode){
      if (el.id === 'gseLearnDock'){ from = 'learn'; break; }
      if (el.id === 'gseBillOv'){ from = 'bill'; break; }
    }
    if (from) track('vpp_click', { utility: teslaVppUtility(), from: from });
  }
  document.addEventListener('click', vppClick, true);
  document.addEventListener('auxclick', vppClick, true);

  /* ============================================================
     SLIDE ENGINE
  ============================================================ */
  var slides = Array.prototype.slice.call(ROOT.querySelectorAll('.gss-slide'));
  var order = ['intro','bill','care','cal','confirm']; // dq replaces tail
  var history = ['intro'];
  // Dion 2026-10-22: the CARE question is asked only after a $150-300 bill answer. The bill answer sets this; while
  // it is on, the care dot is hidden and the counter counts 3 steps. Cleared whenever the questions start over.
  var careSkipped = false;
  var dotsEl = document.getElementById('gssDots');
  var stepNum = document.getElementById('gssStepNum');
  var backBtn = document.getElementById('gssBack');

  for (var i = 0; i < 4; i++){
    var d = document.createElement('span');
    d.className = 'gss-dot' + (i === 0 ? ' on' : '');
    dotsEl.appendChild(d);
  }

  function slideEl(name){ return ROOT.querySelector('.gss-slide[data-slide="' + name + '"]'); }

  function goTo(name, isBack){
    var current = history[history.length - 1];
    if (name === current) return;
    var from = slideEl(current), to = slideEl(name);
    from.classList.remove('active'); from.classList.add('exit');
    setTimeout(function(){ from.classList.remove('exit'); }, 520);
    to.classList.add('active');
    to.scrollTop = 0;

    if (isBack) history.pop(); else history.push(name);

    if (name === 'intro' || name === 'bill') careSkipped = false;   // back at the questions: 4 steps until the bill answer says otherwise
    var skip = careSkipped && name !== 'care';
    var idxMap = skip ? { intro:0, bill:1, cal:2, confirm:2, dq:2 } : { intro:0, bill:1, care:2, cal:3, confirm:3, dq:3 };
    var idx = idxMap[name];
    dotsEl.querySelectorAll('.gss-dot').forEach(function(dot, j){
      var hide = skip && j === 2, step = (skip && j === 3) ? 2 : j;   // care dot (3rd) gone; the 4th dot is then step 3
      dot.style.display = hide ? 'none' : '';
      dot.classList.toggle('on', !hide && step === idx);
      dot.classList.toggle('done', !hide && step < idx);
    });
    stepNum.textContent = (idx + 1) + ' / ' + (skip ? 3 : 4);
    backBtn.hidden = (name === 'intro' || name === 'dq' || (name === 'confirm' && !confirmBack));

    var cta = document.getElementById('gssStart') || ROOT.querySelector('.gss-cta');   // the Learn dock's buttons share the class
    if (cta) cta.classList.toggle('gss-cta-hide', name !== 'intro');
    var splitCta = document.getElementById('gssBookedCta') || ROOT.querySelector('.gss-cta-split');   // by id: on review day it sits in the Learn dock
    if (splitCta) splitCta.classList.toggle('gss-cta-hide', name !== 'intro');
    var noinfo = ROOT.querySelector('.gss-noinfo');
    if (noinfo) noinfo.classList.toggle('gss-cta-hide', name !== 'intro');

    if (name === 'confirm') requestAnimationFrame(setupConfirm);
  }

  backBtn.addEventListener('click', function(){
    if (history.length > 1) goTo(history[history.length - 2], true);
  });

  /* ---- "You're booked" screen: drop the green check, dock a seamless [Spoilage Claim | Upload Bill]
     split CTA at the bottom, and scale the content so it always fits the screen (no scrolling). ---- */
  function setupConfirm(){
    var slide = slideEl('confirm'); if (!slide) return;
    var end = slide.querySelector('.gss-end'); if (!end) return;
    var chk = end.querySelector('.gss-check'); if (chk) chk.style.display = 'none';        // no green check
    var oldCta = end.querySelector('.gss-claim-cta'); if (oldCta) oldCta.style.display = 'none'; // replaced by the dock
    var dock = slide.querySelector('.gssConfDock');
    if (!dock){
      dock = document.createElement('div'); dock.className = 'gssConfDock';
      dock.innerHTML = '<div class="gss-cta-split">' +
        '<button type="button" class="gss-cta-join" id="gseConfSpoil" style="flex:1 1 0;min-width:0;padding:15px 12px;justify-content:center"><span class="gss-cta-main" style="font-size:16px;font-weight:700">Spoilage Claim</span></button>' +
        '<button type="button" class="gss-cta-caret" id="gseConfBill" style="flex:1 1 0;min-width:0;padding:15px 12px;font-size:16px;font-weight:700;white-space:nowrap">Upload Bill</button>' +
        '</div>';
      var sp = dock.querySelector('#gseConfSpoil'); if (sp) sp.addEventListener('click', function(){ if (typeof openClaim === 'function') openClaim(); });
      var bl = dock.querySelector('#gseConfBill'); if (bl) bl.addEventListener('click', function(){ if (typeof openBill === 'function') openBill(); });
    }
    // A bill already on file (Dion 2026-10-10: it showed Upload Bill anyway): no Upload Bill here, Spoilage Claim takes the
    // whole button, as the Learn dock hides its own. Re-run on every visit and after an upload (initBill), so it follows
    // billUploaded. The booked button's caret menu keeps Upload Bill for a second home's bill.
    var billBtn = dock.querySelector('#gseConfBill'), spoilBtn = dock.querySelector('#gseConfSpoil');
    if (billBtn) billBtn.style.display = billUploaded ? 'none' : '';
    if (spoilBtn) spoilBtn.style.borderRadius = billUploaded ? '999px' : '';
    var split = dock.querySelector('.gss-cta-split');
    var h2El = end.querySelector('.gss-h2'), whenEl = end.querySelector('.gss-when');
    var appChip = document.getElementById('gssAppIdChip'), chipsRow = end.querySelector('.gss-chips'), reqsPanel = end.querySelector('.gss-reqs');
    // The plan-for list's last line asks "Have a recent {utility} bill handy or upload it." — with a bill on file that asks
    // for one we have, so it reads "We already have your {utility} bill." (the utility span untouched; back to the
    // liquid's words without one). An unreadable zip leaves the span "your utility": then "We already have your utility
    // bill.", not "your your". Only a line in one of these exact shapes is touched; any other liquid is left alone.
    if (reqsPanel) reqsPanel.querySelectorAll('[data-gse="utility"]').forEach(function(u){
      var pre = u.previousSibling, post = u.nextSibling;
      if (!pre || !post || pre.nodeType !== 3 || post.nodeType !== 3) return;
      var ASK0 = 'Have a recent ', ASK1 = ' bill handy or upload it.', HAVE1 = ' bill.';
      var pd = pre.data, qd = post.data, ends = function(s, t){ return s.length >= t.length && s.lastIndexOf(t) === s.length - t.length; };
      var p0 = ends(pd, ASK0) ? ASK0 : ends(pd, 'We already have your ') ? 'We already have your ' : ends(pd, 'We already have ') ? 'We already have ' : null;
      var p1 = qd.indexOf(ASK1) === 0 ? ASK1 : qd.indexOf(HAVE1) === 0 ? HAVE1 : null;
      if (!p0 || !p1 || (p0 === ASK0) !== (p1 === ASK1)) return;
      var to0 = !billUploaded ? ASK0 : /^your /i.test(u.textContent || '') ? 'We already have ' : 'We already have your ';
      pre.data = pd.slice(0, pd.length - p0.length) + to0; post.data = (billUploaded ? HAVE1 : ASK1) + qd.slice(p1.length);
    });
    slide.style.justifyContent = 'center'; slide.style.overflow = 'hidden';
    var wide = (window.innerWidth || document.documentElement.clientWidth || 0) > 820;
    if (wide){
      // Desktop: centered; the split CTA flows directly beneath the requirements panel (not stranded
      // at the bottom), and the whole block scales UP to fill the roomy viewport.
      slide.style.alignItems = 'center';
      if (h2El) h2El.style.fontSize = ''; if (whenEl) whenEl.style.fontSize = '';
      // app pill lives in the chips row up top
      if (appChip && chipsRow){ appChip.style.display = ''; appChip.style.marginTop = ''; if (chipsRow.firstChild !== appChip) chipsRow.insertBefore(appChip, chipsRow.firstChild); }
      if (split) split.style.cssText = 'position:relative;left:auto;right:auto;bottom:auto;min-width:0;width:100%;max-width:460px';
      dock.style.cssText = 'display:flex;justify-content:center;margin-top:24px';
      if (dock.parentNode !== end) end.appendChild(dock);
      slide.style.paddingBottom = '';
    } else {
      // Mobile: top-align so the heading + date sit up near the top (not floated to the middle) and
      // bump their size; dock the split CTA at the very bottom; content scales DOWN only if it overflows.
      slide.style.alignItems = 'flex-start';
      if (h2El) h2El.style.fontSize = 'clamp(25px,7vw,33px)';
      if (whenEl) whenEl.style.fontSize = 'clamp(17px,5vw,21px)';
      // app pill drops below the requirements panel, centered, just above the docked CTA
      if (appChip && !appChip.hidden && reqsPanel){ appChip.style.display = 'inline-block'; appChip.style.marginTop = '18px'; if (appChip.previousElementSibling !== reqsPanel) reqsPanel.insertAdjacentElement('afterend', appChip); }
      if (split) split.style.cssText = 'position:relative;left:auto;right:auto;bottom:auto;min-width:0;width:100%;max-width:440px';
      dock.style.cssText = 'position:absolute;left:0;right:0;bottom:calc(16px + env(safe-area-inset-bottom));display:flex;justify-content:center;padding:0 18px;z-index:6';
      if (dock.parentNode !== slide) slide.appendChild(dock);
      slide.style.paddingBottom = (dock.offsetHeight + 26) + 'px';
    }
    fitConfirm(slide, end, wide);
  }
  function fitConfirm(slide, end, allowUp){
    end.style.transform = ''; end.style.transformOrigin = allowUp ? 'center center' : 'top center';
    var cs = getComputedStyle(slide);
    var availH = slide.clientHeight - (parseFloat(cs.paddingTop) || 0) - (parseFloat(cs.paddingBottom) || 0);
    var availW = slide.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    var needH = end.scrollHeight, needW = end.offsetWidth || needH;
    if (availH <= 80 || !needH) return;
    var s;
    if (allowUp) s = Math.max(0.6, Math.min((availH / needH) * 0.92, (availW / needW) * 0.98, 1.5)); // desktop: grow to fill, cap 1.5×, never overflow either axis
    else s = needH > availH ? Math.max(0.6, availH / needH) : 1;                                     // mobile: shrink only
    if (Math.abs(s - 1) > 0.01) end.style.transform = 'scale(' + s.toFixed(3) + ')';
  }
  window.addEventListener('resize', function(){ var c = slideEl('confirm'); if (c && c.classList.contains('active')) setupConfirm(); });

  /* ---- TEST MODE (#test or ?test=1): stub every WRITE to the worker — no real bookings, uploads,
     reschedules/cancels, or GHL field writes — and add a quick-jump toolbar so every screen can be
     exercised safely. Reads (/lead, /slots) stay live. Inert unless the flag is present. ---- */
  var TEST_MODE = /(?:^|[#&?/])test\b/i.test(location.hash) || P.get('test') != null || EMB.test === true;
  if (TEST_MODE){
    var _realFetch = window.fetch.bind(window);
    var STUBS = [
      [/\/book(\?|$)/,           function(){ return { ok:true, appointmentId:'TEST-' + Date.now(), assignedUserId:'test', coordinator:'Test Coordinator' }; }],
      [/\/track(\?|$)/,          function(){ return { ok:true }; }],
      [/\/bill(\?|$)/,           function(body){ var n=1; try{ n=(JSON.parse(body).files||[]).length||1; }catch(e){} return { ok:true, count:n, attached:true }; }],
      [/\/claim\/analyze(\?|$)/, function(){ return { ok:true, items:[{description:'Reduced Fat Milk',brand:'',qty:'1 gallon',replacement_cost:4.99},{description:'Frozen Pizza',brand:'',qty:'2',replacement_cost:7.5}] }; }],
      [/\/claim\/confirm(\?|$)/, function(){ return { ok:true }; }],
      [/\/cancel(\?|$)/,         function(){ return { ok:true }; }],
      [/\/reschedule(\?|$)/,     function(){ return { ok:true }; }]
    ];
    window.fetch = function(u, opts){
      var url = String((u && u.url) || u);
      for (var i=0;i<STUBS.length;i++){ if (STUBS[i][0].test(url)){ var data = STUBS[i][1](opts && opts.body); try{ console.log('[TEST] stubbed', url, data); }catch(e){} return Promise.resolve(new Response(JSON.stringify(data), { status:200, headers:{'Content-Type':'application/json'} })); } }
      return _realFetch(u, opts);
    };
    var fakeAppt = { when:'Wednesday, June 25 · 2 PM PT', start:'2026-06-25 14:00:00', sameDay:false, link:'https://example.com/meet', coordinator:'Test Coordinator', appointmentId:'TEST-1234', past:false };
    function jumpConfirm(){
      var w=document.getElementById('gseConfWhen'); if(w) w.textContent=fakeAppt.when;
      var c=document.getElementById('gseConfCoord'); if(c) c.textContent=fakeAppt.coordinator;
      var ap=document.getElementById('gseConfAppId'); if(ap) ap.textContent='#TEST-1234';
      var chip=document.getElementById('gssAppIdChip'); if(chip) chip.hidden=false;
      goTo('confirm');
    }
    var OPTS = [
      ['Booked screen', jumpConfirm],
      ['Booked CTA · future', function(){ billUploaded=false; applyBookedState(fakeAppt); goTo('intro'); }],
      ['Booked CTA · today', function(){ billUploaded=false; applyBookedState(Object.assign({},fakeAppt,{sameDay:true})); goTo('intro'); }],
      ['Bill upload', function(){ if(typeof openBill==='function') openBill(); }],
      ['Spoilage claim', function(){ if(typeof openClaim==='function') openClaim(); }],
      ['Disqualified', function(){ goTo('dq'); }]
    ];
    var tPill=document.createElement('button'); tPill.type='button'; tPill.textContent='🧪 Test ▾';
    tPill.style.cssText='align-self:center;background:#34c759;color:#04210f;border:0;border-radius:999px;padding:6px 11px;font:800 11.5px/1 -apple-system,system-ui,Arial;cursor:pointer;white-space:nowrap;margin-left:6px';
    var tMenu=document.createElement('div');
    tMenu.style.cssText='display:none;position:fixed;z-index:2147483647;min-width:160px;background:#15171f;border:1px solid #2c313f;border-radius:11px;padding:5px;box-shadow:0 14px 34px rgba(0,0,0,.5)';
    OPTS.forEach(function(it){ var b=document.createElement('button'); b.type='button'; b.textContent=it[0]; b.style.cssText='display:block;width:100%;text-align:left;background:none;border:0;border-radius:7px;padding:8px 11px;font:600 12.5px/1 -apple-system,system-ui,Arial;color:#e8e9ed;cursor:pointer;white-space:nowrap'; b.addEventListener('mouseenter',function(){ b.style.background='#1d2130'; }); b.addEventListener('mouseleave',function(){ b.style.background='none'; }); b.addEventListener('click', function(e){ e.preventDefault(); tMenu.style.display='none'; it[1](); }); tMenu.appendChild(b); });
    tPill.addEventListener('click', function(e){ e.stopPropagation(); if(tMenu.style.display==='block'){ tMenu.style.display='none'; return; } var r=tPill.getBoundingClientRect(); tMenu.style.left=Math.round(r.left)+'px'; tMenu.style.top=Math.round(r.bottom+6)+'px'; tMenu.style.display='block'; });
    document.addEventListener('click', function(){ tMenu.style.display='none'; });
    tMenu.addEventListener('click', function(e){ e.stopPropagation(); });
    var chromeLeft = ROOT.querySelector('.gss-chrome-left');
    if (chromeLeft){ chromeLeft.appendChild(tPill); var tBrand=ROOT.querySelector('.gss-brand'); if(tBrand) tBrand.style.display='none'; }  // brand is centered-absolute → hide it so the pill doesn't overlap
    else { tPill.style.position='fixed'; tPill.style.left='8px'; tPill.style.top='8px'; tPill.style.zIndex='2147483647'; (document.body||ROOT).appendChild(tPill); }
    (document.body||ROOT).appendChild(tMenu);
  }

  /* ---- SIMULATOR (the GSTEST link, or any link with #test): a "Simulate" pill at the top right opens
     a drawer of switches that override what /lead returned (booking, bill on file, live outage, night
     theme). A change saves and reloads, so the whole page behaves as if that were the real state;
     "Clear" puts it back to the real contact. Saved per code in localStorage. ---- */
  var gssSim = null;
  (function initSimulator(){
    var code = String(leadCode || '').toUpperCase();
    if (code !== 'GSTEST' && !TEST_MODE) return;
    var KEY = 'gseSim:' + (code || 'none'), state = {};
    try { state = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { state = {}; }
    if (state.learn === 'video') delete state.learn;   // the old test switch: the video is now what everyone sees
    var GROUPS = [
      { key: 'appt',   label: 'Appointment',  opts: [['future', 'Booked, a future day'], ['today', 'Booked for today'], ['past', 'Review already happened']] },
      { key: 'bill',   label: 'Bill on file', hint: 'Upload Bill shows on Learn only with a booking and no bill.', opts: [['yes', 'Bill uploaded'], ['no', 'No bill yet']] },
      { key: 'outage', label: 'Live outage',  opts: [['active', 'Outage right now'], ['restored', 'Power just restored']] },
      { key: 'theme',  label: 'Look',         opts: [['dark', 'Night theme']] },
      { key: 'learn',  label: 'Learn tab',    hint: 'Customers see the video.', opts: [['text', 'Text version instead of the video']] }
    ];
    var pad = function(n){ return (n < 10 ? '0' : '') + n; };
    var whenText = function(d, today){
      var h = d.getHours(), hh = ((h + 11) % 12) + 1, ap = h < 12 ? 'AM' : 'PM';
      var day = today ? 'Today' : d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
      return day + ' · ' + hh + ' ' + ap + ' PT';
    };
    function apply(lead){
      var now = new Date();
      if (state.appt){
        var d = new Date(now);
        if (state.appt === 'future') d.setDate(d.getDate() + 1);
        if (state.appt === 'past') d.setDate(d.getDate() - 1);
        d.setHours(14, 0, 0, 0);
        lead.appointment = { when: whenText(d, state.appt === 'today'), start: d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' 14:00:00',
          sameDay: state.appt === 'today', past: state.appt === 'past', link: 'https://example.com/meet', coordinator: 'Test Coordinator', appointmentId: 'TEST-1234' };
      }
      if (state.bill) lead.billUploaded = state.bill === 'yes';
      if (state.outage){
        var h = 3600e3;
        lead.liveOutage = state.outage === 'active'
          ? { active: true, customers: 1240, cause: 'Equipment failure', etr: new Date(now.getTime() + 3 * h).toISOString(), start_time: new Date(now.getTime() - h).toISOString() }
          : { active: false, customers: 980, restored_time: new Date(now.getTime() - 20 * 60e3).toISOString(), start_time: new Date(now.getTime() - 2 * h).toISOString() };
      }
      if (state.theme === 'dark') ROOT.classList.add('gse-dark');
    }
    gssSim = { apply: apply, state: state };
    var count = GROUPS.filter(function(g){ return state[g.key]; }).length;
    var css = document.createElement('style');
    css.textContent =
      '#gseSimBtn{position:fixed;z-index:2147483000;display:inline-flex;align-items:center;gap:6px;background:#34c759;color:#04210f;border:0;border-radius:999px;padding:7px 12px;font:800 12px/1 -apple-system,system-ui,Arial;cursor:pointer;white-space:nowrap;box-shadow:0 6px 18px rgba(0,0,0,.18)}' +
      '#gseSimBtn b{background:#04210f;color:#34c759;border-radius:999px;padding:2px 6px;font-size:10.5px}' +
      '#gseSimDim{position:fixed;inset:0;z-index:2147483001;background:rgba(0,0,0,.35);opacity:0;pointer-events:none;transition:opacity .2s}' +
      '#gseSimDim.on{opacity:1;pointer-events:auto}' +
      '#gseSim{position:fixed;top:0;right:0;bottom:0;z-index:2147483002;width:min(330px,88vw);background:var(--card-solid,#fff);color:var(--text,#1d1d1f);box-shadow:-12px 0 40px rgba(0,0,0,.25);transform:translateX(102%);transition:transform .25s;display:flex;flex-direction:column;padding:calc(16px + env(safe-area-inset-top)) 18px calc(16px + env(safe-area-inset-bottom));font:14px/1.35 -apple-system,system-ui,Arial;overflow-y:auto}' +
      '#gseSim.on{transform:none}' +
      '#gseSim h3{margin:0 0 4px;font-size:17px;font-weight:800;display:flex;align-items:center;justify-content:space-between}' +
      '#gseSim h3 button{background:none;border:0;font-size:24px;line-height:1;color:inherit;cursor:pointer;padding:0 2px}' +
      '#gseSim .gss-sim-sub{font-size:12px;color:var(--text-2,#6e6e73);margin:0 0 14px}' +
      '#gseSim .gss-sim-g{margin:0 0 14px;padding:0 0 12px;border-bottom:1px solid var(--border,rgba(0,0,0,.08))}' +
      '#gseSim .gss-sim-g b{display:block;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:var(--text-3,#8e8e93);margin:0 0 6px}' +
      '#gseSim label{display:flex;align-items:center;gap:10px;padding:7px 0;cursor:pointer;font-weight:600}' +
      '#gseSim label input{width:20px;height:20px;accent-color:#34c759;margin:0;flex:0 0 auto}' +
      '#gseSim .gss-sim-real{font-weight:500;color:var(--text-2,#6e6e73)}' +
      '#gseSim .gss-sim-foot{margin-top:auto;display:flex;gap:8px;padding-top:12px}' +
      '#gseSim .gss-sim-foot button{flex:1 1 0;font:700 13px/1 -apple-system,system-ui,Arial;border-radius:999px;padding:12px 10px;cursor:pointer;border:1.5px solid var(--border-strong,rgba(0,0,0,.18));background:transparent;color:inherit}' +
      '#gseSim .gss-sim-foot button.pri{background:var(--accent,#1d1d1f);color:var(--accent-text,#fff);border-color:transparent}';
    document.head.appendChild(css);
    var btn = document.createElement('button'); btn.type = 'button'; btn.id = 'gseSimBtn';
    btn.innerHTML = 'Simulate ▾' + (count ? ' <b>' + count + '</b>' : '');
    var dim = document.createElement('div'); dim.id = 'gseSimDim';
    var panel = document.createElement('div'); panel.id = 'gseSim'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'Simulate');
    var html = '<h3>Simulate <button type="button" id="gseSimClose" aria-label="Close">&times;</button></h3>' +
      '<p class="gss-sim-sub">Test link ' + (code || '#test') + '. Pick what the page should believe; it reloads with that state.</p>';
    GROUPS.forEach(function(g){
      html += '<div class="gss-sim-g"><b>' + g.label + '</b>' + (g.hint ? '<p class="gss-sim-sub">' + g.hint + '</p>' : '');
      html += '<label><input type="checkbox" data-g="' + g.key + '" value=""' + (!state[g.key] ? ' checked' : '') + '><span class="gss-sim-real">Real (whatever GHL says)</span></label>';
      g.opts.forEach(function(o){ html += '<label><input type="checkbox" data-g="' + g.key + '" value="' + o[0] + '"' + (state[g.key] === o[0] ? ' checked' : '') + '><span>' + o[1] + '</span></label>'; });
      html += '</div>';
    });
    html += '<div class="gss-sim-foot"><button type="button" id="gseSimClear">Clear all</button><button type="button" class="pri" id="gseSimReload">Reload</button></div>';
    panel.innerHTML = html;
    ROOT.appendChild(dim); ROOT.appendChild(panel);
    var brand = ROOT.querySelector('.gss-brand'); if (brand) brand.style.display = 'none';   // the centered brand would sit under the pill on a phone
    // The pill flows inside the header row, right before the "1 / 4" counter (a fixed pill drifted on iPhones).
    var stepnum = ROOT.querySelector('.gss-stepnum');
    if (stepnum && stepnum.parentNode){ btn.style.position = 'static'; btn.style.marginLeft = 'auto'; btn.style.marginRight = '10px'; stepnum.parentNode.insertBefore(btn, stepnum); }
    else { btn.style.top = '10px'; btn.style.right = '12px'; ROOT.appendChild(btn); }
    var open = function(on){ panel.classList.toggle('on', on); dim.classList.toggle('on', on); };
    btn.addEventListener('click', function(){ open(!panel.classList.contains('on')); });
    dim.addEventListener('click', function(){ open(false); });
    document.getElementById('gseSimClose').addEventListener('click', function(){ open(false); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && panel.classList.contains('on')) open(false); });
    var save = function(){ try { if (Object.keys(state).length) localStorage.setItem(KEY, JSON.stringify(state)); else localStorage.removeItem(KEY); } catch (e) {} };
    var reload = function(){ btn.innerHTML = 'Reloading…'; location.reload(); };
    panel.addEventListener('change', function(e){
      var inp = e.target; if (!inp || inp.type !== 'checkbox') return;
      var g = inp.getAttribute('data-g'), v = inp.value;
      // one choice per group: ticking one clears the others ("Real" = no override)
      panel.querySelectorAll('input[data-g="' + g + '"]').forEach(function(x){ x.checked = (x === inp); });
      if (!inp.checked){ inp.checked = true; }
      if (v) state[g] = v; else delete state[g];
      save(); setTimeout(reload, 150);
    });
    document.getElementById('gseSimClear').addEventListener('click', function(){ state = {}; save(); reload(); });
    document.getElementById('gseSimReload').addEventListener('click', reload);
  })();

  // Disqualified by a mis-tap? Let them jump back to the questions and re-answer.
  var dqBackBtn = document.getElementById('gseDqBack');
  if (dqBackBtn) dqBackBtn.addEventListener('click', function(){
    goTo('bill', true);          // exits the dq slide (current === 'dq')
    history = ['intro', 'bill']; // normalize so forward nav from bill stays clean
  });

  /* ---- food-spoilage claim prep overlay (opens from Power/Spoilage "Prepare" or after booking) ---- */
  (function initClaim(){
    var ov = document.getElementById('gseClaimOv'); if (!ov) return;
    var photos = [], items = [], appendMode = false, haulDate = '', dirty = false, confirmed = false;
    // dock the add-row inside the footer so it's always visible (idempotent — also relocates older markup that nested it in the scroll area)
    (function(){ var f = ov.querySelector('.gss-claim-foot'), a = ov.querySelector('.gss-claim-addrow'); if (f && a && a.parentNode !== f) f.insertBefore(a, f.firstChild); })();
    // express-claim framing (robust: applies even if the liquid copy wasn't re-pasted)
    (function(){
      var capEl = ov.querySelector('[data-claimstep="cap"]'); if (!capEl) return;
      var eb = capEl.querySelector('.gss-claim-eyebrow'); if (eb) eb.textContent = 'EXPRESS SPOILAGE CLAIM';
      if (!document.getElementById('gseClaimExpress')){
        var sub = capEl.querySelector('.gss-claim-sub');
        var ex = document.createElement('div'); ex.className = 'gss-claim-express'; ex.id = 'gseClaimExpress'; ex.innerHTML = '<span></span>';
        if (sub && sub.parentNode) sub.parentNode.insertBefore(ex, sub.nextSibling); else capEl.appendChild(ex);
      }
    })();
    // The $150 guarantee (Dion 2026-10-13): shown once the claim is authorized, on the "Your claim list is ready" screen
    // under its note and above Done (first it sat under the Authorize button; Dion moved it here). Built here (no liquid
    // change); the utility is written in each time that screen shows, so it is the homeowner's own once /lead answered.
    var guarEl = document.getElementById('gseClaimGuar');
    (function(){
      var dn = ov.querySelector('[data-claimstep="done"]'); if (guarEl || !dn) return;
      var doneBtn = document.getElementById('gseClaimDone');
      guarEl = document.createElement('p'); guarEl.className = 'gss-claim-guar'; guarEl.id = 'gseClaimGuar';
      if (doneBtn && doneBtn.parentNode === dn) dn.insertBefore(guarEl, doneBtn); else dn.appendChild(guarEl);
    })();
    function paintGuar(){ if (guarEl) guarEl.textContent = '$150 guaranteed by Grid Stability if ' + (utility || 'your utility') + ' denies your claim, after your VPP enrollment.'; }
    function setExpress(daysLeft){ var e = document.getElementById('gseClaimExpress'); if (!e) return; var s = e.querySelector('span') || e; s.textContent = (typeof daysLeft === 'number' && daysLeft >= 0 && daysLeft < 7) ? ('Express claim — ' + daysLeft + (daysLeft === 1 ? ' day' : ' days') + ' left to submit') : 'Express claim — available for 7 days'; }
    setExpress();
    function show(step){ ['cap', 'proc', 'rev', 'done'].forEach(function(s){ var el = ov.querySelector('[data-claimstep="' + s + '"]'); if (el) el.hidden = (s !== step); }); ov.classList.toggle('gss-on-rev', step === 'rev'); ov.classList.toggle('gss-on-done', step === 'done'); if (step !== 'rev') claimErr(''); if (step === 'rev') recalc(); if (step === 'done'){ paintGuar(); renderClaimDone(); focusDone(); } }

    /* "Claim authorized" (the done step), Dion 2026-10-13: "i like the receipt look with the way the other bottom and top
       section look". TOP: the green check inline with "Claim authorized" and one line on what happens next (their coordinator,
       their utility, their review time). MIDDLE: the claim as a torn paper receipt (biggest items first, qty in grey, dotted
       leaders, "+ N more items", the total). BOTTOM: "{Utility} has the right to deny claims" over the $150 guarantee (#gseClaimGuar MOVED in), the SAME
       #gseClaimDone (its close handler is attached by id) and a quiet "Edit list". Built once, inside #gseClaimOv only (the bill
       sheet's done step shares data-claimstep="done" and is left alone). How many receipt lines show is decided by MEASURING
       the real layout (fold lines into "+ N more" until the sheet fits without scrolling), again on every resize. */
    var cd = null, authAt = null, CD_CAP = 8;
    var CD_MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], CD_DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    function cdEl(tag, cls, txt){ var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
    function buildClaimDone(){
      if (cd) return cd;
      var dn = ov.querySelector('[data-claimstep="done"]'), doneBtn = document.getElementById('gseClaimDone'); if (!dn) return null;
      Array.prototype.slice.call(dn.children).forEach(function(c){ if (c !== doneBtn && c !== guarEl) dn.removeChild(c); });   // the old check, title and note
      dn.classList.add('gss-cd');
      var main = cdEl('div', 'gss-cd-main');
      // top: the check inline with the title, then what happens next
      var head = cdEl('div', 'gss-cd-head');
      var h = cdEl('h2', 'gss-cd-h'); h.setAttribute('tabindex', '-1');
      var tick = cdEl('span', 'gss-cd-tick'); tick.setAttribute('aria-hidden', 'true');
      tick.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>';
      h.appendChild(tick); h.appendChild(document.createTextNode('Claim authorized'));
      var next = cdEl('p', 'gss-cd-next');
      head.appendChild(h); head.appendChild(next);
      // middle: the receipt (torn top and bottom edges are drawn by the stylesheet)
      var rc = cdEl('div', 'gss-cd-rc'); rc.setAttribute('role', 'group'); rc.setAttribute('aria-label', 'Your claim');
      var top = cdEl('div', 'gss-cd-top');
      var who = cdEl('span', 'gss-cd-who'), date = cdEl('span', 'gss-cd-date');
      top.appendChild(who); top.appendChild(document.createTextNode(' ')); top.appendChild(date);
      var haul = cdEl('div', 'gss-cd-haul');
      var lines = cdEl('ul', 'gss-cd-lines'); lines.setAttribute('aria-label', 'Claimed items');
      var tot = cdEl('div', 'gss-cd-tot');
      var totL = cdEl('span', 'gss-cd-totl'); totL.appendChild(cdEl('b', null, 'Total'));
      var count = cdEl('span', 'gss-cd-count'); totL.appendChild(document.createTextNode(' ')); totL.appendChild(count);
      var total = cdEl('span', 'gss-cd-totv');
      tot.appendChild(totL); tot.appendChild(document.createTextNode(' ')); tot.appendChild(total);
      rc.appendChild(top); rc.appendChild(haul); rc.appendChild(lines); rc.appendChild(tot);
      // bottom: the safety net, then the way out
      var net = cdEl('div', 'gss-cd-net'), shield = cdEl('span', 'gss-cd-shield'), nb = cdEl('div', 'gss-cd-netbody');
      shield.setAttribute('aria-hidden', 'true');
      shield.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 3 4.5 6v5.5c0 4.6 3.1 8.3 7.5 9.5 4.4-1.2 7.5-4.9 7.5-9.5V6z"/><path d="m8.8 12.2 2.3 2.3 4.3-4.6"/></svg>';
      var neth = cdEl('div', 'gss-cd-neth'); nb.appendChild(neth);   // "{Utility} has the right to deny claims" (renderClaimDone)
      if (guarEl) nb.appendChild(guarEl);
      net.appendChild(shield); net.appendChild(nb);
      main.appendChild(head); main.appendChild(rc); main.appendChild(net);
      var dock = cdEl('div', 'gss-cd-dock');
      if (doneBtn) dock.appendChild(doneBtn);
      var edit = cdEl('button', 'gss-cd-edit', 'Edit list'); edit.type = 'button'; edit.id = 'gseClaimEditList';
      edit.addEventListener('click', function(){ show('rev'); });
      dock.appendChild(edit);
      dn.appendChild(main); dn.appendChild(dock);
      cd = { dn: dn, h: h, next: next, rc: rc, who: who, date: date, haul: haul, lines: lines, count: count, total: total, neth: neth, list: [], name: '' };
      return cd;
    }
    function cdCents(n){ return Math.round((Number(n) || 0) * 100); }
    function cdMoney(c){ return money(c / 100); }
    function renderClaimDone(){
      var c = buildClaimDone(); if (!c) return;
      var util = utility || 'your utility';
      // the box over the $150 guarantee says plainly that the utility may say no (Dion 2026-10-13; it was "Your safety net")
      if (c.neth) c.neth.textContent = util.charAt(0).toUpperCase() + util.slice(1) + ' has the right to deny claims';
      // what happens next (who files it, with whom, and when, if the review is booked and still ahead)
      var a = bookedAppt, who = (a && a.coordinator && !/coordinator/i.test(a.coordinator)) ? String(a.coordinator).trim() : 'Your coordinator';
      c.next.textContent = '';
      if (a && a.when && !a.past){   // the date and time stay on one line
        c.next.appendChild(document.createTextNode(who + ' files it with ' + util + ' at your review, '));
        c.next.appendChild(cdEl('span', 'gss-cd-when', String(a.when)));
        c.next.appendChild(document.createTextNode('. Until then, just keep your photos as proof.'));
      } else c.next.textContent = who + ' files it with ' + util + ' at your review. Until then, just keep your photos as proof.';
      // the receipt head: whose claim, the moment it was authorized, the grocery run it covers
      var fn = String((typeof lead !== 'undefined' && lead && lead.fn) || '').trim(); if (/^neighbor$/i.test(fn)) fn = '';   // the page's no-name placeholder
      c.name = fn ? fn + '’s spoilage claim' : '';
      var at = authAt || new Date(); c.date.textContent = CD_MON[at.getMonth()] + ' ' + at.getDate();
      var hm = /^(\d{4})-(\d{2})-(\d{2})$/.exec(haulDate || ''), hd = hm ? new Date(+hm[1], +hm[2] - 1, +hm[3]) : null;
      c.haul.textContent = hd ? 'Groceries from ' + CD_DOW[hd.getDay()] + ', ' + CD_MON[hd.getMonth()] + ' ' + hd.getDate() : '';
      c.haul.hidden = !hd;
      // the lines: every listed item, most valuable first (ties keep the list order); money in cents so sums are exact
      var list = [];
      items.forEach(function(it, i){
        if (!it) return;
        var nm = String(it.description || '').trim(), v = cdCents(it.replacement_cost);
        if (!nm && !v) return;   // an empty row the homeowner added and never filled
        list.push({ name: nm || 'Item', qty: String(it.qty || '').trim(), v: v, i: i });
      });
      list.sort(function(x, y){ return (y.v - x.v) || (x.i - y.i); });
      c.list = list;
      c.count.textContent = list.length + (list.length === 1 ? ' item' : ' items');
      c.total.textContent = cdMoney(list.reduce(function(s, x){ return s + x.v; }, 0));
      fitClaimDone();
    }
    // paint the first k lines (and "+ N more items" for the rest)
    function cdPaint(k){
      var c = cd, list = c.list; c.lines.innerHTML = '';
      function line(name, qty, price, more){
        var li = cdEl('li', 'gss-cd-line' + (more ? ' gss-cd-more' : ''));
        var nm = cdEl('span', 'gss-cd-name', name); if (!more) nm.title = name;
        li.appendChild(nm);
        if (qty){ li.appendChild(document.createTextNode(' ')); li.appendChild(cdEl('span', 'gss-cd-qty', qty)); }
        var dots = cdEl('span', 'gss-cd-dots'); dots.setAttribute('aria-hidden', 'true'); li.appendChild(dots);
        li.appendChild(document.createTextNode(' '));
        li.appendChild(cdEl('span', 'gss-cd-price', price));
        c.lines.appendChild(li);
      }
      for (var i = 0; i < k && i < list.length; i++) line(list[i].name, list[i].qty, cdMoney(list[i].v), false);
      var rest = list.slice(k);
      if (rest.length) line('+ ' + rest.length + (rest.length === 1 ? ' more item' : ' more items'), '', cdMoney(rest.reduce(function(s, x){ return s + x.v; }, 0)), true);
      if (!list.length) line('No items listed', '', cdMoney(0), true);
    }
    // the line counts to try, most first: all of them up to the cap, then fold (never fold a single item: "+ 1 more" costs the same line)
    function cdCounts(n){
      var ks = [], k0 = n <= CD_CAP ? n : CD_CAP - 1; ks.push(k0);
      for (var k = Math.min(k0 - 1, n - 2); k >= 1; k--) ks.push(k);
      return ks;
    }
    function fitClaimDone(){
      var c = cd; if (!c) return;
      var ks = cdCounts(c.list.length), card = ov.querySelector('.gss-claim-card');
      c.who.textContent = c.name || 'Spoilage claim';
      var live = !ov.hidden && !c.dn.hidden && card && card.clientHeight > 0;
      var TIGHT = ['gss-cd-t1', 'gss-cd-t2', 'gss-cd-t3'];
      var mode = function(n){ TIGHT.forEach(function(t, i){ ov.classList.toggle(t, i < n); }); };
      if (!live){ mode(0); cdPaint(ks[0]); return; }   // no layout (hidden, or no renderer): the default
      var over = function(){ return card.scrollHeight > card.clientHeight; };
      // spacing modes, roomiest first (each tighter one marks the sheet: t1, then t2 = no grocery-run line, then
      // t3 = the tightest phone layout); take the first that shows at least 3 lines (or all of a short list)
      var want = Math.min(3, ks[0]), pick = null;
      for (var m = 0; m <= TIGHT.length && !pick; m++){
        mode(m);
        for (var j = 0; j < ks.length; j++){
          cdPaint(ks[j]);
          if (!over()){ if (ks[j] >= want || m === TIGHT.length) pick = ks[j]; break; }
        }
      }
      if (pick === null) cdPaint(ks[ks.length - 1]);   // nothing fits even at the tightest: the fewest lines (the card scrolls)
      // the name never cuts mid-word: if "{fn}'s spoilage claim" does not fit beside the date, it reads "Spoilage claim"
      if (c.name && c.who.scrollWidth > c.who.clientWidth) c.who.textContent = 'Spoilage claim';
      // a truncated item name gives up its grey qty first (the name keeps the room); a name that still does not fit is cut
      // after its last whole word that fits, so the dotted leader starts right after the "…" (CSS ellipsis is the fallback
      // for a single long word). Screen readers get the full name.
      Array.prototype.forEach.call(c.lines.querySelectorAll('.gss-cd-line'), function(li){
        var nm = li.querySelector('.gss-cd-name'), q = li.querySelector('.gss-cd-qty');
        var cut = function(){ return nm.scrollWidth > nm.clientWidth; };
        if (q && (cut() || q.scrollWidth > q.clientWidth)) li.removeChild(q);
        if (!cut() || li.classList.contains('gss-cd-more')) return;
        var full = nm.textContent, words = full.split(/\s+/);
        for (var n = words.length - 1; n >= 1; n--){
          nm.textContent = words.slice(0, n).join(' ').replace(/[\s,;:–—-]+$/, '') + '…';
          if (!cut()) break;
        }
        if (cut() && words.length > 1) nm.textContent = words[0] + '…';
        nm.setAttribute('aria-hidden', 'true');
        li.insertBefore(cdEl('span', 'gss-cd-sr', full), nm);
      });
    }
    var cdRaf = 0;
    window.addEventListener('resize', function(){
      if (!cd || ov.hidden || cd.dn.hidden || cdRaf) return;
      cdRaf = requestAnimationFrame(function(){ cdRaf = 0; fitClaimDone(); });
    });
    // the Authorize button that had focus is gone: hand focus to the new title so a keyboard / screen-reader user lands on it
    function focusDone(){ if (cd && cd.h && cd.h.focus){ try { cd.h.focus({ preventScroll: true }); } catch (e) {} } }
    function open(){
      photos = []; items = []; appendMode = false; haulDate = ''; dirty = false; confirmed = false; selectHaul(''); setExpress();
      document.getElementById('gseClaimThumbs').innerHTML = '';
      renderCapState();
      show('cap'); ov.hidden = false; track('claim_opened');
      // resume/edit: if a claim was already prepared for this lead, load it straight into the review
      if (leadCode && CFG.workerBase){
        fetch(CFG.workerBase.replace(/\/$/, '') + '/claim?c=' + encodeURIComponent(leadCode))
          .then(function(r){ return r.json(); })
          .then(function(d){ var capEl = ov.querySelector('[data-claimstep="cap"]');
            if (d && d.haul_date) selectHaul(d.haul_date);
            if (d && typeof d.days_left === 'number') setExpress(d.days_left);
            if (d && d.ok && d.found && d.items && d.items.length && !ov.hidden && capEl && !capEl.hidden && photos.length === 0){ confirmed = (d.status === 'confirmed'); dirty = false; items = d.items; renderRows(); show('rev'); } })
          .catch(function(){});
      }
    }
    // capture-step dock: big Take/Library buttons until a photo exists, then a thumbs tray + "Itemize" with small
    // "add more" links; "Back to your list" only shows when adding photos from the review step.
    function renderCapState(){
      var has = photos.length > 0, $ = function(id){ return document.getElementById(id); };
      var an = $('gseClaimAnalyze'); if (an){ an.hidden = !has; an.disabled = !has; }
      var take = $('gseClaimTake'), lib = $('gseClaimLib'), alt = $('gseClaimAlt'), skip = $('gseClaimSkip');
      if (take) take.hidden = has; if (lib) lib.hidden = has; if (alt) alt.hidden = !has;
      if (skip) skip.hidden = !appendMode;
      requestAnimationFrame(syncCapScroll);
    }
    // fade the bottom edge of the capture step while more content sits below it (short viewports, e.g. a phone
    // with the browser bar showing) so the date chips never look cut off; the fade clears once scrolled to the end
    var capTop = ov.querySelector('.gss-claim-top');
    function syncCapScroll(){ if (capTop) capTop.classList.toggle('gss-scrolls', capTop.scrollHeight - capTop.clientHeight - capTop.scrollTop > 2); }
    if (capTop) capTop.addEventListener('scroll', syncCapScroll, { passive: true });
    window.addEventListener('resize', syncCapScroll);
    function close(){ ov.hidden = true; }
    openClaim = open;   // let the "You're booked" screen open the spoilage claim
    document.getElementById('gseClaimClose').addEventListener('click', close);
    document.getElementById('gseClaimSkip').addEventListener('click', function(){ if (appendMode){ appendMode = false; show('rev'); } else { close(); } });
    document.getElementById('gseClaimDone').addEventListener('click', close);
    ROOT.querySelectorAll('[data-claim-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); open(); }); });

    ['gseClaimFile', 'gseClaimFileLib'].forEach(function(id){
      var fi = document.getElementById(id); if (!fi) return;
      fi.addEventListener('change', function(){ Array.prototype.forEach.call(fi.files, addFile); fi.value = ''; });
    });

    /* last-grocery-haul date strip (today back 21 days) */
    var HAUL_DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], HAUL_MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function pad2(n){ return (n < 10 ? '0' : '') + n; }
    function isoDate(d){ return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }
    function selectHaul(iso){
      haulDate = iso || '';
      var strip = document.getElementById('gseHaulStrip'); if (!strip) return;
      Array.prototype.forEach.call(strip.querySelectorAll('.gss-haul-day'), function(el){ el.classList.toggle('on', el.getAttribute('data-date') === haulDate); });
    }
    function buildHaul(){
      var strip = document.getElementById('gseHaulStrip'); if (!strip) return;
      strip.innerHTML = '';
      var today = new Date(); today.setHours(0, 0, 0, 0);
      for (var i = 0; i < 21; i++){
        var d = new Date(today); d.setDate(today.getDate() - i);
        var b = document.createElement('button'); b.type = 'button'; b.className = 'gss-haul-day'; b.setAttribute('data-date', isoDate(d));
        var dow = document.createElement('span'); dow.className = 'gss-hd-dow'; dow.textContent = i === 0 ? 'Today' : HAUL_DOW[d.getDay()];
        var num = document.createElement('span'); num.className = 'gss-hd-num'; num.textContent = HAUL_MON[d.getMonth()] + ' ' + d.getDate();
        b.appendChild(dow); b.appendChild(num);
        b.addEventListener('click', function(){ selectHaul(this.getAttribute('data-date')); dirty = true; });
        strip.appendChild(b);
      }
    }
    buildHaul();
    function addFile(f){
      if (!f || !f.type || f.type.indexOf('image') !== 0) return;
      var img = new Image(), url = URL.createObjectURL(f);
      img.onload = function(){
        var max = 1024, w = img.width, h = img.height;
        if (w >= h && w > max){ h = Math.round(h * max / w); w = max; } else if (h > w && h > max){ w = Math.round(w * max / h); h = max; }
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        cv.getContext('2d').drawImage(img, 0, 0, w, h);
        var data = cv.toDataURL('image/jpeg', 0.7);
        photos.push(data.split(',')[1]);
        var t = document.createElement('img'); t.className = 'gss-claim-thumb'; t.src = data;
        document.getElementById('gseClaimThumbs').appendChild(t);
        renderCapState();
        URL.revokeObjectURL(url);
      };
      img.onerror = function(){ URL.revokeObjectURL(url); };
      img.src = url;
    }

    document.getElementById('gseClaimAnalyze').addEventListener('click', function(){
      if (!photos.length) return;
      if (!leadCode || !CFG.workerBase){ alert('We couldn’t find your link — please reopen from your text message.'); return; }
      show('proc');
      var pctEl = document.getElementById('gseClaimPct'), pct = 0; if (pctEl) pctEl.textContent = '0%';
      var pctTimer = setInterval(function(){ pct = Math.min(94, pct + Math.random() * 11 + 4); if (pctEl) pctEl.textContent = Math.round(pct) + '%'; }, 320);
      function stopPct(done){ clearInterval(pctTimer); if (done && pctEl) pctEl.textContent = '100%'; }
      fetch(CFG.workerBase.replace(/\/$/, '') + '/claim/analyze', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ c: leadCode, photos: photos, haul_date: haulDate }) })
        .then(function(r){ return r.json(); })
        .then(function(d){ stopPct(true); setTimeout(function(){
          if (d && d.ok && d.items && d.items.length){ items = appendMode ? items.concat(d.items) : d.items; appendMode = false; dirty = true; renderRows(); show('rev'); }
          else if (appendMode){ appendMode = false; alert('No new items spotted in those photos.'); show('rev'); }
          else { alert('We couldn’t read those photos — try clearer, well-lit shots.'); show('cap'); }
        }, 250); })
        .catch(function(){ stopPct(false); if (appendMode){ appendMode = false; show('rev'); } else { show('cap'); } alert('Network issue — please try again.'); });
    });

    function money(n){ return '$' + (Math.round((Number(n) || 0) * 100) / 100).toFixed(2); }
    function recalc(){ var t = items.reduce(function(s, it){ return s + (Number(it.replacement_cost) || 0); }, 0); var cf = document.getElementById('gseClaimConfirm'); if (cf){ cf.innerHTML = (confirmed ? 'Update Claim' : 'Authorize Claim') + ' · <span id="gseClaimBtnTotal">' + money(t) + '</span>'; cf.disabled = confirmed && !dirty; } }
    function renderRows(){
      var list = document.getElementById('gseClaimList'); list.innerHTML = '';
      items.forEach(function(it, i){
        var row = document.createElement('div'); row.className = 'gss-claim-row';
        function mkInput(f){
          var inp = document.createElement('input'); inp.setAttribute('data-f', f);
          if (f === 'replacement_cost'){ inp.className = 'cost'; inp.inputMode = 'decimal'; inp.placeholder = '0.00'; var cv0 = it[f]; inp.value = (cv0 === '' || cv0 == null) ? '' : (Number(cv0) || 0).toFixed(2); inp.addEventListener('blur', function(){ var bv = items[i][f]; inp.value = (bv === '' || bv == null) ? '' : (Number(bv) || 0).toFixed(2); }); }
          else { inp.value = it[f] || ''; inp.placeholder = (f === 'qty' ? 'Qty' : 'Item'); }
          inp.addEventListener('input', function(){ items[i][f] = (f === 'replacement_cost') ? (inp.value.trim() === '' ? '' : (parseFloat(inp.value) || 0)) : inp.value; dirty = true; recalc(); });
          return inp;
        }
        var costWrap = document.createElement('span'); costWrap.className = 'gss-claim-cost';
        var dol = document.createElement('span'); dol.className = 'gss-claim-dollar'; dol.textContent = '$';
        costWrap.appendChild(dol); costWrap.appendChild(mkInput('replacement_cost'));
        var del = document.createElement('button'); del.type = 'button'; del.className = 'gss-claim-del'; del.setAttribute('aria-label', 'Remove'); del.innerHTML = '&times;';
        del.addEventListener('click', function(){ items.splice(i, 1); dirty = true; renderRows(); });
        // order: item label (widest) · qty · value (right-aligned) · remove × (far right)
        row.appendChild(mkInput('description')); row.appendChild(mkInput('qty')); row.appendChild(costWrap); row.appendChild(del);
        list.appendChild(row);
      });
      recalc();
    }
    document.getElementById('gseClaimAddItem').addEventListener('click', function(){ items.push({ description: '', brand: '', qty: '', replacement_cost: '' }); dirty = true; renderRows(); });
    document.getElementById('gseClaimMore').addEventListener('click', function(){ appendMode = true; photos = []; document.getElementById('gseClaimThumbs').innerHTML = ''; renderCapState(); show('cap'); });
    // a failed send never says "Claim authorized": the homeowner stays on the list, the button comes back, one plain line says why
    // (Dion 2026-10-13; it used to show the done screen from .catch()). The line clears on the next attempt.
    function claimErr(msg){
      var cf = document.getElementById('gseClaimConfirm'), e = document.getElementById('gseClaimErr');
      if (!e && msg && cf && cf.parentNode){ e = document.createElement('p'); e.className = 'gss-claim-err'; e.id = 'gseClaimErr'; e.setAttribute('role', 'alert'); cf.parentNode.insertBefore(e, cf.nextSibling); }
      if (!e) return;
      e.textContent = msg || ''; e.hidden = !msg;
    }
    document.getElementById('gseClaimConfirm').addEventListener('click', function(){
      var btn = this; btn.disabled = true; claimErr(''); track('claim_confirmed');
      function failed(){ btn.disabled = false; claimErr('Couldn’t send your claim. Check your connection and try again.'); }
      fetch(CFG.workerBase.replace(/\/$/, '') + '/claim/confirm', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ c: leadCode, consent: true, items: items, haul_date: haulDate }) })
        .then(function(r){ if (!r || !r.ok) throw new Error('confirm ' + (r && r.status)); return r.json(); })
        .then(function(d){ if (!d || d.ok !== true) throw new Error('confirm not ok'); confirmed = true; dirty = false; authAt = new Date(); show('done'); })
        .catch(failed);
    });
    // auto-open the claim portal when the link carries #prepare (e.g. a minted link …?c=CODE#prepare)
    if (/prepare/i.test(location.hash || '')) open();
  })();

  /* ---- upload-bill: a photo or PDF of the homeowner's utility bill → POST /bill → attached to the
     GHL contact. Opens from the booked "Join Meeting" dropdown ("Upload bill") or a …#uploadbill link. ---- */
  (function initBill(){
    ensureBillMarkup();
    var ov = document.getElementById('gseBillOv'); if (!ov) return;
    var files = [];  // [{ name, type, b64, dataUrl?, cls }]
    var sending = false, sent = false, failed = false, rejects = 0, SIX_MONTHS = 183 * 86400000;
    var noteUi = null;   // the closer's progress on Copy Usage Note (Scoreboard popup only), set up below
    var camSvg = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 4h-5L8 6H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-4l-1.5-2Z"/><circle cx="12" cy="13" r="3.5"/></svg>';
    var docSvg = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>';
    // "We need both pages" checklist icons — show the homeowner what to look for on the bill
    var idSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="5" width="19" height="14" rx="2.5"/><circle cx="8.5" cy="11" r="2.2"/><path d="M5.2 16.2c.6-1.4 1.8-2.1 3.3-2.1s2.7.7 3.3 2.1"/><path d="M14.5 10h4.5"/><path d="M14.5 13.5h3.5"/></svg>';
    var chartSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg>';
    var chevSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
    var heroSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M9 13h6"/><path d="M9 17h4"/></svg>';   // hero glyph above the bill-screen title
    buildCapLayout();
    if (EMBED_BILL){   // the reader is a closer or setter, not the homeowner
      var capH = ov.querySelector('[data-billstep="cap"] .gss-claim-h2');
      if (capH) capH.innerHTML = 'Upload the <span data-gse="utility">utility</span> bill';
      var capSub = ov.querySelector('[data-billstep="cap"] .gss-claim-sub');
      if (capSub) capSub.innerHTML = '<span class="gss-bill-lead">Add both pages of the homeowner\u2019s bill.</span>It goes straight to the Scoreboard.';
      var doneSub = ov.querySelector('[data-billstep="done"] .gss-claim-sub');
      if (doneSub) doneSub.textContent = 'Bill uploaded. The Scoreboard usually updates within a minute, once the bill has been read.';
      // "Copy Usage Note" (months of kWh, rate, average bill) on the done screen. The Scoreboard reads the
      // uploaded bill and sends its note here; this page holds the text so the click itself copies it.
      // Only when the Scoreboard says it can (EMB.copyNote), so an older Scoreboard never shows a dead button.
      var doneBtn = document.getElementById('gseBillDone');
      if (doneBtn && EMB.copyNote === true && window.parent !== window && !document.getElementById('gseBillCopyNote')){
        if (!document.getElementById('gseCopyNoteCss')){
          var cnCss = document.createElement('style'); cnCss.id = 'gseCopyNoteCss';
          cnCss.textContent = '@keyframes gseCnSpin{to{transform:rotate(360deg)}}.gse-cn-spin{animation:gseCnSpin .9s linear infinite}' +
            // the reading progress: a fill inside the button itself, in its own text colour, so it reads in both themes
            '#gseBillCopyNote.gse-cn-prog{position:relative;overflow:hidden;white-space:nowrap}' +
            // "busy, still usable" while it reads (over the theme's disabled-button wait cursor, #gs-elig .gss-bookbtn:disabled)
            '#gseBillCopyNote.gse-cn-prog,#gs-elig #gseBillCopyNote.gse-cn-prog{cursor:progress}' +
            '#gseBillCopyNote .gse-cn-fill{position:absolute;left:0;top:0;bottom:0;width:100%;background:currentColor;opacity:.17;transform-origin:0 50%;transform:scaleX(0);transition:transform 1s linear;pointer-events:none}' +
            '#gseBillCopyNote.gse-cn-fin .gse-cn-fill{transition:transform .45s ease-out}' +
            '#gseBillCopyNote.gse-cn-prog svg,#gseBillCopyNote .gse-cn-lbl,#gseBillCopyNote .gse-cn-time{position:relative;flex:0 0 auto}' +
            // room for "99%", so 0 % → 99 % never moves the label (tabular digits); "100%" only on the finish frame
            '#gseBillCopyNote .gse-cn-pct{display:inline-block;min-width:2.4em;text-align:left;font-variant-numeric:tabular-nums}' +
            '#gseBillCopyHint .gse-cn-htime{font-weight:600;font-variant-numeric:tabular-nums}' +
            '.gse-sr{position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}' +
            // a very narrow frame (320 px phones): the spinner gives its room to the words, the fill and % still move
            '@media (max-width:339px){#gseBillCopyNote.gse-cn-prog svg{display:none}}' +
            '@media (prefers-reduced-motion:reduce){.gse-cn-spin{animation:none}#gseBillCopyNote .gse-cn-fill,#gseBillCopyNote.gse-cn-fin .gse-cn-fill{transition:none}}';
          document.head.appendChild(cnCss);
        }
        var copySvg = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
        var spinSvg = '<svg class="gse-cn-spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M21 12a9 9 0 1 1-9-9"/></svg>';
        var cn = document.createElement('button'); cn.type = 'button'; cn.id = 'gseBillCopyNote'; cn.className = 'gss-bookbtn gss-claim-go';
        cn.style.cssText = 'text-align:center;display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:10px';
        var cnHint = document.createElement('p'); cnHint.id = 'gseBillCopyHint'; cnHint.setAttribute('aria-live', 'polite');
        // The progress for screen readers (a role inside a <button> is not exposed): value + step, never the clock.
        var cnBar = document.createElement('span'); cnBar.id = 'gseBillCopyBar'; cnBar.className = 'gse-sr'; cnBar.hidden = true;
        cnBar.setAttribute('role', 'progressbar'); cnBar.setAttribute('aria-label', 'Reading the bill'); cnBar.setAttribute('aria-valuemin', '0'); cnBar.setAttribute('aria-valuemax', '100');
        cnHint.style.cssText = 'margin:0 0 14px;font-size:13px;line-height:1.4;color:var(--text-2,#6e6e73);text-align:center';   // follows the night theme
        // "View Usage Note": shows once the note is ready, opens it full-screen inside the sheet.
        var eyeSvg = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>';
        var vn = document.createElement('button'); vn.type = 'button'; vn.id = 'gseBillViewNote'; vn.className = 'gss-bookbtn gss-claim-go';
        vn.style.cssText = 'text-align:center;display:none;align-items:center;justify-content:center;gap:8px;margin-bottom:10px;cursor:pointer';
        vn.innerHTML = eyeSvg + ' View Usage Note';
        doneBtn.parentNode.insertBefore(cn, doneBtn); doneBtn.parentNode.insertBefore(cnBar, doneBtn); doneBtn.parentNode.insertBefore(vn, doneBtn); doneBtn.parentNode.insertBefore(cnHint, doneBtn);
        var note = { status: 'reading', text: '' }, flashTimer = null;
        // "Reading the bill… 42%  0:47" while the upload is read (Dion 2026-10-14: it used to spin for minutes with no
        // sense of progress). The clock counts from the upload press; the percentage follows billProgressModel (real
        // steps, eased inside each); the line under the button names the step. Painted every second by a timer (never
        // requestAnimationFrame: a hidden tab or pane never runs it), the fill glides between ticks by CSS.
        var prog = null;   // { m: model, iv: ticker, fin: filling to 100 %, took: ms at ready }
        var clock = function(ms){ var t = Math.floor(Math.max(0, ms) / 1000), sec = t % 60; return Math.floor(t / 60) + ':' + (sec < 10 ? '0' : '') + sec; };
        var stepLine = function(now){
          var st = prog.m.step(now);
          return 'Step ' + st.n + ' of ' + prog.m.steps + ' \u00b7 ' + st.label;
        };
        var paintProgress = function(){
          var now = Date.now(), pct = prog.fin ? 100 : prog.m.pct(now), key = prog.m.step(now).key;
          // the button's words follow the step (the line under it names it): reading, then almost ready, then ready
          var verb = prog.fin ? 'Note ready' : (key === 'saving' || key === 'note' ? 'Almost ready\u2026' : 'Reading the bill\u2026');
          var fill = cn.querySelector ? cn.querySelector('.gse-cn-fill') : null;
          if (!fill){
            cn.innerHTML = '<span class="gse-cn-fill" aria-hidden="true"></span>' + spinSvg + '<span class="gse-cn-lbl"><span class="gse-cn-verb"></span> <span class="gse-cn-pct"></span></span>';
            fill = cn.querySelector ? cn.querySelector('.gse-cn-fill') : null;
          }
          var ve = cn.querySelector ? cn.querySelector('.gse-cn-verb') : null, pe = cn.querySelector ? cn.querySelector('.gse-cn-pct') : null;
          if (ve && ve.textContent !== verb) ve.textContent = verb;
          if (pe) pe.textContent = pct + '%';
          if (fill) fill.style.transform = 'scaleX(' + (pct / 100) + ')';
          cn.className = 'gss-bookbtn gss-claim-go gse-cn-prog' + (prog.fin ? ' gse-cn-fin' : '');
          cn.setAttribute('aria-label', prog.fin ? 'Usage note ready' : 'Reading the bill');
          cnBar.hidden = false; cnBar.setAttribute('aria-valuenow', String(pct));
          var line = prog.fin ? 'The usage note is ready.' : stepLine(now);
          cnBar.setAttribute('aria-valuetext', pct + '%, ' + line);
          // The clock leads the step line (Dion 2026-10-14: off the button, "to the left of step 1 of 5"). It has its own
          // aria-hidden span, so the live region announces a new step, never every second.
          var ht = cnHint.querySelector ? cnHint.querySelector('.gse-cn-htime') : null, hs = cnHint.querySelector ? cnHint.querySelector('.gse-cn-hstep') : null;
          if (!ht || !hs){
            cnHint.innerHTML = '<span class="gse-cn-htime" aria-hidden="true"></span><span class="gse-cn-hstep"></span>';
            ht = cnHint.querySelector ? cnHint.querySelector('.gse-cn-htime') : null; hs = cnHint.querySelector ? cnHint.querySelector('.gse-cn-hstep') : null;
          }
          var tm = clock(prog.fin ? prog.took : prog.m.elapsed(now)) + ' \u00b7 ';
          if (ht && ht.textContent !== tm) ht.textContent = tm;
          if (hs && hs.textContent !== line) hs.textContent = line;
          else if (!hs && cnHint.textContent !== tm + line) cnHint.textContent = tm + line;
        };
        var endProgress = function(){
          if (!prog) return;
          clearInterval(prog.iv); prog.iv = null;
          cn.className = 'gss-bookbtn gss-claim-go'; cn.removeAttribute && cn.removeAttribute('aria-label');
          cnBar.hidden = true;
        };
        var openNoteViewer = function(){
          var v = document.getElementById('gseNoteView');
          if (!v){
            v = document.createElement('div'); v.className = 'gss-bill-exov'; v.id = 'gseNoteView'; v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true');
            v.innerHTML = '<button type="button" class="gss-claim-x" id="gseNoteViewClose" aria-label="Close">&times;</button>' +
              '<div class="gss-bill-exhead"><div class="gss-bill-exttl">Usage Note</div></div>' +
              '<div class="gss-bill-exbody" style="align-items:stretch;justify-content:stretch"><pre id="gseNoteViewText" style="flex:1 1 auto;min-height:0;margin:0;overflow:auto;white-space:pre-wrap;word-break:break-word;text-align:left;font:13px/1.5 ui-monospace,SFMono-Regular,Menlo,monospace;color:var(--text,#1d1d1f);background:var(--card,rgba(127,127,127,.08));border-radius:14px;padding:16px"></pre></div>' +
              '<div style="flex:0 0 auto;display:flex;gap:10px;width:100%;max-width:500px;align-self:center;margin-top:14px">' +
                '<button type="button" class="gss-bookbtn gss-claim-go" id="gseNoteViewCopy" style="flex:1 1 0;margin:0;display:flex;align-items:center;justify-content:center;gap:8px;cursor:pointer">' + copySvg + ' Copy</button>' +
                '<button type="button" class="gss-bookbtn gss-claim-go" id="gseNoteViewOk" style="flex:1 1 0;margin:0;display:flex;align-items:center;justify-content:center;cursor:pointer">Close</button>' +
              '</div>';
            ov.appendChild(v);
            var shut = function(){ v.hidden = true; };
            var vc = document.getElementById('gseNoteViewCopy'), vcTimer = null;
            vc.addEventListener('click', function(){
              clearTimeout(vcTimer);
              copyText(note.text).then(function(){ vc.innerHTML = copySvg + ' Copied \u2713'; }, function(){ vc.innerHTML = copySvg + ' Copy failed'; });
              vcTimer = setTimeout(function(){ vc.innerHTML = copySvg + ' Copy'; }, 2200);
            });
            document.getElementById('gseNoteViewClose').addEventListener('click', shut);
            document.getElementById('gseNoteViewOk').addEventListener('click', shut);
            document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !v.hidden) shut(); });
          }
          document.getElementById('gseNoteViewText').textContent = note.text;
          v.hidden = false;
        };
        vn.addEventListener('click', function(){ if (note.status === 'ready') openNoteViewer(); });
        // Why the bill worker could not read a year from the upload, as the Scoreboard passes it on (Dion 2026-10-14: the
        // closer used to wait minutes for a bare "unavailable"): what it means, and what to do instead.
        var NOTE_WHY = {
          'multiple-rate-codes': 'This bill lists two different rate plans (likely two meters), so no yearly average can be worked out. Measure it in Bill Info instead.',
          'solar/net-metering': 'This is a solar (net metering) bill: it does not show the home\u2019s real usage. Measure it in Bill Info instead.',
          'one-month-only': 'Only one month could be read. Upload the whole bill as one file, including the 12-month usage chart page (usually page 2 or 3).',
          'daily-comparison-only': 'The 12-month billing history could not be read. Add the page with the Monthly Billing History.',
          'charges-or-usage-missing': 'This period\u2019s kWh or charges could not be found. Add page 1 of the bill (with Total Usage), or a clearer copy.',
          'rate-not-derivable': 'No price per kWh could be worked out from this bill. Measure it in Bill Info instead.',
          'partial-chart-read': 'The 12-month usage chart could not be read. Add a clearer copy of the chart page, or measure it in Bill Info.',
          'derivation-failed': 'No 12-month average could be worked out from the usage chart. Measure it in Bill Info instead.',
          'unreadable': 'The bill could not be read. Upload a clearer PDF or photo, or measure it in Bill Info.'
        };
        // The bill was filed from the upload but not read as a full year (the Scoreboard passes the reason as
        // note.partial): the note is there to copy, and this line says what it is missing.
        var NOTE_PARTIAL = {
          'one-month-only': 'only this month (no 12-month usage chart). Upload the whole bill as one file for a yearly average.',
          'daily-comparison-only': 'estimated from the daily usage comparison. Add the Monthly Billing History page.',
          'solar/net-metering': 'solar (net metering) bill, its usage is net. Measure it in Bill Info.',
          'charges-or-usage-missing': 'this period\u2019s kWh or charges were not found. Add page 1 of the bill, or a clearer copy.',
          'rate-not-derivable': 'no price per kWh could be worked out. Measure it in Bill Info.',
          'partial-chart-read': 'the 12-month chart could not be read. Add a clearer copy of it.',
          'derivation-failed': 'no 12-month average could be worked out. Measure it in Bill Info.',
          'multiple-rate-codes': 'two rate plans on the bill. Measure it in Bill Info.',
          'unreadable': 'nothing could be read automatically. Upload a clearer copy, or measure it in Bill Info.'
        };
        var paintNote = function(flash){
          var ready = note.status === 'ready';
          var inProg = !!(prog && prog.iv && (note.status === 'reading' || prog.fin));
          cn.disabled = !ready || inProg; cn.style.opacity = ready || inProg ? '' : '0.6'; cn.style.cursor = inProg ? '' : (ready ? 'pointer' : 'default');   // '' while it reads: the stylesheet's progress cursor
          if (inProg) cn.style.opacity = '1';   // over the stylesheet's dimmed :disabled, so the fill reads
          vn.style.display = ready && !inProg ? 'flex' : 'none';
          // Done waits until the reading ends, however it ends (Dion 2026-10-14: "the done button should not show until reading
          // bill is done"). Its room is kept, so nothing jumps when it appears; the popup's own × still closes it meanwhile.
          doneBtn.style.visibility = inProg ? 'hidden' : '';
          if (inProg){ paintProgress(); return; }
          if (note.status === 'reading'){ cn.innerHTML = spinSvg + ' Reading the bill…'; cnHint.textContent = 'The usage note is usually ready in about a minute.'; }
          else if (ready && note.partial){ cn.innerHTML = copySvg + ' ' + (flash || 'Copy Usage Note'); cnHint.textContent = flash ? '' : 'Read partially: ' + (NOTE_PARTIAL[note.partial] || 'not a full 12-month reading. The note says what is missing.'); }
          else if (ready){ cn.innerHTML = copySvg + ' ' + (flash || 'Copy Usage Note'); cnHint.textContent = flash ? '' : (prog && prog.took ? 'Read in ' + clock(prog.took) + '. ' : '') + 'Months of usage, rate and average bill, ready to paste.'; }
          else if (note.reason === 'kept-existing'){
            // Not filed: the row already holds an earlier bill from this homeowner, left as it is.
            cn.innerHTML = copySvg + ' Usage Note Unavailable';
            cnHint.textContent = 'This upload was not added to the Scoreboard' + (NOTE_PARTIAL[note.detail] ? ' (read partially: ' + NOTE_PARTIAL[note.detail].split('. ')[0] + ')' : '') + ': the row keeps the homeowner\u2019s earlier bill and its note. What was read from this upload is in the contact\u2019s GHL notes. Pages sent separately are never combined: upload the whole bill as one file, or measure it in Bill Info.';
          }
          else { cn.innerHTML = copySvg + ' Usage Note Unavailable'; cnHint.textContent = NOTE_WHY[note.reason] || 'The bill could not be read as a full bill yet. Check its row on the Scoreboard.'; }
        };
        var copyText = function(t){
          var legacy = function(){ return new Promise(function(res, rej){
            var ta = document.createElement('textarea'); ta.value = t; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:-1000px;left:0;opacity:0';
            document.body.appendChild(ta); ta.select(); var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
            ta.parentNode.removeChild(ta); if (ok) res(); else rej(new Error('copy failed'));
          }); };
          if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(t).catch(legacy);
          return legacy();
        };
        cn.addEventListener('click', function(){
          if (note.status !== 'ready') return;
          clearTimeout(flashTimer);
          copyText(note.text).then(function(){ paintNote('Copied ✓'); }, function(){ paintNote('Copy failed, try again'); });
          flashTimer = setTimeout(function(){ paintNote(); }, 2200);
        });
        window.addEventListener('message', function(e){
          var o = window.origin || location.origin;
          if (e.source !== window.parent || !o || o === 'null' || e.origin !== o) return;
          var d = (e.data && typeof e.data === 'object') ? e.data : {};
          if (d.type !== 'gs-uploadbill-note') return;
          // A newer Scoreboard says where the upload is (stage) and hands over the stored reading (result).
          if (d.result && typeof d.result === 'object') takeBillRead(d.result);
          if (typeof d.stage === 'string' && STAGE_OF[d.stage]) noteUi.stage(STAGE_OF[d.stage]);
          var was = note.status;
          if (d.status === 'ready' && typeof d.text === 'string' && d.text) note = { status: 'ready', text: d.text, partial: typeof d.partial === 'string' ? d.partial : '' };
          else if (note.status !== 'ready' && (d.status === 'unavailable' || d.status === 'reading')) note = { status: d.status, text: '', reason: typeof d.reason === 'string' ? d.reason : '', detail: typeof d.detail === 'string' ? d.detail : '' };
          if (note.status === 'ready' && was !== 'ready') noteUi.finish();
          else if (note.status === 'unavailable') noteUi.stop();
          if (note.status !== 'reading') billNoteEnded(note.status);
          paintNote();
        });
        // The Scoreboard's / the funnel's stage names → the model's steps.
        var STAGE_OF = { queued: 'queued', reading: 'reading', pending: 'wait', read: 'saving', found: 'note' };
        noteUi = {
          // the closer pressed upload: the clock starts
          begin: function(){
            if (prog) clearInterval(prog.iv);
            prog = { m: billProgressModel(Date.now()), iv: null, fin: false, took: 0 };
            prog.iv = setInterval(function(){
              if (!prog || !prog.iv) return;
              if (prog.m.elapsed(Date.now()) > 15 * 60000){ endProgress(); paintNote(); return; }   // nobody answered: stop ticking
              paintNote();
            }, 1000);
            paintNote();
          },
          stage: function(key){ if (prog && prog.iv && !prog.fin && prog.m.to(key, Date.now())) paintNote(); },
          // the upload could not be sent: back to the capture screen, no clock
          reset: function(){ endProgress(); prog = null; paintNote(); },
          // the note is ready: fill to 100 % quickly, then the normal Copy Usage Note
          finish: function(){
            if (!prog || !prog.iv) return;
            prog.took = prog.m.elapsed(Date.now()); prog.m.done(); prog.fin = true; paintNote();
            setTimeout(function(){ if (!prog) return; prog.fin = false; endProgress(); paintNote(); }, 700);
          },
          // unavailable / not added / timed out: the bar stops, part 2's reason shows as before
          stop: function(){ if (!prog || !prog.iv) return; prog.m.stop(Date.now()); endProgress(); },
          pct: function(){ return prog ? (prog.fin ? 100 : prog.m.pct(Date.now())) : 0; },
          line: function(){ var now = Date.now(); return prog ? clock(prog.m.elapsed(now)) + ' \u00b7 ' + stepLine(now) : ''; }
        };
        paintNote();
      }
      // No bill in hand: the Scoreboard texts the customer this link instead (it confirms the text first).
      // Only when the Scoreboard says it can (EMB.sendLink), so an older Scoreboard never shows a dead button.
      var dock = ov.querySelector('.gss-bill-dock');
      if (dock && EMB.sendLink === true && window.parent !== window && !document.getElementById('gseBillSendLink')){
        var sl = document.createElement('button'); sl.type = 'button'; sl.id = 'gseBillSendLink'; sl.className = 'gss-bookbtn gss-claim-go';
        sl.style.cssText = 'cursor:pointer;text-align:center;display:flex;align-items:center;justify-content:center;gap:8px';
        sl.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg> Text Link to Customer';
        sl.addEventListener('click', function(){ embedPost('gs-uploadbill-sendlink'); });
        var takeBtn = document.getElementById('gseBillTake');   // right under Take a Photo
        if (takeBtn && takeBtn.parentNode === dock) dock.insertBefore(sl, takeBtn.nextSibling); else dock.appendChild(sl);
      }
    }
    // Deploy-gap safety: if the liquid wasn't re-uploaded, build the overlay + dropdown item from JS.
    function ensureBillMarkup(){
      if (!document.getElementById('gseBillOv')){
        var html = '<div class="gss-claim-ov" id="gseBillOv" hidden><div class="gss-claim-card">' +
          '<button type="button" class="gss-claim-x" id="gseBillClose" aria-label="Close">&times;</button>' +
          '<div data-billstep="cap" data-claimstep="cap"><div class="gss-claim-eyebrow">YOUR UTILITY BILL</div><h2 class="gss-claim-h2">Upload your bill</h2>' +
          '<p class="gss-claim-sub">Add a photo or PDF of a recent <span data-gse="utility">utility</span> bill so your coordinator can confirm your usage qualifies and that your home can be fully funded before your review.</p>' +
          '<label class="gss-claim-add" for="gseBillFile"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 4h-5L8 6H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-4l-1.5-2Z"/><circle cx="12" cy="13" r="3.5"/></svg> Take a photo of your bill</label>' +
          '<input type="file" id="gseBillFile" accept="image/*" capture="environment" multiple hidden>' +
          '<label class="gss-claim-lib" for="gseBillFileLib">or choose a photo or PDF from your device</label>' +
          '<input type="file" id="gseBillFileLib" accept="image/*,application/pdf" multiple hidden>' +
          '<div class="gss-claim-thumbs" id="gseBillThumbs"></div>' +
          '<button type="button" class="gss-bookbtn gss-claim-go" id="gseBillSend" disabled>Send to Coordinator <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>' +
          '</div>' +
          '<div data-billstep="proc" data-claimstep="proc" hidden><div class="gss-claim-prog"><span class="gss-claim-prog-ring"></span><span class="gss-claim-pct" id="gseBillPct">0%</span></div><h2 class="gss-claim-h2">Uploading your bill…</h2><p class="gss-claim-sub">Sending it securely to your coordinator. This takes a few seconds.</p></div>' +
          '<div data-billstep="done" data-claimstep="done" hidden><div class="gss-claim-donecheck"><svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></div><h2 class="gss-claim-h2">Bill received</h2><p class="gss-claim-sub">Thanks — your coordinator now has your bill and will review it before your appointment. Nothing else to do right now.</p><button type="button" class="gss-bookbtn gss-claim-go" id="gseBillDone">Done</button></div>' +
          '</div></div>';
        var wrap = document.createElement('div'); wrap.innerHTML = html;
        (ROOT || document.body).appendChild(wrap.firstElementChild);
      }
      var menu = document.getElementById('gssCtaMenu');
      if (menu && !document.getElementById('gssUploadBill')){
        var bb = document.createElement('button'); bb.type = 'button'; bb.id = 'gssUploadBill'; bb.setAttribute('role', 'menuitem'); bb.textContent = 'Upload Bill';
        menu.insertBefore(bb, menu.firstChild);
      }
    }
    function show(step){ Array.prototype.forEach.call(ov.querySelectorAll('[data-billstep]'), function(s){ var on = s.getAttribute('data-billstep') === step; s.hidden = !on; if (s.getAttribute('data-billstep') === 'cap') s.style.display = on ? 'flex' : 'none'; }); }   // the cap step carries an inline display:flex (buildCapLayout), which would beat [hidden]
    function refresh(){ renderBillState(); embedPost('gs-uploadbill-state', { sending: sending, sent: sent }); }
    // Redesigned capture screen: header centered; "Take a photo" docked at the bottom as the CTA with the
    // file/photo link right above it; "Send" appears once a bill is added. Built from JS so it applies
    // whether the markup came from the liquid or the injected fallback.
    function buildCapLayout(){
      var cap = ov.querySelector('[data-billstep="cap"]'); if (!cap) return;
      cap.style.cssText = 'display:flex;flex-direction:column;flex:1 1 auto;min-height:0;margin:0;width:100%';
      cap.innerHTML =
        '<div class="gss-bill-top"><div class="gss-bill-head">' +
          '<div class="gss-bill-hero">' + heroSvg + '</div>' +
          '<h2 class="gss-claim-h2">Upload your <span data-gse="utility">utility</span> bill</h2>' +
          '<p class="gss-claim-sub"><span class="gss-bill-lead">Save time in your meeting.</span>Your coordinator will prepare the project for your home’s energy use.</p>' +
          // SCE needs BOTH pages — make that the unmissable instruction (a numbered checklist, not a faint hint)
          '<div class="gss-bill-need">We use 2 pages</div>' +
          '<div class="gss-bill-steps">' +
            '<button type="button" class="gss-bill-step" data-ex="front"><span class="gss-bill-ic">' + idSvg + '<span class="gss-bill-n">1</span></span><b class="gss-bill-t">Front Page</b><span class="gss-bill-ex">Example' + chevSvg + '</span></button>' +
            '<button type="button" class="gss-bill-step" data-ex="graph"><span class="gss-bill-ic">' + chartSvg + '<span class="gss-bill-n">2</span></span><b class="gss-bill-t">Usage Graph</b><span class="gss-bill-ex">Example' + chevSvg + '</span></button>' +
          '</div>' +
          '<div class="gss-claim-thumbs" id="gseBillThumbs"></div>' +
        '</div></div>' +
        '<div class="gss-bill-dock" style="flex:0 0 auto;display:flex;flex-direction:column;gap:10px">' +
          '<input type="file" id="gseBillFile" accept="image/*" capture="environment" multiple hidden>' +
          '<input type="file" id="gseBillFileLib" accept="image/*,application/pdf" multiple hidden>' +
          '<label class="gss-bookbtn gss-claim-go" id="gseBillLib" for="gseBillFileLib" style="cursor:pointer;text-align:center;display:flex;align-items:center;justify-content:center;gap:8px">' + docSvg + ' Upload PDF or Photos</label>' +
          '<label class="gss-bookbtn gss-claim-go" id="gseBillTake" for="gseBillFile" style="cursor:pointer;text-align:center;display:flex;align-items:center;justify-content:center;gap:8px">' + camSvg + ' Take a Photo</label>' +
          '<div class="gss-bill-status" id="gseBillStatus" hidden></div>' +
          '<div class="gss-bill-split" id="gseBillSplit" hidden><label for="gseBillFileLib">' + docSvg + ' Upload Another</label><label for="gseBillFile">' + camSvg + ' Take Photo</label></div>' +
          '<button type="button" class="gss-claim-skip" id="gseBillAnyway" hidden>Having trouble? Send what you have</button>' +
        '</div>';
    }
    // "Example ›" on each page tile opens a full-screen look at that page from the customer's utility's bill.
    // CFG.billExamples = { 'SCE': { front, graph }, 'PG&E': {…} } comes from the liquid (theme asset URLs); the local
    // preview has no CFG and falls back to the SCE set. Utilities without a set (SDG&E for now) show no affordance.
    var EX_LABEL = { front: 'Front Page', graph: 'Usage Graph' };
    var EX_HINT = { front: 'The first page, with your account summary and amount due.', graph: 'The page with the bar chart of your monthly usage.' };
    function exampleSet(){
      if (!CFG.billExamples) return { front: 'assets/gs-bill-ex-sce-front.jpg', graph: 'assets/gs-bill-ex-sce-graph.jpg' };
      return CFG.billExamples[utility] || null;
    }
    function renderExampleAffordance(){
      var ex = exampleSet();
      Array.prototype.forEach.call(ov.querySelectorAll('.gss-bill-step[data-ex]'), function(b){ b.classList.toggle('gss-has-ex', !!(ex && ex[b.getAttribute('data-ex')])); });
    }
    function openExample(kind){
      var ex = exampleSet(); if (!ex || !ex[kind]) return;
      var v = document.getElementById('gseBillEx');
      if (!v){
        v = document.createElement('div'); v.className = 'gss-bill-exov'; v.id = 'gseBillEx'; v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true');
        v.innerHTML = '<button type="button" class="gss-claim-x" id="gseBillExClose" aria-label="Close">&times;</button>' +
          '<div class="gss-bill-exhead"><div class="gss-bill-exttl" id="gseBillExTtl"></div><div class="gss-bill-exsub" id="gseBillExSub"></div></div>' +
          '<div class="gss-bill-exbody"><img id="gseBillExImg" alt=""></div>' +
          '<button type="button" class="gss-bookbtn gss-bill-exok" id="gseBillExOk">Got it</button>';
        ov.appendChild(v);
        var closeEx = function(){ v.hidden = true; };
        document.getElementById('gseBillExClose').addEventListener('click', closeEx);
        document.getElementById('gseBillExOk').addEventListener('click', closeEx);
        v.addEventListener('click', function(e){ if (e.target === v || e.target.className === 'gss-bill-exbody') closeEx(); });
        document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !v.hidden) closeEx(); });
      }
      document.getElementById('gseBillExTtl').textContent = 'Example: ' + EX_LABEL[kind];
      document.getElementById('gseBillExSub').textContent = utility + ' bill \u00b7 ' + EX_HINT[kind];
      var img = document.getElementById('gseBillExImg'); img.src = ex[kind]; img.alt = utility + ' ' + EX_LABEL[kind] + ' example';
      v.hidden = false; track('bill_example', { page: kind });
    }
    ov.addEventListener('click', function(e){
      var b = e.target.closest ? e.target.closest('.gss-bill-step[data-ex]') : null;
      if (b && b.classList.contains('gss-has-ex')) openExample(b.getAttribute('data-ex'));
    });
    ROOT.addEventListener('gse:lead', renderExampleAffordance);   // a #uploadbill link opens this overlay before the lead (and utility) has loaded
    // fade the bottom edge of the top area while more content sits below it (short viewports) — clears at the end
    function syncBillScroll(){ var t = ov.querySelector('.gss-bill-top'); if (t) t.classList.toggle('gss-scrolls', t.scrollHeight - t.clientHeight - t.scrollTop > 2); }
    ov.addEventListener('scroll', syncBillScroll, true);   // capture: the top area is rebuilt by buildCapLayout, so listen on the overlay
    window.addEventListener('resize', syncBillScroll);
    function billDate(){ var d = null; files.forEach(function(f){ var c = f.cls; if (c && typeof c === 'object' && c.date && (!d || c.date > d)) d = c.date; }); return d; }
    // What the bill says, merged across pages: price per kWh, this bill normalized to a month, yearly usage + cost.
    function pgePage1(){ return files.some(function(f){ return f.cls && typeof f.cls === 'object' && f.cls.pge && f.cls.front; }); }
    function billStats(){
      var m = {};
      files.forEach(function(f){ var s = f.cls && f.cls.stats; if (!s) return; ['period_kwh', 'period_days', 'electric_charges', 'gas_charges', 'one_time_credits', 'total_due', 'daily_avg_kwh'].forEach(function(k){ if (s[k] != null && m[k] == null) m[k] = s[k]; }); });
      if (!m.period_kwh && !m.daily_avg_kwh) return pgePage1() ? { pge_page1: 1 } : null;
      var kwh = m.period_kwh || null, days = m.period_days || null;
      // electricity only (a PG&E bill also carries gas) + one-time credits added back = a typical month's electric cost
      var elec = m.electric_charges != null ? m.electric_charges : (m.total_due != null ? m.total_due - (m.gas_charges || 0) : null);
      var typical = elec != null ? elec + (m.one_time_credits || 0) : null;
      var rate = (typical && kwh) ? typical / kwh : null;
      var monthly = typical ? ((days && (days < 24 || days > 38)) ? typical * 30.4 / days : typical) : null;
      var annualKwh = m.daily_avg_kwh ? m.daily_avg_kwh * 365 : (kwh ? (days ? kwh * 365 / days : kwh * 12) : null);
      var annualCost = (annualKwh && rate) ? annualKwh * rate : null;
      return { kwh: kwh, days: days, total: m.total_due || null, electric: elec, gas: m.gas_charges || 0, credits: m.one_time_credits || 0, daily_avg: m.daily_avg_kwh || null, rate: rate, monthly: monthly, annual_kwh: annualKwh, annual_cost: annualCost, pge_page1: pgePage1() ? 1 : 0 };
    }
    // The done screen's numbers. The page itself only reads this month's bill, so until the Scoreboard has read the
    // usage graph it shows THIS bill, labelled as such (scaling one summer month to a year overstated a $461 home as
    // $820/month and 23,977 kWh/year). Once the year has been read (billRead, from /bill/result) it shows the
    // average monthly bill and the year's usage, the same figures as the bill's notes.
    var billRead = null, billReadPending = false, billReadTimer = null;
    function renderBillStats(){
      var box = document.getElementById('gseBillStats'); if (!box) return;
      var fmtN = function(n){ return Math.round(n).toLocaleString('en-US'); };
      var set = function(id, v, label){ var e = document.getElementById(id); if (!e) return; e.textContent = v; if (label && e.nextElementSibling) e.nextElementSibling.textContent = label; };
      var r = billRead && billRead.status === 'ready' ? billRead : null;
      if (r){
        set('gseBsRate', r.rate ? '$' + Number(r.rate).toFixed(2) : '\u2014', 'per kWh today');
        set('gseBsMonthly', '$' + fmtN(r.avg_bill), 'avg monthly bill');
        set('gseBsAnnual', r.annual_kwh ? fmtN(r.annual_kwh) + ' kWh' : '\u2014', 'used per year');
        set('gseBsNote', 'About $' + fmtN(r.avg_bill * 12) + ' a year at today\u2019s rates.');
        box.hidden = false; return;
      }
      var s = billStats();
      if (!s || !(s.rate || s.monthly || s.kwh)){ box.hidden = true; return; }
      set('gseBsRate', s.rate ? '$' + s.rate.toFixed(2) : '\u2014', 'per kWh today');
      set('gseBsMonthly', s.monthly ? '$' + fmtN(s.monthly) : '\u2014', 'this bill');
      set('gseBsAnnual', s.kwh ? fmtN(s.kwh) + ' kWh' : '\u2014', 'used this bill');
      // A partial read (the bill was filed, but not as a full year) keeps this bill's figures; the closer is told why.
      var partialWhy = billRead && billRead.status === 'partial' && EMBED_BILL ? 'Read partially: not a full year of usage. See the usage note.' : '';
      set('gseBsNote', billReadPending ? 'Reading your usage graph for the full year\u2026' : partialWhy);
      box.hidden = false;
    }
    // The reading arrived (from this page's own poll, or handed over by the Scoreboard): the done screen's figures, and
    // the closer's progress moves on to "Updating the Scoreboard".
    function takeBillRead(d){
      if (!d || !(d.status === 'ready' || d.status === 'none' || d.status === 'partial')) return false;
      clearTimeout(billReadTimer); billRead = d; billReadPending = false; renderBillStats();
      if (noteUi) noteUi.stage('saving');
      return true;
    }
    // The Scoreboard is done with the note. If it never handed over the reading (it found the row first), ask once more
    // here for the done screen's figures; if it gave up, stop saying "Reading your usage graph…".
    function billNoteEnded(status){
      if (!billReadForwarded() || !billReadPending) return;
      if (status === 'ready') pollBillRead(true);
      else { clearTimeout(billReadTimer); billReadPending = false; renderBillStats(); }
    }
    // A newer Scoreboard (EMB.progress) asks /bill/result every 3 s itself and forwards it to this page, so in its
    // Upload Bill popup the page does not ask as well (one source, no doubled requests). force: ask anyway.
    function billReadForwarded(){ return EMBED_BILL && EMB.progress === true && window.parent !== window; }
    // After the upload: ask every 5 s, for up to 3 minutes, whether the year has been read.
    function pollBillRead(force){
      clearTimeout(billReadTimer);
      if (!leadCode || !CFG.workerBase) return;
      var tries = 0; billRead = null; billReadPending = true; renderBillStats();
      if (force !== true && billReadForwarded()) return;
      var tick = function(){
        fetch(CFG.workerBase.replace(/\/$/, '') + '/bill/result?c=' + encodeURIComponent(leadCode), { cache: 'no-store' })
          .then(function(r){ return r.json(); })
          .then(function(d){
            if (takeBillRead(d)) return;
            // an upload still waiting: where it is (a funnel without stages → 'wait', eased on time alone)
            if (d && d.status === 'pending' && noteUi) noteUi.stage(d.stage === 'queued' || d.stage === 'reading' ? d.stage : 'wait');
            if (++tries >= 36){ billReadPending = false; renderBillStats(); return; }
            billReadTimer = setTimeout(tick, 5000);
          })
          .catch(function(){ if (++tries >= 36){ billReadPending = false; renderBillStats(); return; } billReadTimer = setTimeout(tick, 5000); });
      };
      billReadTimer = setTimeout(tick, 4000);
    }
    // The closer's "Reading the bill… 42%" (Dion 2026-10-14). Honest: the percentage passes a step only when that step
    // really ended — this page's upload answered (queued), the funnel's queue picked it up (reading), the reading was
    // stored (/bill/result final → saving), the Scoreboard found the row (note) — and 100 only when the note is ready.
    // Inside a step it eases toward the step's ceiling, three quarters of the way at the step's typical time (measured
    // 2026-10-14: the bill read itself 21-24 s live, the whole hand-off ~35-45 s; the queue and Drive a few seconds),
    // never reaching the ceiling and never going backwards. Pure: every time is passed in, so it is tested on its own.
    // 'queued' is believed for 10 s only: the reader starts within a second or two, but its stamp can reach this edge up
    // to a minute late, so after that the bar eases through the read as 'wait' (step 2, toward the reading ceiling)
    // instead of sitting at 13 %. 'wait' is also what a funnel without stages gives. o = order, n = the step shown.
    function billProgressModel(t0){
      var STEPS = {
        upload:  { o: 1,   n: 1, lo: 0,  hi: 8,  sec: 5,  label: 'Uploading the bill' },
        queued:  { o: 2,   n: 2, lo: 8,  hi: 14, sec: 4,  label: 'Waiting for the reader' },
        wait:    { o: 2.5, n: 2, lo: 8,  hi: 88, sec: 45, label: 'Waiting for the bill to be read' },
        reading: { o: 3,   n: 3, lo: 14, hi: 88, sec: 40, label: 'Reading the usage chart' },
        saving:  { o: 4,   n: 4, lo: 88, hi: 97, sec: 6,  label: 'Updating the Scoreboard' },
        note:    { o: 5,   n: 5, lo: 97, hi: 99, sec: 2,  label: 'Getting the usage note' }
      };
      var QUEUED_MAX = 10000;
      var cur = 'upload', from = 0, since = t0, last = 0, end = '';
      // the current step's value at t: eased, under its ceiling, never below what was already shown
      var calc = function(t){
        var s = STEPS[cur], dt = Math.max(0, (t - since) / 1000), tau = s.sec / Math.log(4);
        var v = Math.floor(from + (s.hi - from) * (1 - Math.exp(-dt / tau)));
        if (v > s.hi - 1) v = s.hi - 1;
        if (v < last) v = last;
        last = v; return v;
      };
      var move = function(key, t){ var now = calc(t); cur = key; since = t; from = Math.max(STEPS[key].lo, now); };
      var drift = function(t){ if (!end && cur === 'queued' && typeof t === 'number' && t - since >= QUEUED_MAX) move('wait', since + QUEUED_MAX); };
      var m = {
        steps: 5,
        step: function(t){ drift(t); var s = STEPS[cur]; return { key: cur, n: s.n, label: s.label, hi: s.hi }; },
        elapsed: function(t){ return Math.max(0, t - t0); },
        ended: function(){ return end; },
        pct: function(t){
          if (end === 'done') return 100;
          if (end) return last;
          drift(t);
          return calc(t);
        },
        // a real milestone: on to that step (only forwards; a step already passed is ignored)
        to: function(key, t){
          var s = STEPS[key];
          if (!s || end) return false;
          drift(t);
          if (s.o <= STEPS[cur].o) return false;
          move(key, t);
          return true;
        },
        done: function(){ if (!end) { end = 'done'; last = 100; } },
        stop: function(t){ if (!end) { m.pct(t); end = 'stopped'; } }
      };
      return m;
    }
    function monthName(iso){ var d = new Date(iso + 'T12:00:00'); return isNaN(d) ? iso : d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }); }
    // thumbnails are rebuilt from `files` on every render: state ring (checking / ok / needs attention) + a remove ×
    function renderThumbs(){
      var th = document.getElementById('gseBillThumbs'); if (!th) return; th.innerHTML = '';
      files.forEach(function(f, i){
        var c = f.cls, w = document.createElement('div');
        w.className = 'gss-bill-thumb' + (c === 'pending' ? ' pending' : (c && typeof c === 'object' ? (c.bad ? ' bad' : ' ok') : ''));
        if (f.type === 'application/pdf'){ var d = document.createElement('div'); d.className = 'gss-claim-thumb gss-bill-pdf'; d.textContent = 'PDF'; w.appendChild(d); }
        else { var im = document.createElement('img'); im.className = 'gss-claim-thumb'; im.src = f.dataUrl || ('data:image/jpeg;base64,' + f.b64); w.appendChild(im); }
        var x = document.createElement('button'); x.type = 'button'; x.className = 'gss-bill-thumb-x'; x.setAttribute('aria-label', 'Remove'); x.innerHTML = '&times;';
        x.addEventListener('click', function(){ files.splice(i, 1); refresh(); });
        w.appendChild(x); th.appendChild(w);
      });
    }
    function renderBillState(){
      renderExampleAffordance();
      requestAnimationFrame(syncBillScroll);
      var has = files.length > 0;
      var nPdfs = files.filter(function(f){ return f.type === 'application/pdf'; }).length, nPhotos = files.length - nPdfs;
      // Full-size Upload / Take a Photo buttons up front; once a file is added they collapse into one split button.
      var lib = document.getElementById('gseBillLib'), take = document.getElementById('gseBillTake'), split = document.getElementById('gseBillSplit');
      if (lib) lib.style.display = has ? 'none' : 'flex';
      if (take) take.style.display = has ? 'none' : 'flex';
      if (split) split.hidden = !has;
      var sendLink = document.getElementById('gseBillSendLink'); if (sendLink) sendLink.style.display = (has || sending || sent) ? 'none' : 'flex';
      // What did the detector make of each file? ('pending' while checking; 'unavailable' when the detector itself
      // failed — then we fall back to the plain 2-photos-or-a-PDF rule so nobody gets stuck)
      var pending = false, unavailable = false, front = false, graph = false, cnt = { front: 0, graph: 0 }, problem = null, latest = null;
      files.forEach(function(f){
        var c = f.cls;
        if (c === 'pending'){ pending = true; return; }
        if (!c || typeof c !== 'object'){ unavailable = true; return; }
        c.bad = false;
        if (c.quality === 'unreadable' || (!c.front && !c.graph)){ c.bad = true; problem = problem || 'That doesn\u2019t look like a page of your bill \u2014 please take a photo of the bill itself.'; return; }
        if (c.quality === 'blurry'){ c.bad = true; problem = problem || 'That photo is too blurry to read \u2014 please retake it in good light.'; return; }
        if (c.quality === 'cut_off'){ c.bad = true; problem = problem || 'Part of that page is cut off \u2014 please retake it with the whole page in frame.'; return; }
        if (c.front){ front = true; cnt.front++; }
        if (c.graph){ graph = true; cnt.graph++; }
        if (c.date && (!latest || c.date > latest)) latest = c.date;
      });
      var old = !!latest && (Date.now() - Date.parse(latest + 'T12:00:00') > SIX_MONTHS);
      if (old) files.forEach(function(f){ var c = f.cls; if (c && typeof c === 'object' && c.date) c.bad = true; });
      renderThumbs();
      var complete = unavailable ? (nPdfs > 0 || nPhotos >= 2) : (front && graph);
      var got = { front: unavailable ? nPdfs > 0 : front, graph: unavailable ? nPdfs > 0 : graph };
      Array.prototype.forEach.call(ov.querySelectorAll('.gss-bill-step[data-ex]'), function(b){
        var k = b.getAttribute('data-ex'), n = b.querySelector('.gss-bill-n');
        b.classList.toggle('gss-done', !!got[k]);
        b.classList.toggle('gss-want', has && !complete && !got[k] && (got.front || got.graph));
        if (n) n.textContent = got[k] ? '\u2713' : (k === 'front' ? '1' : '2');
      });
      var msg = '';
      if (!has) msg = '';
      else if (sending) msg = 'Sending to your coordinator\u2026';
      else if (failed) msg = 'We couldn\u2019t upload that just now.';
      else if (pending) msg = 'Checking your ' + (nPdfs && !nPhotos ? 'bill' : 'photo') + '\u2026';
      else if (problem) msg = problem;
      else if (old) msg = 'This bill is from <b>' + monthName(latest) + '</b> \u2014 please upload one from the last 6 months.';
      else if (unavailable) msg = complete ? '' : '<b>' + nPhotos + ' of 2 pages added.</b> Add the other page to finish.';
      else if (front && !graph) msg = (cnt.front >= 2 ? 'Both photos look like the <b>Front Page</b> \u2014 ' : '<b>Front Page received.</b> ') + 'Now add the <b>Usage Graph</b> page.';
      else if (graph && !front) msg = (cnt.graph >= 2 ? 'Both photos look like the <b>Usage Graph</b> \u2014 ' : '<b>Usage Graph received.</b> ') + 'Now add the <b>Front Page</b>.';
      var st = document.getElementById('gseBillStatus'); if (st){ st.innerHTML = msg; st.hidden = !msg; }
      // rescue link: after a failed upload, or once the detector has turned photos down twice
      var anyway = document.getElementById('gseBillAnyway');
      if (anyway){ var showAnyway = has && !sending && !sent && !pending && (failed || rejects >= 2); anyway.hidden = !showAnyway; anyway.textContent = failed ? 'Try again' : 'Having trouble? Send what you have'; }
      // all set → it sends itself; no button to find
      if (has && complete && !pending && !problem && !old && !sending && !sent && !failed) sendBill();
    }
    function open(){ files = []; sending = false; sent = false; failed = false; rejects = 0; refresh(); show('cap'); ov.hidden = false; }
    function close(){ if (EMBED_BILL) return; ov.hidden = true; }   // embed: the sheet is the whole page (covers the x, Escape and the example viewer's Escape)
    openBill = open;   // let the booked CTA open this overlay
    function addThumb(dataUrl, label){
      var th = document.getElementById('gseBillThumbs'); if (!th) return;
      if (dataUrl){ var t = document.createElement('img'); t.className = 'gss-claim-thumb'; t.src = dataUrl; th.appendChild(t); return; }
      var d = document.createElement('div'); d.className = 'gss-claim-thumb'; d.title = label || 'PDF';
      d.style.display = 'flex'; d.style.alignItems = 'center'; d.style.justifyContent = 'center';
      d.style.background = 'rgba(255,255,255,.08)'; d.style.color = '#fff'; d.style.fontWeight = '800'; d.style.fontSize = '11px';
      d.textContent = 'PDF'; th.appendChild(d);
    }
    // What is this file? The worker asks Gemini which page(s) it holds, whether it's readable, and the bill date — so a
    // lone photo can ask for the other page by name, bad shots get a retake prompt, and bills older than 6 months are caught.
    function isBad(c){ return c.quality !== 'good' || (!c.front && !c.graph) || (!!c.date && Date.now() - Date.parse(c.date + 'T12:00:00') > SIX_MONTHS); }
    // A page photographed sideways or upside-down is turned upright before anything else reads it: the first check
    // carries a 2x2 grid of the photo turned 0/90/180/270 degrees clockwise (numbered panels), the worker asks which
    // panel reads upright and answers which side of the photo the page's top faces, the canvas is redrawn turned, and
    // the upright copy is checked again (with a grid again, so a wrong first answer can be turned back once), shown,
    // merged into the PDF and read by the Scoreboard. At most two turns, so it can never flip back and forth.
    var TURN = { right: -90, bottom: 180, left: 90 };
    function turnGrid(src){
      var cell = 512, g = document.createElement('canvas'); g.width = g.height = cell * 2;
      var x = g.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, g.width, g.height);
      [0, 90, 180, 270].forEach(function(deg, k){
        var side = deg % 180 !== 0, w = side ? src.height : src.width, h = side ? src.width : src.height;
        var s = Math.min((cell - 16) / w, (cell - 16) / h), x0 = (k % 2) * cell, y0 = Math.floor(k / 2) * cell, b = Math.round(cell * 0.12);
        x.save(); x.translate(x0 + cell / 2, y0 + cell / 2); x.rotate(deg * Math.PI / 180);
        x.drawImage(src, -src.width * s / 2, -src.height * s / 2, src.width * s, src.height * s); x.restore();
        x.fillStyle = '#000'; x.fillRect(x0 + 4, y0 + 4, b, b);
        x.fillStyle = '#fff'; x.font = 'bold ' + Math.round(cell * 0.085) + 'px Helvetica, Arial, sans-serif'; x.textAlign = 'center'; x.textBaseline = 'middle';
        x.fillText(String(k + 1), x0 + 4 + b / 2, y0 + 4 + b / 2);
        x.strokeStyle = '#000'; x.lineWidth = 3; x.strokeRect(x0 + 1.5, y0 + 1.5, cell - 3, cell - 3);
      });
      return g.toDataURL('image/jpeg', 0.75).split(',')[1];
    }
    function turnEntry(entry, top){
      var deg = TURN[top], src = entry.cv; if (!deg || !src) return false;
      var side = deg !== 180, cv = document.createElement('canvas');
      cv.width = side ? src.height : src.width; cv.height = side ? src.width : src.height;
      var g = cv.getContext('2d'); g.translate(cv.width / 2, cv.height / 2); g.rotate(deg * Math.PI / 180); g.drawImage(src, -src.width / 2, -src.height / 2);
      var data = cv.toDataURL('image/jpeg', 0.8);
      entry.cv = cv; entry.b64 = data.split(',')[1]; entry.dataUrl = data; entry.turns = (entry.turns || 0) + 1;
      return true;
    }
    function classifyFile(entry, img){
      entry.cls = 'pending';
      var body = { c: leadCode };
      if (img){
        var max = 1000, w = img.width, h = img.height;
        if (w >= h && w > max){ h = Math.round(h * max / w); w = max; } else if (h > w && h > max){ w = Math.round(w * max / h); h = max; }
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h; cv.getContext('2d').drawImage(img, 0, 0, w, h);
        body.photo = cv.toDataURL('image/jpeg', 0.7).split(',')[1];
        if ((entry.turns || 0) < 2){ try { body.grid = turnGrid(cv); } catch (e) {} }
      } else if (entry.b64 && entry.b64.length < 9000000){ body.pdf = entry.b64; }
      else { entry.cls = 'unavailable'; refresh(); return; }
      if (!leadCode || !CFG.workerBase){ entry.cls = 'unavailable'; refresh(); return; }
      fetch(CFG.workerBase.replace(/\/$/, '') + '/bill/classify', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function(r){ return r.json(); })
        .then(function(d){
          var read = (d && !d.error && typeof d.front === 'boolean')
            ? { front: !!d.front, graph: !!d.graph, pge: d.pge_history === true, quality: d.quality || 'good', date: /^\d{4}-\d{2}-\d{2}$/.test(d.bill_date || '') ? d.bill_date : null, stats: (d.stats && typeof d.stats === 'object') ? d.stats : null } : null;
          // keep this read: if the re-check of the turned copy fails (or the turn itself throws), it still gates the upload
          if (read && d.page_top && d.page_top !== 'top' && (entry.turns || 0) < 2){
            var turned = false; try { turned = turnEntry(entry, d.page_top); } catch (e) {}
            if (turned){ entry.preTurn = read; refresh(); classifyFile(entry, entry.cv); return; }
          }
          entry.cls = read || entry.preTurn || 'unavailable';
          if (entry.cls !== 'unavailable' && isBad(entry.cls)) rejects++;
          refresh();
        })
        .catch(function(){ entry.cls = entry.preTurn || 'unavailable'; if (entry.cls !== 'unavailable' && isBad(entry.cls)) rejects++; refresh(); });
    }
    function addFile(f){
      if (!f || !f.type) return;
      if (f.type === 'application/pdf'){
        var r = new FileReader();
        r.onload = function(){ files.push({ name: f.name || 'bill.pdf', type: 'application/pdf', b64: String(r.result).split(',')[1] }); classifyFile(files[files.length - 1], null); refresh(); };
        r.readAsDataURL(f);
      } else if (f.type.indexOf('image') === 0){
        // Several photos picked at once are checked at the same time: each is decoded off the page thread
        // (createImageBitmap) and its check goes out as soon as it is ready, instead of waiting behind the others.
        var use = function(src, cleanup){
          var max = 1500, w = src.width, h = src.height;
          if (w >= h && w > max){ h = Math.round(h * max / w); w = max; } else if (h > w && h > max){ w = Math.round(w * max / h); h = max; }
          var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
          cv.getContext('2d').drawImage(src, 0, 0, w, h);
          if (cleanup) cleanup();
          var data = cv.toDataURL('image/jpeg', 0.8);
          files.push({ name: (f.name ? f.name.replace(/\.[^.]+$/, '') : 'bill') + '.jpg', type: 'image/jpeg', b64: data.split(',')[1], dataUrl: data, cv: cv });
          classifyFile(files[files.length - 1], cv);   // the resized copy: no second full-size decode
          refresh();
        };
        var viaImg = function(){
          var img = new Image(), url = URL.createObjectURL(f);
          img.onload = function(){ use(img, function(){ URL.revokeObjectURL(url); }); };
          img.onerror = function(){ URL.revokeObjectURL(url); };
          img.src = url;
        };
        if (window.createImageBitmap){
          // the fallback only when the decode itself fails, never on an error after the photo was added
          createImageBitmap(f, { imageOrientation: 'from-image' })
            .then(function(bmp){ use(bmp, function(){ if (bmp.close) bmp.close(); }); }, viaImg);
        } else viaImg();
      }
    }
    ['gseBillFile', 'gseBillFileLib'].forEach(function(id){
      var fi = document.getElementById(id); if (!fi) return;
      fi.addEventListener('change', function(){ Array.prototype.forEach.call(fi.files, addFile); fi.value = ''; });
    });
    // Photos → one multi-page PDF (jsPDF, lazy-loaded only when sending); uploaded PDFs pass through unchanged.
    function loadJsPDF(cb){
      if (window.jspdf && window.jspdf.jsPDF) return cb(window.jspdf.jsPDF);
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.onload = function(){ cb(window.jspdf && window.jspdf.jsPDF); };
      s.onerror = function(){ cb(null); };
      document.head.appendChild(s);
    }
    function prepareUpload(done){
      var imgs = files.filter(function(f){ return f.type !== 'application/pdf'; });
      var pdfs = files.filter(function(f){ return f.type === 'application/pdf'; });
      if (!imgs.length) return done(pdfs);
      loadJsPDF(function(JsPDF){
        if (!JsPDF){ done(files); return; }  // CDN blocked → fall back to sending the photos as-is (the field also accepts JPEGs)
        try {
          var doc = new JsPDF({ unit: 'pt', format: 'a4', compress: true });
          var pw = doc.internal.pageSize.getWidth(), ph = doc.internal.pageSize.getHeight(), m = 18;
          imgs.forEach(function(f, i){
            if (i > 0) doc.addPage();
            var du = f.dataUrl || ('data:image/jpeg;base64,' + f.b64);
            var p = doc.getImageProperties(du);
            var r = Math.min((pw - m * 2) / p.width, (ph - m * 2) / p.height);
            var w = p.width * r, h = p.height * r;
            doc.addImage(du, 'JPEG', (pw - w) / 2, (ph - h) / 2, w, h);
          });
          done(pdfs.concat([{ name: 'utility-bill.pdf', type: 'application/pdf', b64: doc.output('datauristring').split(',')[1] }]));
        } catch (e) { done(files); }
      });
    }
    // Upload: runs by itself once the detector is satisfied (see renderBillState), or from the rescue link.
    function sendBill(){
      if (!files.length || sending || sent) return;
      if (!leadCode || !CFG.workerBase){ alert('We couldn’t find your link — please reopen from your text message.'); return; }
      sending = true; failed = false; refresh();
      show('proc');
      var pctEl = document.getElementById('gseBillPct'), pct = 0; if (pctEl) pctEl.textContent = '0%';
      var timer;
      if (noteUi){
        // The Scoreboard popup: the same honest percentage and clock as the Copy Usage Note button after it, so the
        // number never jumps back from this screen's 100 % to the reading's 8 %.
        noteUi.begin();
        var procSub = ov.querySelector('[data-billstep="proc"] .gss-claim-sub');
        if (procSub && procSub.getAttribute('data-gse-orig') == null) procSub.setAttribute('data-gse-orig', procSub.textContent);
        var paintProc = function(){ if (pctEl) pctEl.textContent = noteUi.pct() + '%'; if (procSub) procSub.textContent = noteUi.line(); };
        paintProc(); timer = setInterval(paintProc, 1000);
      }
      else timer = setInterval(function(){ pct = Math.min(92, pct + Math.random() * 10 + 4); if (pctEl) pctEl.textContent = Math.round(pct) + '%'; }, 300);
      var sendFailed = function(){ if (noteUi) noteUi.reset(); var ps = ov.querySelector('[data-billstep="proc"] .gss-claim-sub'); if (ps && ps.getAttribute('data-gse-orig') != null) ps.textContent = ps.getAttribute('data-gse-orig'); };
      // Count what the homeowner added BEFORE photos get merged into one PDF — the worker can't tell
      // 1 photo from 2 once they're merged, and SCE needs both the first page and the usage graph.
      var nPdfs = files.filter(function(f){ return f.type === 'application/pdf'; }).length;
      var nPhotos = files.length - nPdfs;
      prepareUpload(function(uploadList){
        if (!uploadList || !uploadList.length){ clearInterval(timer); sendFailed(); sending = false; failed = true; show('cap'); refresh(); return; }
        fetch(CFG.workerBase.replace(/\/$/, '') + '/bill', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ c: leadCode, files: uploadList, photos: nPhotos, pdfs: nPdfs, bill_date: billDate(), bill_stats: billStats() }) })
          .then(function(r){ return r.json().catch(function(){ return {}; }); })
          .then(function(d){ clearInterval(timer); if (pctEl && !noteUi) pctEl.textContent = '100%'; if (noteUi && d && d.ok) noteUi.stage('queued'); setTimeout(function(){
            if (d && d.ok){ try { track('bill_uploaded', { photos: nPhotos, pdfs: nPdfs }); } catch (e) {} billUploaded = true; sent = true; sending = false; embedPost('gs-uploadbill-state', { sending: false, sent: true }); try { renderBookedCta(); } catch (e) {} try { if (typeof gssPaintLearn === 'function') gssPaintLearn(); } catch (e) {} try { var cf = slideEl('confirm'); if (cf && cf.classList.contains('active')) setupConfirm(); } catch (e) {} renderBillStats(); show('done'); pollBillRead(); }
            else { sendFailed(); sending = false; failed = true; show('cap'); refresh(); }
          }, 250); })
          .catch(function(){ clearInterval(timer); sendFailed(); sending = false; failed = true; show('cap'); refresh(); });
      });
    }
    var sendBtn = document.getElementById('gseBillSend'); if (sendBtn) sendBtn.addEventListener('click', sendBill);   // fallback markup only
    ov.addEventListener('click', function(e){ if (e.target && e.target.id === 'gseBillAnyway'){ failed = false; sendBill(); } });
    var x = document.getElementById('gseBillClose'); if (x){ if (EMBED_BILL) x.style.display = 'none'; else x.addEventListener('click', close); }
    var dn = document.getElementById('gseBillDone'); if (dn) dn.addEventListener('click', function(){
      if (!EMBED_BILL) return close();
      embedPost('gs-uploadbill-done', { sent: sent });           // the Scoreboard closes its popup
      if (window.parent === window){                             // opened on the real URL, not in the Scoreboard frame
        try { window.close(); } catch (e) {}                     // works when a script opened the tab
        setTimeout(function(){ dn.textContent = 'Uploaded. You can close this tab.'; dn.disabled = true; }, 300);
      }
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !ov.hidden) close(); });
    var ub = document.getElementById('gssUploadBill');
    if (ub) ub.addEventListener('click', function(){ if (typeof closeCtaMenu === 'function') closeCtaMenu(); open(); });
    if (ROOT && ROOT.querySelectorAll) ROOT.querySelectorAll('[data-bill-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); open(); }); });
    if (EMBED_BILL || /uploadbill/i.test(location.hash || '')) open();
  })();

  /* ---- closer claim-submission view: the minted link + #claimsubmission loads that customer's claim
     for the coordinator. CHROME-EXTENSION CONTRACT:
       • <html data-gs-claim="ready" data-gs-claim-code data-gs-claim-utility>  ← detect + route
       • <script id="gsClaimData" type="application/json">{full claim, absolute photo URLs, contact_endpoint}</script>
       • clicking #gseCloserSubmit fires a 'gs-claim-submit' CustomEvent (detail = the claim)
       • the extension sets <html data-gs-ext="1"> to suppress the manual fallback, and pulls phone/email from
         claimData.contact_endpoint sending header x-gs-closer-key: <CLOSER_KEY> (never exposed in the page). ---- */
  (function initCloser(){
    if (!/claimsubmission/i.test(location.hash || '')) return;
    var ov = document.getElementById('gseCloserOv'); if (!ov) return;
    ov.hidden = false;
    function txt(id, t){ var el = document.getElementById(id); if (el) el.textContent = t; }
    if (!leadCode || !CFG.workerBase){ txt('gseCloserName', 'Missing link'); txt('gseCloserMeta', 'Open this from a customer’s link (…/vpp/CODE#claimsubmission).'); return; }
    fetch(CFG.workerBase.replace(/\/$/, '') + '/claim?c=' + encodeURIComponent(leadCode) + '&contact=1')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (d && d.expired){ txt('gseCloserName', 'Claim expired'); txt('gseCloserMeta', 'The 7-day express window for this claim has passed.'); return; }
        if (!d || !d.ok || !d.found){ txt('gseCloserName', 'No claim yet'); txt('gseCloserMeta', 'This customer hasn’t prepared a spoilage claim.'); return; }
        var c = d.claimant || {};
        txt('gseCloserName', c.name || d.code);
        txt('gseCloserMeta', (c.address || '') + (d.utility ? ' · ' + d.utility : ''));
        var fmtPhone = function(p){ var x = String(p || '').replace(/\D/g, ''); if (x.length === 11 && x.charAt(0) === '1') x = x.slice(1); return x.length === 10 ? ('(' + x.slice(0, 3) + ') ' + x.slice(3, 6) + '-' + x.slice(6)) : (p || ''); };
        var cinfo = []; if (d.contact){ if (d.contact.phone) cinfo.push(fmtPhone(d.contact.phone)); if (d.contact.email) cinfo.push(d.contact.email); }
        if (cinfo.length){ var metaEl = document.getElementById('gseCloserMeta'); if (metaEl && !document.getElementById('gseCloserContact')){ var cl2 = document.createElement('p'); cl2.className = 'gss-closer-meta'; cl2.id = 'gseCloserContact'; cl2.style.marginTop = '2px'; cl2.textContent = cinfo.join(' · '); metaEl.parentNode.insertBefore(cl2, metaEl.nextSibling); } }
        txt('gseCloserStatus', (d.status || '') + (typeof d.days_left === 'number' ? ' · express: ' + d.days_left + 'd left' : ''));
        var haulEl = document.getElementById('gseCloserHaul');
        if (haulEl){ if (d.haul_date){ var hp = String(d.haul_date).split('-'), hm = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']; haulEl.textContent = 'Last grocery haul: ' + (hp.length === 3 ? (hm[parseInt(hp[1], 10) - 1] || '') + ' ' + parseInt(hp[2], 10) + ', ' + hp[0] : d.haul_date); haulEl.hidden = false; } else { haulEl.hidden = true; } }
        txt('gseCloserTotal', '$' + (Number(d.total) || 0).toFixed(2));
        var tbl = document.getElementById('gseCloserTable'); tbl.innerHTML = '';
        (d.items || []).forEach(function(it){
          var row = document.createElement('div'); row.className = 'gss-closer-row';
          var desc = document.createElement('div'); desc.className = 'gss-cr-desc'; desc.textContent = it.description || ''; row.appendChild(desc);
          var sub = document.createElement('div'); sub.className = 'gss-cr-sub';
          var left = document.createElement('span'); left.textContent = [it.brand, it.qty].filter(Boolean).join(' · ') || '—';
          var cost = document.createElement('span'); cost.className = 'cost'; cost.textContent = '$' + (Number(it.replacement_cost) || 0).toFixed(2);
          sub.appendChild(left); sub.appendChild(cost); row.appendChild(sub);
          tbl.appendChild(row);
        });
        var form = document.getElementById('gseCloserForm');
        if (form && d.claim_form_url){ form.href = d.claim_form_url; form.textContent = 'Open the ' + (d.utility || '') + ' claim form manually ↗'; }
        else if (form){ form.style.display = 'none'; }
        // ---- extension-ready data hook + submit trigger (see CHROME-EXTENSION CONTRACT above) ----
        var WB = CFG.workerBase.replace(/\/$/, '');
        var claimData = { code: d.code, status: d.status, utility: d.utility, claim_form_url: d.claim_form_url || '', total: d.total, haul_date: d.haul_date || '', days_left: d.days_left, claimant: d.claimant || null, items: d.items || [], photos: (d.photos || []).map(function(p){ return { key: p.key, url: WB + p.url }; }), contact: d.contact || null };
        var dataEl = document.getElementById('gsClaimData'); if (!dataEl){ dataEl = document.createElement('script'); dataEl.type = 'application/json'; dataEl.id = 'gsClaimData'; document.body.appendChild(dataEl); }
        dataEl.textContent = JSON.stringify(claimData);
        var de = document.documentElement; de.setAttribute('data-gs-claim', 'ready'); de.setAttribute('data-gs-claim-code', d.code || ''); de.setAttribute('data-gs-claim-utility', d.utility || '');
        var submit = document.getElementById('gseCloserSubmit');
        if (!submit){ submit = document.createElement('button'); submit.type = 'button'; submit.id = 'gseCloserSubmit'; submit.className = 'gss-bookbtn gss-claim-go'; submit.textContent = 'Process Express Claim'; if (form && form.parentNode) form.parentNode.insertBefore(submit, form); else { var card = ov.querySelector('.gss-closer-card'); if (card) card.appendChild(submit); } }
        submit.addEventListener('click', function(){
          document.dispatchEvent(new CustomEvent('gs-claim-submit', { detail: claimData }));
          if (de.getAttribute('data-gs-ext') !== '1' && d.claim_form_url){ window.open(d.claim_form_url, '_blank', 'noopener'); }
        });
        var pc = document.getElementById('gseCloserPhotos'); if (pc){ pc.innerHTML = ''; (d.photos || []).forEach(function(p){ var im = document.createElement('img'); im.src = CFG.workerBase.replace(/\/$/, '') + p.url; pc.appendChild(im); }); }
        var copy = document.getElementById('gseCloserCopy');
        if (copy) copy.addEventListener('click', function(){
          var lines = (d.items || []).map(function(it){ return (it.description || '') + (it.brand ? ' (' + it.brand + ')' : '') + ' — ' + (it.qty || '') + ' — $' + (Number(it.replacement_cost) || 0).toFixed(2); });
          lines.push('TOTAL: $' + (Number(d.total) || 0).toFixed(2));
          if (navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(lines.join('\n')); copy.textContent = 'Copied ✓'; setTimeout(function(){ copy.textContent = 'Copy list to clipboard'; }, 1500); }
        });
        // full-screen layout: scrolling body + a docked split-button footer (total lives in the primary button;
        // "open manually" + "copy" become a dropdown). Idempotent; works on flat markup too.
        var ccard = ov.querySelector('.gss-closer-card');
        if (ccard && !ccard.querySelector('.gss-closer-scroll')){
          var cscroll = document.createElement('div'); cscroll.className = 'gss-closer-scroll';
          while (ccard.firstChild) cscroll.appendChild(ccard.firstChild);
          ccard.appendChild(cscroll);
          var totEl = cscroll.querySelector('.gss-closer-total'); if (totEl) totEl.style.display = 'none';
          var cfoot = document.createElement('div'); cfoot.className = 'gss-closer-foot';
          var csplit = document.createElement('div'); csplit.className = 'gss-closer-split';
          var primary = cscroll.querySelector('#gseCloserSubmit');
          if (primary){ primary.classList.add('gss-closer-primary'); primary.textContent = 'Process Express Claim · $' + (Number(d.total) || 0).toFixed(2); }
          var caret = document.createElement('button'); caret.type = 'button'; caret.className = 'gss-closer-caret'; caret.id = 'gseCloserMore'; caret.setAttribute('aria-label', 'More options'); caret.textContent = '▾';
          var menu = document.createElement('div'); menu.className = 'gss-closer-menu'; menu.id = 'gseCloserMenu'; menu.hidden = true;
          var formEl = cscroll.querySelector('#gseCloserForm'); var copyEl = cscroll.querySelector('#gseCloserCopy');
          if (formEl) menu.appendChild(formEl);
          if (copyEl) menu.appendChild(copyEl);
          if (primary) csplit.appendChild(primary);
          csplit.appendChild(caret); csplit.appendChild(menu);
          cfoot.appendChild(csplit); ccard.appendChild(cfoot);
          caret.addEventListener('click', function(e){ e.stopPropagation(); menu.hidden = !menu.hidden; });
          menu.addEventListener('click', function(e){ e.stopPropagation(); });
          document.addEventListener('click', function(){ menu.hidden = true; });
          // desktop = full-width card + tile grid (JS-applied so it works even if the CSS asset isn't re-uploaded)
          var gsTiles = function(){
            var t = document.getElementById('gseCloserTable'), desk = window.innerWidth >= 760;
            if (t){ if (desk){ t.style.display = 'grid'; t.style.gridTemplateColumns = 'repeat(auto-fill, minmax(240px, 1fr))'; t.style.gap = '10px'; t.style.alignContent = 'start'; } else { t.style.display = ''; t.style.gridTemplateColumns = ''; t.style.gap = ''; t.style.alignContent = ''; } }
            ccard.style.maxWidth = desk ? 'none' : '';
          };
          gsTiles(); window.addEventListener('resize', gsTiles);
        }
      })
      .catch(function(){ txt('gseCloserName', 'Could not load'); txt('gseCloserMeta', 'Try refreshing.'); });
  })();

  /* ============================================================
     SEEDED RNG
  ============================================================ */
  function seeded(str){
    var h = 2166136261;
    for (var i=0;i<str.length;i++){ h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return function(){
      h = Math.imul(h ^ (h>>>15), 2246822519);
      h = Math.imul(h ^ (h>>>13), 3266489917);
      return ((h ^= h>>>16) >>> 0) / 4294967296;
    };
  }
  /* rng is created in initPage() once the lead is resolved */

  /* ============================================================
     SATELLITE ROOF SCAN
  ============================================================ */
  var satImg = document.getElementById('gseSatImg');

  var panels, kw, offset, pwUnits, zone;

  function initStats(){
    panels = 14 + Math.floor(rng()*13);
    kw = (panels * 0.41).toFixed(1);
    offset = Math.min(105, 78 + Math.floor(rng()*28));
    pwUnits = panels > 20 ? 3 : 2;
    // RNG fallback for the zone metrics (preview / no worker / geocode miss).
    zone = {
      outages: 5 + Math.floor(rng()*14),
      homes: 300 + Math.floor(rng()*1700),
      food_total: 0, tier: 2, tier_label: 'Moderate', window_days: 30, in_hfra: false
    };
    zone.food_total = zone.homes * 300;
  }

  function fmtMoney(n){
    n = Math.round(Number(n) || 0);
    if (n >= 1e9) return '$' + (n/1e9).toFixed(n >= 1e10 ? 0 : 1).replace(/\.0$/,'') + 'B';
    if (n >= 1e6) return '$' + (n/1e6).toFixed(n >= 1e7 ? 0 : 1).replace(/\.0$/,'') + 'M';
    if (n >= 1e3) return '$' + Math.round(n/1e3) + 'K';
    return '$' + n;
  }
  // Compact counts for the big 12-month projections: 2500→2.5K, 250000→250K, 2.5M, 1.3B.
  function fmtCount(n){
    n = Math.round(Number(n) || 0);
    if (n >= 1e9) return (n/1e9).toFixed(n >= 1e10 ? 0 : 1).replace(/\.0$/,'') + 'B';
    if (n >= 1e6) return (n/1e6).toFixed(n >= 1e7 ? 0 : 1).replace(/\.0$/,'') + 'M';
    if (n >= 1e4) return Math.round(n/1e3) + 'K';
    if (n >= 1e3) return (n/1e3).toFixed(1).replace(/\.0$/,'') + 'K';
    return String(n);
  }

  /* ---- real grid-stress intel from the Worker (/insights), with RNG fallback ---- */
  var zoneRevealed = false;
  var insightsData = null;   // full /insights payload (incl. lat/lng + outage points) for the map
  function revealZone(d){
    if (zoneRevealed) return; zoneRevealed = true;
    hideLoading();
    // Reveal the 12-month projection first; the flip alternates to "last N days" every 10s.
    var pWin = d.window_days || 30;
    var pO = (d.expected_year != null) ? d.expected_year : Math.round((d.outages || 0) / pWin * 365);
    var pH = Math.round((d.homes || 0) / pWin * 365);
    var pF = Math.round((d.food_total || 0) / pWin * 365);
    countUp('gseZOutages', pO, fmtCount);
    countUp('gseZHomes', pH, fmtCount);
    countUp('gseZSpoil', pF, fmtMoney);
    var win = document.getElementById('gseZWindow');
    if (win) win.textContent = d.window_days ? ('last ' + d.window_days + ' days') : 'recent weeks';
    var tierEl = document.getElementById('gseTier');
    if (tierEl && d.tier_label){
      tierEl.textContent = 'Stress Tier ' + (d.tier || 2) + ' · ' + d.tier_label;
      tierEl.className = 'gss-tier-ov tier-' + (d.tier || 2);
      tierEl.hidden = false;
    }
    var fireEl = document.getElementById('gseHFRA');
    if (fireEl && d.in_hfra){ fireEl.hidden = false; var sv = document.getElementById('gseSat'); if (sv) sv.classList.add('gss-has-fire'); }
    setupStatsFlip(d);
    requestAnimationFrame(fitStats);
    // Desktop landing on Learn: paintLearn held the copy at the home copy's height before these pills were filled.
    // Filled (and rewrapped, at 821-1000 px wide or on a short window) the home copy is taller, so once the count-up
    // (1.3 s) is done, hold the Learn copy at the real height again or the tabs jump on the first switch to Your home.
    setTimeout(function(){
      var c = ROOT.querySelector('.gss-intro-copy');
      if (typeof gssPaintLearn === 'function' && c && c.classList.contains('gss-learn-on') && !gssMqFull.matches) gssPaintLearn();
    }, 1400);
  }

  // The 3 stat pills alternate between the realized "last N days" snapshot (the worker's window, 90 days) and
  // a 12-month projection (annualized from the same local data) — a flash on each
  // switch draws the eye and makes the forward risk concrete.
  function setupStatsFlip(d){
    var win = d.window_days || 30;
    var fO = (d.expected_year != null) ? d.expected_year : Math.round((d.outages || 0) / win * 365);
    var fH = Math.round((d.homes || 0) / win * 365);
    var fF = Math.round((d.food_total || 0) / win * 365);
    var winLabel = win ? ('last ' + win + ' days') : 'recent weeks';
    var modes = [
      { o:fmtCount(d.outages||0), h:fmtCount(d.homes||0), f:fmtMoney(d.food_total||0),
        oL:'outages', hL:'homes affected', fL:'food lost',
        cap:'Within 5 miles of your home · ' + winLabel },
      { o:fmtCount(fO), h:fmtCount(fH), f:fmtMoney(fF),
        oL:'outages', hL:'homes affected', fL:'food at risk',
        cap:'Within 5 miles of your home · next 12 months' }
    ];
    function setPill(vid, lid, val, lab){
      var v=document.getElementById(vid), l=document.getElementById(lid), p=v?v.closest('.gss-zpill'):null;
      if(v) v.textContent=val; if(l) l.innerHTML=lab;
      if(p){ p.classList.remove('gss-flash'); void p.offsetWidth; p.classList.add('gss-flash'); }
    }
    function paint(m){
      setPill('gseZOutages','gseZOutagesL',m.o,m.oL); setPill('gseZHomes','gseZHomesL',m.h,m.hL); setPill('gseZSpoil','gseZSpoilL',m.f,m.fL);
      var cap=document.getElementById('gseZCapTxt'); if(cap) cap.textContent=m.cap;
    }
    // Show the 12-month projection first (labels + caption); count-up already set its values.
    var sp0 = document.getElementById('gseZOutagesL'); if (sp0) sp0.innerHTML = modes[1].oL;
    var sp1 = document.getElementById('gseZHomesL');   if (sp1) sp1.innerHTML = modes[1].hL;
    var sp2 = document.getElementById('gseZSpoilL');   if (sp2) sp2.innerHTML = modes[1].fL;
    var capEl0 = document.getElementById('gseZCapTxt'); if (capEl0) capEl0.textContent = modes[1].cap;
    var idx = 1;
    setInterval(function(){ idx = idx ? 0 : 1; paint(modes[idx]); }, 10000);
  }

  function initInsights(){
    var fallback = { outages: zone.outages, homes: zone.homes, food_total: zone.food_total, tier: zone.tier,
      tier_label: zone.tier_label, window_days: zone.window_days, in_hfra: zone.in_hfra };
    if (leadCode && CFG.workerBase){
      var done = false;
      var t = setTimeout(function(){ if (!done){ done = true; revealZone(fallback); } }, 2500);
      fetch(CFG.workerBase.replace(/\/$/,'') + '/insights?c=' + encodeURIComponent(leadCode))
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(d){
          if (done) return; done = true; clearTimeout(t);
          if (d && d.available){ insightsData = d; revealZone(d); applyInsightsToMap(); }
          else { if (d && d.in_hfra) fallback.in_hfra = true; revealZone(fallback); }
        })
        .catch(function(){ if (!done){ done = true; clearTimeout(t); revealZone(fallback); } });
    } else {
      revealZone(fallback);
    }
  }

  function countUp(id, target, fmt){
    var el = document.getElementById(id);
    if (!el) return;
    var t0 = null, dur = 1300;
    function tick(t){
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0)/dur), eased = 1 - Math.pow(1-p, 3);
      el.textContent = fmt(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function startScan(){}

  function canvasFallback(){
    var cv = document.getElementById('gseSatFallback');
    cv.hidden = false; satImg.hidden = true;
    var c = cv.getContext('2d');
    c.fillStyle = '#10141d'; c.fillRect(0,0,640,400);
    var frng = seeded('roofs' + lead.zip);
    for (var i=0;i<9;i++){
      var x = 30 + frng()*520, y = 30 + frng()*300, w = 50+frng()*90, hgt = 40+frng()*70;
      c.fillStyle = 'rgba(' + Math.round(40+frng()*30) + ',' + Math.round(46+frng()*30) + ',' + Math.round(60+frng()*30) + ',1)';
      c.save(); c.translate(x+w/2, y+hgt/2); c.rotate((frng()-0.5)*0.5);
      c.fillRect(-w/2,-hgt/2,w,hgt); c.restore();
    }
    c.strokeStyle = 'rgba(52,199,89,.9)'; c.lineWidth = 3;
    c.strokeRect(250, 140, 150, 110);
    startScan();
  }

  function initSatellite(){
    if (CFG.mapsKey) {
      satImg.src = 'https://maps.googleapis.com/maps/api/staticmap'
        + '?center=' + encodeURIComponent(fullAddr)
        + '&zoom=20&size=640x400&scale=2&maptype=satellite&key=' + encodeURIComponent(CFG.mapsKey);
      satImg.onload = startScan;
      satImg.onerror = canvasFallback;
    } else {
      canvasFallback();
    }
  }

  /* ============================================================
     HERO TOGGLE — roof scan ↔ live outage map (Google Maps JS API,
     loaded lazily on first switch). Pins are non-clustered: a green
     home marker + red outage markers sized by customers affected,
     inside the 5-mile radius.
  ============================================================ */
  var mapsApiPromise = null, outageMap = null;
  function loadMapsApi(){
    if (mapsApiPromise) return mapsApiPromise;
    if (window.google && window.google.maps) { mapsApiPromise = Promise.resolve(); return mapsApiPromise; }
    mapsApiPromise = new Promise(function(resolve, reject){
      if (!CFG.mapsKey) { reject(new Error('no key')); return; }
      var cb = 'gseMapsCb_' + Math.floor(Math.random()*1e9);
      var to = setTimeout(function(){ reject(new Error('timeout')); }, 8000);
      window[cb] = function(){ clearTimeout(to); resolve(); };
      var s = document.createElement('script');
      s.async = true; s.defer = true;
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(CFG.mapsKey) + '&callback=' + cb + '&loading=async';
      s.onerror = function(){ clearTimeout(to); reject(new Error('load')); };
      document.head.appendChild(s);
    });
    return mapsApiPromise;
  }

  var houseMarker = null, radiusCircle = null, outageMarkers = [];
  function applyInsightsToMap(){
    if (!outageMap || !insightsData || typeof insightsData.lat !== 'number') return;
    var center = { lat: insightsData.lat, lng: insightsData.lng };
    outageMap.setCenter(center);
    if (houseMarker) houseMarker.setMap(null);
    houseMarker = new google.maps.Marker({
      position: center, map: outageMap, zIndex: 9999, title: 'Your home',
      icon: { path: google.maps.SymbolPath.CIRCLE, scale: 9, fillColor: '#34c759', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 3 }
    });
    if (radiusCircle) radiusCircle.setMap(null);
    radiusCircle = new google.maps.Circle({
      map: outageMap, center: center, radius: 8047,   // 5 mi
      strokeColor: '#34c759', strokeOpacity: 0.7, strokeWeight: 1.5, fillColor: '#34c759', fillOpacity: 0.06, clickable: false
    });
    // Frame the whole 5-mile radius so it's obvious the stats are local to them.
    if (radiusCircle.getBounds) outageMap.fitBounds(radiusCircle.getBounds());
    outageMarkers.forEach(function(m){ m.setMap(null); }); outageMarkers = [];
    // Past/current outages red; scheduled (planned/future) yellow. Sized by customers affected.
    (insightsData.points || []).forEach(function(p){
      var sc = Math.max(4, Math.min(15, Math.sqrt(p.c || 1) / 2.2));
      var color = (p.k === 's') ? '#ffcc00' : '#ff3b30';
      outageMarkers.push(new google.maps.Marker({
        position: { lat: p.lat, lng: p.lng }, map: outageMap, clickable: false, zIndex: (p.k === 's' ? 3 : 2),
        icon: { path: google.maps.SymbolPath.CIRCLE, scale: sc, fillColor: color, fillOpacity: 0.78, strokeColor: '#fff', strokeWeight: 0.6 }
      }));
    });
  }

  var DARK_MAP_STYLE = [
    { elementType: 'geometry', stylers: [{ color: '#1d2127' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#1d2127' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#9aa0a6' }] },
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#181b21' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#2c313a' }] },
    { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#8a9099' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#3a4150' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#0c1018' }] }
  ];

  function initOutageMap(){
    if (outageMap || !(window.google && window.google.maps)) return;
    var center = (insightsData && typeof insightsData.lat === 'number')
      ? { lat: insightsData.lat, lng: insightsData.lng }
      : { lat: 32.99, lng: -117.07 };
    var dark = ROOT.classList.contains('gse-dark');
    outageMap = new google.maps.Map(document.getElementById('gseMap'), {
      center: center, zoom: 11, mapTypeId: 'roadmap',
      disableDefaultUI: true, zoomControl: false, keyboardShortcuts: false,
      gestureHandling: 'greedy', clickableIcons: false,
      styles: dark ? DARK_MAP_STYLE : []
    });
    var zc = document.getElementById('gseMapZoom');
    if (zc && !zc.dataset.wired){
      zc.dataset.wired = '1';
      zc.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){ outageMap.setZoom(outageMap.getZoom() + (b.dataset.z === 'in' ? 1 : -1)); });
      });
    }
    applyInsightsToMap();
  }

  var gssShowView = null, gssPaintLearn = null;
  (function initViewToggle(){
    var toggle = document.getElementById('gseVToggle');
    if (!toggle) return;
    var satView = document.getElementById('gseSat');
    var mapWrap = document.getElementById('gseMapWrap');
    var vppView = document.getElementById('gseVPP');
    var liveView = document.getElementById('gseLive');
    var spoilView = document.getElementById('gseSpoil');
    var note = document.getElementById('gseMapNote');
    // "Learn" (the VPP card's view): the copy under the panel becomes the explainer and the Continue
    // button becomes a link to Tesla's Virtual Power Plant page for the homeowner's utility.
    var copy = ROOT.querySelector('.gss-intro-copy');
    var learnTab = toggle.querySelector('.gss-vtab[data-view="vpp"]');
    if (learnTab) learnTab.textContent = 'Learn';   // the liquid may still read "Why VPP?"
    // The card above already says what a VPP is; this block says what happens for THIS home. {fn} and
    // {utility} fill from the lead (initPage), the Tesla utility from teslaVppUtility().
    var LEARN = {
      eyebrow: '',      // Dion: "Virtual Power Plant" was on the screen 4 or 5 times
      headline: 'Participate in your neighborhood\u2019s power plant.',   // Dion's wording, 2026-10-07
      lead: 'A Virtual Power Plant links thousands of home batteries into one resource the grid can call on when demand peaks. Yours keeps your home running in an outage, and the power it shares at peak is credited back to you.',
      items: [],        // Dion: no 1-2-3 steps; keep it simple
      // Under the paragraph: what the home does for the grid and the neighborhood (Dion's framing). Single lines, no numbers.
      caption: 'What your home does',
      points: ['Help stabilize the grid', 'Reduce rotating outages in your area', 'Provide power to your neighbors'],   // Dion's three only
      teslaSub: '',     // Dion: no sub-lines on either button
      uploadSub: ''
    };
    if (copy && !document.getElementById('gseLearn')){
      var bolt = '<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z"/></svg>';
      var ext = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg>';
      var cam = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 4h-5L8 6H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-4l-1.5-2Z"/><circle cx="12" cy="13" r="3.5"/></svg>';
      var learn = document.createElement('div'); learn.className = 'gss-learn'; learn.id = 'gseLearn';
      learn.innerHTML =
        (LEARN.eyebrow ? '<div class="gss-eyebrow">' + bolt + LEARN.eyebrow + '</div>' : '') +
        '<h2 class="gss-learn-h1">' + LEARN.headline + '</h2>' +   // not .gss-h1: fitHeadline() measures the first .gss-h1
        (LEARN.lead ? '<p class="gss-learn-lead">' + LEARN.lead + '</p>' : '') +   // not .gss-sub: applyBookedState rewrites the intro's first .gss-sub
        (LEARN.points && LEARN.points.length ? (LEARN.caption ? '<div class="gss-zcap gss-learn-cap">' + bolt + '<span>' + LEARN.caption + '</span></div>' : '') +
          '<ul class="gss-learn-list">' + LEARN.points.map(function(t){ return '<li>' + t + '</li>'; }).join('') + '</ul>' : '') +
        (LEARN.items.length ? '<div class="gss-learn-steps">' + LEARN.items.map(function(it, i){
          return '<div class="gss-learn-step"><span class="gss-learn-n">' + (i + 1) + '</span><div><b>' + it[0] + '</b><span>' + it[1] + '</span></div></div>';
        }).join('') + '</div>' : '');
      copy.insertBefore(learn, copy.firstChild);
      // Bottom dock: Upload Bill (a booked home with no bill on file) above the Tesla link; with no review booked,
      // paintLearn() moves Continue in under it, and on the day of the review the Join Meeting split button.
      var dock = document.createElement('div'); dock.className = 'gss-learn-dock'; dock.id = 'gseLearnDock';
      dock.innerHTML =
        '<button type="button" class="gss-cta gss-cta-upload" id="gseLearnUpload" hidden><span class="gss-cta-main"><span>Upload Bill</span>' + cam + '</span>' + (LEARN.uploadSub ? '<span class="gss-cta-sub">' + LEARN.uploadSub + '</span>' : '') + '</button>' +
        '<a class="gss-cta gss-cta-learn" id="gseLearnCta" target="_blank" rel="noopener" href="' + teslaVppUrl() + '"><span class="gss-cta-main"><span>Virtual Power Plant with <span data-gse="vpp-utility">SCE</span></span>' + ext + '</span>' + (LEARN.teslaSub ? '<span class="gss-cta-sub">' + LEARN.teslaSub + '</span>' : '') + '</a>';
      // After Continue and the booked split button: goTo() finds the Continue button as the first .gss-cta.
      var splitBtn = document.getElementById('gssBookedCta'), startBtn = document.getElementById('gssStart');
      var after = (splitBtn && splitBtn.parentNode === copy) ? splitBtn : (startBtn && startBtn.parentNode === copy) ? startBtn : null;
      if (after) copy.insertBefore(dock, after.nextSibling); else copy.appendChild(dock);
      document.getElementById('gseLearnUpload').addEventListener('click', function(){ track('upload_click', { from: 'learn' }); if (typeof openBill === 'function') openBill(); });   // upload_click: dashboard only
    }
    // Continue under the Tesla link (Dion 2026-10-10): with no review booked, Learn shows the regular Continue right
    // under "Virtual Power Plant with {utility}". It is the same #gssStart, moved into the dock, so its click handler,
    // its label (a past review's "Schedule another time" included) and flow_started stay exactly as on the other tabs.
    // A comment marks its home in the copy column: paintLearn() puts it back there whenever Learn is off, a review is
    // booked, or it measures the home copy. goTo() finds it by id wherever it sits.
    var startEl = document.getElementById('gssStart'), startHome = null;
    if (startEl && startEl.parentNode){ startHome = document.createComment(' gssStart home '); startEl.parentNode.insertBefore(startHome, startEl); }
    function placeStart(inDock){
      if (!startEl || !startHome || !startHome.parentNode) return;
      var dk = document.getElementById('gseLearnDock'), vpp = document.getElementById('gseLearnCta');
      var toDock = !!(inDock && dk && vpp && vpp.parentNode === dk);
      if (toDock){ if (vpp.nextSibling !== startEl) dk.insertBefore(startEl, vpp.nextSibling); }
      else if (startHome.nextSibling !== startEl) startHome.parentNode.insertBefore(startEl, startHome.nextSibling);
      startLabel(toDock);
    }
    // Under the Tesla link it reads "Check Eligibility", with no arrow (Dion 2026-10-10); back home, on the other tabs,
    // "Continue" and its arrow as the section has them. Only that plain label is swapped: a past review's "Schedule
    // another time" (and its arrow) is left alone.
    function startLabel(inDock){
      var m = startEl.querySelector('.gss-cta-main'), t = m && m.firstChild;
      if (!t || t.nodeType !== 3) return;
      var cur = t.data.trim(), want = inDock ? 'Check Eligibility' : 'Continue';
      if (cur !== 'Continue' && cur !== 'Check Eligibility') return;
      if (cur !== want) t.data = t.data.replace(cur, want);
      var arrow = m.querySelector('svg'); if (arrow) arrow.style.display = inDock ? 'none' : '';
    }
    // Join Meeting under the Tesla link (Dion 2026-10-10): on the day of the review Learn is the landing tab, and the
    // REAL booked split button (#gssBookedCta: Join Meeting + its caret menu with Upload Bill, Copy Meeting Link, More
    // Options, Reschedule, Cancel) sits right under "Virtual Power Plant with {utility}". Moved, not copied, the way
    // Continue is: every handler finds it by id, and the outside-click check (splitEl.contains) still sees its menu.
    // Its label and sub-line stay as renderBookedCta wrote them. A comment marks its home (right after Continue, as in
    // the liquid): paintLearn() sends it back whenever Learn is off, the review is not today, or it measures the home copy.
    var joinEl = document.getElementById('gssBookedCta'), joinHome = null;
    if (joinEl && joinEl.parentNode){ joinHome = document.createComment(' gssBookedCta home '); joinEl.parentNode.insertBefore(joinHome, joinEl); }
    function placeJoin(inDock){
      if (!joinEl || !joinHome || !joinHome.parentNode) return;
      var dk = document.getElementById('gseLearnDock'), vpp = document.getElementById('gseLearnCta');
      if (inDock && dk && vpp && vpp.parentNode === dk){ if (vpp.nextSibling !== joinEl) dk.insertBefore(joinEl, vpp.nextSibling); }
      else if (joinHome.nextSibling !== joinEl) joinHome.parentNode.insertBefore(joinEl, joinHome.nextSibling);
    }
    function paintLearn(){
      var u = teslaVppUtility();
      ROOT.querySelectorAll('[data-gse="vpp-utility"]').forEach(function(el){ el.textContent = u; });
      var a = document.getElementById('gseLearnCta'); if (a) a.href = teslaVppUrl();
      // The day of the review (not the closer embed, which never shows Learn): Join Meeting under the Tesla link.
      var reviewDay = !EMBED_BILL && !!(bookedAppt && bookedAppt.sameDay && !bookedAppt.past);
      // Upload Bill only for a homeowner whose review is booked and who has no bill on file yet; on the review day it
      // is not a dock button, it is in the Join Meeting caret menu (Dion 2026-10-10).
      var showUp = !!(bookedAppt && !bookedAppt.past && !billUploaded) && !reviewDay;
      var up = document.getElementById('gseLearnUpload'); if (up) up.hidden = !showUp;
      var dk = document.getElementById('gseLearnDock'); if (dk) dk.classList.toggle('has-upload', showUp);
      var slide = ROOT.querySelector('.gss-slide[data-slide="intro"]'), learnOn = !!(copy && copy.classList.contains('gss-learn-on'));
      // Continue under the Tesla link: Learn on, no review booked (the split button replaces Continue for a booked one;
      // a past review keeps Continue, as on the other tabs), never the closer embed. Never together with Upload Bill.
      var showStart = learnOn && !EMBED_BILL && !(bookedAppt && !bookedAppt.past);
      if (dk) dk.classList.toggle('has-start', showStart);
      var showJoin = learnOn && reviewDay;
      if (dk) dk.classList.toggle('has-join', showJoin);
      // Two bottom buttons (Upload Bill, Continue or Join Meeting, plus the Tesla link) need more room under the copy on a phone.
      if (slide){ slide.classList.toggle('gss-learn-view', learnOn); slide.classList.toggle('gss-learn-tall', (showUp || showStart || showJoin) && learnOn); slide.classList.toggle('gss-learn-video', learnOn && videoMode); }
      // Desktop: the Learn copy is shorter than the home copy, and the slide centres the whole block, so the tabs
      // dropped on Learn. Hold the copy column at the home copy's height (measured with the class off, no paint
      // between; the copy column only, since the panels beside it are mid-switch here). Continue goes home first: the
      // home copy is measured as the other tabs show it, Continue included. With Continue under the Tesla link the Learn
      // copy can come out TALLER than the home copy (about 50 px at 1280 wide), which lifted the tabs instead: the extra
      // goes back as a negative bottom margin, so the row keeps the home height and the copy just runs a little lower.
      // Only as far as the window has room: on a short laptop window that lower copy pushed Continue past the slide's
      // content bottom (cut off, the slide scrolling). The row is centred, so each px of margin given back lifts the
      // copy's bottom half a px, whatever the panel beside it (mid-switch here) is: give back twice the overhang, all
      // of it when there is not that much to give (the tabs then rise a little, as they would without the hold).
      // The review day's Join Meeting stack is the same shape (Dion 2026-10-10): the split button goes home too for the
      // home measurement (the other tabs show it there), then under the Tesla link for the Learn one.
      if (copy){
        copy.style.minHeight = ''; copy.style.marginBottom = '';
        if (learnOn && !gssMqFull.matches){
          placeJoin(false); placeStart(false); copy.classList.remove('gss-learn-on'); var ch = copy.offsetHeight; copy.classList.add('gss-learn-on'); if (ch) copy.style.minHeight = ch + 'px';
          var under = showStart ? startEl : showJoin ? joinEl : null;   // the button stacked under the Tesla link
          if (ch && under){ if (showStart) placeStart(true); else placeJoin(true); var lh = copy.offsetHeight; if (lh > ch){
            copy.style.marginBottom = (ch - lh) + 'px';
            var hang = slide ? under.getBoundingClientRect().bottom - (slide.getBoundingClientRect().bottom - (parseFloat(window.getComputedStyle(slide).paddingBottom) || 0)) : 0;
            if (hang > 0){ var mb = ch - lh + Math.ceil(2 * hang); copy.style.marginBottom = mb < 0 ? mb + 'px' : ''; }
          } }
        }
      }
      placeStart(showStart);
      placeJoin(showJoin);
      if (videoMode && learnOn){ requestAnimationFrame(sizeLearnVideo); setTimeout(sizeLearnVideo, 400); }
      else if (slide) slide.style.paddingBottom = '';   // other tabs keep the stylesheet's room for their buttons
      if (typeof fitStats === 'function') requestAnimationFrame(fitStats);
    }
    // LIVE for customers (Dion 2026-10-09): on Learn the card and the copy give way to a 9:16 video player that fills
    // the space between the tabs and the dock. The text version stays for testing: the GSTEST simulator's
    // "Learn tab: Text version". The closer embed never shows Learn, so it never builds the player.
    var videoMode = !EMBED_BILL && !(gssSim && gssSim.state && gssSim.state.learn === 'text');
    if (videoMode && !document.getElementById('gseLearnVideo')){
      var cssHref = (function(){ var l = document.querySelector('link[href*="gs-eligibility.css"]'); return l ? l.getAttribute('href') : ''; })();
      var assetUrl = function(name){ return cssHref ? cssHref.replace(/gs-eligibility\.css.*$/, name) : name; };
      var vcss = document.createElement('style');
      // The video takes the card's place. Desktop keeps the Learn copy beside it (text left, video right); a phone has
      // room for one, so there the copy gives way too.
      vcss.textContent = '#gs-elig .gss-learn-video #gseVPP{display:none !important}' +
        '@media (max-width:820px){#gs-elig .gss-learn-video .gss-learn-on > .gss-learn{display:none !important}}' +
        '@media (min-width:821px){#gs-elig .gss-learn-video .gss-learn-dock{margin-top:24px}}' +
        // Desktop: the same 8:5 frame + border as the satellite and outage map (wide poster); play still opens the 9:16 video
        '@media (min-width:821px){#gseLearnVideo.gse-vid-light{aspect-ratio:8/5;max-height:none;width:100%;border:1px solid var(--border-strong)}}' +
        '#gseLearnVideo{display:none;position:relative;border-radius:var(--radius,18px);overflow:hidden;background:#0c1018;box-shadow:var(--shadow);aspect-ratio:9/16;max-height:70vh;margin:0 auto}' +
        '#gs-elig .gss-learn-video #gseLearnVideo{display:block}' +
        '#gseLearnVideo .gse-vid-card{position:absolute;inset:0;width:100%;height:100%;padding:0;border:0;background:#0c1018;cursor:pointer;-webkit-tap-highlight-color:transparent}' +
        '#gseLearnVideo .gse-vid-card img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center bottom;display:block}' +
        // our own banner over the sky (the video's burned-in headline would crop on wider phones)
        '#gseLearnVideo .gse-vid-banner{position:absolute;left:0;right:0;top:0;padding:28px 22px 70px;text-align:center;background:linear-gradient(to bottom,rgba(4,7,18,.6),rgba(4,7,18,0));pointer-events:none}' +
        '#gseLearnVideo .gse-vid-banner b{display:block;color:#fff;font:600 27px/1.12 -apple-system,"SF Pro Display",system-ui,sans-serif;letter-spacing:-.022em}' +
        '#gseLearnVideo .gse-vid-banner span{display:block;margin-top:7px;color:rgba(255,255,255,.7);font:500 14.5px/1.3 -apple-system,"SF Pro Text",system-ui,sans-serif;letter-spacing:-.005em}' +
        // frosted-glass play button
        '#gseLearnVideo .gse-vid-play{position:absolute;left:50%;top:50%;width:70px;height:70px;margin:-35px 0 0 -35px;border-radius:50%;background:rgba(255,255,255,.2);-webkit-backdrop-filter:blur(22px) saturate(180%);backdrop-filter:blur(22px) saturate(180%);box-shadow:0 12px 34px rgba(0,0,0,.3),inset 0 0 0 .5px rgba(255,255,255,.5);display:flex;align-items:center;justify-content:center;transition:transform .22s cubic-bezier(.2,.8,.2,1),background .22s}' +
        '#gseLearnVideo .gse-vid-card:hover .gse-vid-play{background:rgba(255,255,255,.28)}' +
        '#gseLearnVideo .gse-vid-card:active .gse-vid-play{transform:scale(.92);background:rgba(255,255,255,.32)}' +
        '#gseLearnVideo .gse-vid-play svg{width:26px;height:26px;margin-left:0;color:#fff;display:block;filter:drop-shadow(0 1px 2px rgba(0,0,0,.25))}' +
        // the video itself is only ever seen in fullscreen
        '#gseLearnVideo video{position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;left:0;top:0}' +
        '#gseLearnVideo video:fullscreen,#gseLearnVideo video:-webkit-full-screen{width:100%;height:100%;opacity:1;pointer-events:auto;background:#000;object-fit:contain}' +
        // where fullscreen is refused (some in-app browsers), it plays inside the card instead, with a close button
        '#gseLearnVideo.gse-vid-inline video{inset:0;width:100%;height:100%;opacity:1;pointer-events:auto;background:#000;object-fit:contain;z-index:2}' +
        '#gseLearnVideo .gse-vid-x{display:none;position:absolute;top:10px;right:10px;z-index:3;width:34px;height:34px;border-radius:50%;border:0;background:rgba(0,0,0,.55);color:#fff;font:400 22px/1 -apple-system,system-ui,Arial;cursor:pointer}' +
        '#gseLearnVideo.gse-vid-inline .gse-vid-x{display:block}' +
        // v2 video (light art, headline area blanked on the poster): dark banner text, dark glass play button, centred
        // poster so phones crop sky and floor alike and the banner sits on blank sky
        '#gseLearnVideo.gse-vid-light{background:#f0f5f5}#gseLearnVideo.gse-vid-light .gse-vid-card{background:#f0f5f5}' +
        '#gseLearnVideo.gse-vid-light .gse-vid-card img{object-position:center center}' +
        '#gseLearnVideo.gse-vid-light .gse-vid-banner{background:none}' +
        '#gseLearnVideo.gse-vid-light .gse-vid-banner b{color:#1d1d1f}#gseLearnVideo.gse-vid-light .gse-vid-banner span{color:rgba(29,29,31,.58)}' +
        '#gseLearnVideo.gse-vid-light .gse-vid-play{background:rgba(29,29,31,.55)}' +
        '#gseLearnVideo.gse-vid-light .gse-vid-card:hover .gse-vid-play{background:rgba(29,29,31,.64)}' +
        '#gseLearnVideo.gse-vid-light .gse-vid-card:active .gse-vid-play{background:rgba(29,29,31,.72)}' +
        '@media (max-width:820px){#gseLearnVideo{aspect-ratio:auto;max-height:none;border-radius:18px}}';
      document.head.appendChild(vcss);
      var vwrap = document.createElement('div'); vwrap.id = 'gseLearnVideo'; vwrap.className = 'gse-vid-light';
      // Banner text: easy to swap (Dion picks from the options). Video v2 = "V3 Refined Update3" (80 s); v1 files
      // (gs-learn-video.mp4, gs-learn-poster-2.jpg, dark card without gse-vid-light) stay in the theme for rollback.
      var VIDEO_TITLE = 'See how it works', VIDEO_SUB = '80-second video';
      vwrap.innerHTML = '<button type="button" class="gse-vid-card" aria-label="Play the video: ' + VIDEO_TITLE + '">' +
          '<picture><source media="(min-width: 821px)" srcset="' + assetUrl('gs-learn-poster-16x9.jpg') + '">' +
            '<img src="' + assetUrl('gs-learn-poster-v2.jpg') + '" alt=""></picture>' +
          '<span class="gse-vid-banner"><b>' + VIDEO_TITLE + '</b><span>' + VIDEO_SUB + '</span></span>' +
          '<span class="gse-vid-play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.14v13.72a1 1 0 0 0 1.52.85l11.1-6.86a1 1 0 0 0 0-1.7L9.52 4.29A1 1 0 0 0 8 5.14z"/></svg></span>' +
        '</button>' +
        // no playsinline: on an iPhone, play() opens the video in the phone's own fullscreen player
        '<video preload="metadata" src="' + assetUrl('gs-learn-video-v2.mp4') + '"></video>' +
        '<button type="button" class="gse-vid-x" aria-label="Close the video">&times;</button>';
      var visual = ROOT.querySelector('.gss-intro-visual');
      if (visual){ var tier = document.getElementById('gseTier'); if (tier && tier.parentNode === visual) visual.insertBefore(vwrap, tier); else visual.appendChild(vwrap); }
      var vEl = vwrap.querySelector('video'), card = vwrap.querySelector('.gse-vid-card');
      var isFull = function(){ return !!(document.fullscreenElement || document.webkitFullscreenElement || vEl.webkitDisplayingFullscreen); };
      var inline = function(on){ vwrap.classList.toggle('gse-vid-inline', on); };
      var closeVideo = function(){ vEl.pause(); vEl.controls = false; inline(false); };
      // Watching, for the dashboard (D1 only): video_play on the first real start in this page load; video_progress
      // with s = the furthest point reached (the most of currentTime seen: a seek back changes nothing, a seek forward
      // counts), sent only when it grew since the last send, at every moment the viewing can stop (pause, the end, the
      // × close, leaving fullscreen, a tab switch, the page hiding or unloading: track() rides sendBeacon / keepalive,
      // which outlive the page) plus a checkpoint every 15 s of new ground for browsers that die without a pagehide;
      // video_complete once, at the end or at 97 %. Registered before the player's own listeners, so 'ended' still
      // reads the end position before the player rewinds. The closer embed never builds the player, and track() is
      // muted there anyway.
      var vMax = 0, vSent = 0, vPlayed = false, vDone = false;
      var vDur = function(){ var d = vEl.duration; return (d > 0 && isFinite(d)) ? Math.round(d) : 0; };
      var vSeen = function(){ var t = vEl.currentTime; if (t > vMax && isFinite(t)) vMax = t; };
      var vFlush = function(){ vSeen(); var s = Math.floor(vMax); if (s > vSent){ vSent = s; track('video_progress', { s: s, dur: vDur() }); } };
      var vComplete = function(){ if (vDone) return; vDone = true; track('video_complete', { dur: vDur() }); };
      vEl.addEventListener('playing', function(){ if (vPlayed) return; vPlayed = true; track('video_play', { dur: vDur() }); });
      vEl.addEventListener('timeupdate', function(){
        vSeen(); var d = vDur();
        if (!vDone && d && vMax >= 0.97 * d){ vFlush(); vComplete(); }   // once: the last seconds then go out on pause / end
        else if (Math.floor(vMax) >= vSent + 15) vFlush();
      });
      vEl.addEventListener('pause', vFlush);
      vEl.addEventListener('ended', function(){ var d = vEl.duration; if (d > vMax && isFinite(d)) vMax = d; vFlush(); vComplete(); });
      vEl.addEventListener('webkitendfullscreen', vFlush);
      document.addEventListener('fullscreenchange', vFlush);
      document.addEventListener('webkitfullscreenchange', vFlush);
      vwrap.querySelector('.gse-vid-x').addEventListener('click', vFlush);
      toggle.addEventListener('click', function(e){ var t = e.target.closest && e.target.closest('.gss-vtab'); if (t && t.dataset.view !== 'vpp') vFlush(); });
      document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'hidden') vFlush(); });
      window.addEventListener('pagehide', vFlush);
      card.addEventListener('click', function(){
        vEl.controls = true;
        var p = vEl.play(); if (p && p.catch) p.catch(function(){});
        // desktop and Android: ask for fullscreen; iPhone Safari goes fullscreen on play() by itself
        var refused = function(){ if (!isFull()) inline(true); };
        try {
          if (vEl.requestFullscreen) vEl.requestFullscreen().catch(function(){ try { if (vEl.webkitEnterFullscreen) vEl.webkitEnterFullscreen(); } catch (e) {} setTimeout(refused, 300); });
          else if (vEl.webkitRequestFullscreen) vEl.webkitRequestFullscreen();
          else if (vEl.webkitEnterFullscreen) vEl.webkitEnterFullscreen();
        } catch (e) {}
        // never a playing video nobody can see: if fullscreen didn't open, play it in the card
        setTimeout(refused, 900);
      });
      vwrap.querySelector('.gse-vid-x').addEventListener('click', closeVideo);
      // Leaving fullscreen pauses it and shows the card again (it picks up where they left off next time).
      var onExit = function(){ setTimeout(function(){ if (!isFull() && !vwrap.classList.contains('gse-vid-inline')) closeVideo(); }, 50); };
      vEl.addEventListener('webkitendfullscreen', onExit);
      document.addEventListener('fullscreenchange', onExit);
      document.addEventListener('webkitfullscreenchange', onExit);
      vEl.addEventListener('ended', function(){ vEl.currentTime = 0; if (document.exitFullscreen && document.fullscreenElement) document.exitFullscreen().catch(function(){}); else if (vEl.webkitExitFullscreen) { try { vEl.webkitExitFullscreen(); } catch (e) {} } closeVideo(); });
      // switching tabs mid-video stops it
      toggle.addEventListener('click', function(e){ var t = e.target.closest && e.target.closest('.gss-vtab'); if (t && t.dataset.view !== 'vpp') closeVideo(); });
    }
    // On a phone the player takes the room between the tabs and the fixed dock.
    function sizeLearnVideo(){
      var v = document.getElementById('gseLearnVideo'); if (!v || !gssMqFull.matches || !v.offsetParent) return;
      var dock = document.getElementById('gseLearnDock');
      // reserve exactly the dock's height under the player (the stylesheet reserves room for taller buttons)
      var slideEl = ROOT.querySelector('.gss-slide[data-slide="intro"]');
      if (slideEl && dock && dock.offsetHeight) slideEl.style.paddingBottom = 'calc(' + (dock.offsetHeight + 26) + 'px + env(safe-area-inset-bottom))';
      var dr = dock && dock.getBoundingClientRect(), vr = v.getBoundingClientRect();
      var bottom = (dr && dr.height) ? dr.top : window.innerHeight - 14;
      var h = Math.max(240, Math.round(bottom - vr.top - 12));
      v.style.height = h + 'px';
      // the slide's bottom padding (room for the dock) can still push it past the screen: give that back too
      var slide = ROOT.querySelector('.gss-slide[data-slide="intro"]'), over = slide ? slide.scrollHeight - slide.clientHeight : 0;
      if (over > 0) v.style.height = Math.max(240, h - over) + 'px';
    }
    window.addEventListener('resize', sizeLearnVideo);
    gssPaintLearn = paintLearn;
    paintLearn();
    ROOT.addEventListener('gse:lead', paintLearn);   // the utility is known once /lead resolves
    var learnRz = 0; window.addEventListener('resize', function(){ clearTimeout(learnRz); learnRz = setTimeout(paintLearn, 150); });   // re-measure the held height
    function showView(view, tab){
      toggle.querySelectorAll('.gss-vtab').forEach(function(t){ t.classList.toggle('on', t === tab); });
      if (copy){ copy.classList.toggle('gss-learn-on', view === 'vpp'); paintLearn(); }
      satView.hidden = (view !== 'roof');
      mapWrap.hidden = (view !== 'outages');
      if (vppView) vppView.hidden = (view !== 'vpp');
      if (liveView) liveView.hidden = (view !== 'live');
      if (spoilView) spoilView.hidden = (view !== 'spoilage');
      var tierEl = document.getElementById('gseTier');           // tier badge only over roof/outages
      if (tierEl) tierEl.style.display = (view === 'vpp' || view === 'live' || view === 'spoilage') ? 'none' : '';
      if (view === 'outages'){
        if (note){ note.hidden = false; note.textContent = 'Loading live outage map…'; }
        loadMapsApi().then(function(){
          if (note) note.hidden = true;
          initOutageMap();
          if (outageMap) google.maps.event.trigger(outageMap, 'resize');
        }).catch(function(){
          if (note){ note.hidden = false; note.textContent = 'Live outage map opens on gridstability.co'; }
        });
      }
      // panels differ in height — re-fit so the stats always clear the sticky CTA
      if (typeof fitStats === 'function') requestAnimationFrame(fitStats);
    }
    gssShowView = showView;
    toggle.querySelectorAll('.gss-vtab').forEach(function(tab){
      tab.addEventListener('click', function(){ showView(tab.dataset.view, tab); var v = tab.dataset.view; if (v === 'live' || v === 'outages' || v === 'vpp' || v === 'spoilage') track('tab_view', { view: v }); });
    });
    // "Your home" until /lead resolves. Then (Dion 2026-10-10) Learn for no booking (initPage) or a review booked for
    // a future day or today (applyBookedState), Power for a live outage (enableLiveOutage); a past review stays here.
    var def = toggle.querySelector('.gss-vtab[data-view="roof"]');
    if (def) showView('roof', def);
  })();

  /* ============================================================
     FLOW
  ============================================================ */
  var billTier = null;

  document.getElementById('gssStart').addEventListener('click', function(){
    if (pastMode) { startReschedule(); return; }
    track('flow_started');
    goTo('bill');
  });

  function optLabel(btn){ var b = btn.querySelector('.gss-opt-big'); return b ? b.textContent.trim() : ''; }

  ROOT.querySelectorAll('.gss-slide[data-slide="bill"] .gss-opt').forEach(function(btn){
    btn.addEventListener('click', function(){
      billTier = parseInt(btn.dataset.bill, 10);
      track('bill_answered', { tier: billTier, bill_label: optLabel(btn) });
      // Dion 2026-10-22: the CARE question only changes the verdict at $150-300 (tier 1). $0-150 never qualifies and
      // $300+ always does, so neither is asked: the verdict goes straight out ('care_skipped' is D1-only on the worker:
      // no tag, no GHL field) and the page moves on with no Congratulations beat. Re-answering sends these again; the
      // worker overwrites the same lead columns, so repeats are harmless.
      careSkipped = billTier !== 1;
      if (billTier === 0){
        track('care_skipped', { tier: 0, reason: '0-150' });
        track('disqualified', { tier: 0, care: false, skipped: true });
        goTo('dq');
      } else if (billTier === 1){
        goTo('care');
      } else {
        track('care_skipped', { tier: billTier, reason: '300+' });
        track('qualified', { tier: billTier, care: false, skipped: true });
        buildCalendar(); goTo('cal');
      }
    });
  });

  ROOT.querySelectorAll('.gss-slide[data-slide="care"] .gss-opt').forEach(function(btn){
    btn.addEventListener('click', function(){
      var care = btn.dataset.care === '1';
      track('care_answered', { care: care, care_label: optLabel(btn) });
      var dq = (billTier === 0) || (billTier === 1 && care);
      if (dq) { track('disqualified', { tier: billTier, care: care }); goTo('dq'); }
      else { track('qualified', { tier: billTier, care: care }); buildCalendar(); goTo('cal'); }
    });
  });

  /* ============================================================
     CALENDAR — real GHL availability (2-hour windows)
     Live mode (worker_base_url set + ?c=code): fetch /slots and
     render only the windows GHL actually has open; book with the
     exact ISO strings GHL returned. Preview/testing mode (no
     worker): fall back to the simulated generator below.
  ============================================================ */
  var coordinators = String(CFG.coordinators||'').split('\n').map(function(l){
    var p = l.split('|'); return { name:(p[0]||'').trim(), plat:(p[1]||'Zoom').trim() };
  }).filter(function(c){ return c.name; });
  if (!coordinators.length) coordinators = [{name:'Project Coordinator', plat:'Zoom'}];

  var WINDOW_MS = 2 * 3600000;
  var liveMode = !!(CFG.workerBase && leadCode);
  var avail = { timezone: 'America/Los_Angeles', days: {} }; // dayKey -> [{startISO,endISO}]
  var dayKeys = [];   // ordered 'YYYY-MM-DD' that have at least one window
  var selectedDay = 0;

  function fmt12(h){ return (((h+11)%12)+1) + ':00 ' + (h >= 12 ? 'PM' : 'AM'); }
  function fmtTimeTZ(iso){
    try {
      return new Date(iso).toLocaleTimeString('en-US',{hour:'numeric',minute:'2-digit',hour12:true,timeZone:avail.timezone});
    } catch(e){ return iso; }
  }
  function fmtDateTZ(iso){
    try { return new Date(iso).toLocaleDateString('en-US',{weekday:'long',month:'long',day:'numeric',timeZone:avail.timezone}); }
    catch(e){ return iso; }
  }
  function tzDayKey(ms){ return new Date(ms).toLocaleDateString('en-CA',{timeZone:avail.timezone}); } // YYYY-MM-DD
  function dayLabel(key){
    if (key === tzDayKey(Date.now())) return 'Today';
    if (key === tzDayKey(Date.now()+86400000)) return 'Tomorrow';
    return '';
  }
  function dowDate(key){
    var p = key.split('-');
    var d = new Date(parseInt(p[0],10), parseInt(p[1],10)-1, parseInt(p[2],10), 12, 0, 0);
    return { dow:d.toLocaleDateString('en-US',{weekday:'short'}), date:d.toLocaleDateString('en-US',{month:'short',day:'numeric'}) };
  }
  function ymd(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
  // YYYY-MM-DD that is `n` business days (Mon–Fri) after today. Today is "day 0"
  // and always bookable; the window then runs out to the nth business day.
  function businessCutoffKey(n){
    var p = tzDayKey(Date.now()).split('-');
    var d = new Date(parseInt(p[0],10), parseInt(p[1],10)-1, parseInt(p[2],10), 12, 0, 0);
    var added = 0;
    while (added < n){ d.setDate(d.getDate()+1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
    return ymd(d);
  }
  // Every GHL free start (30-min increments) becomes its own 2-hour window —
  // overlapping windows give the homeowner more choice; GHL validates conflicts on book.
  function toWindows(isoList){
    return (isoList||[]).slice().sort().map(function(iso){
      var t = new Date(iso).getTime();
      return { startISO: iso, endISO: new Date(t + WINDOW_MS).toISOString() };
    });
  }

  function buildCalendar(){ if (liveMode) fetchSlots(); else buildSimCalendar(); }

  // The full-screen "Congratulations" beat (#gseCongratsOv in the section) is gone (Dion 2026-10-22): a qualified
  // answer goes straight to the schedule. The overlay markup stays hidden; nothing shows it any more.

  function fetchSlots(){
    var urg = document.getElementById('gseUrgency');
    if (urg) urg.textContent = 'Checking live availability…';
    fetch(CFG.workerBase.replace(/\/$/,'') + '/slots?days=' + CFG.daysAhead)
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        if (!d || !d.days) { buildSimCalendar(); return; }
        avail.timezone = d.timezone || avail.timezone;
        avail.days = {}; dayKeys = [];
        Object.keys(d.days).sort().forEach(function(k){
          var w = toWindows(d.days[k]);
          if (w.length){ avail.days[k] = w; dayKeys.push(k); }
        });
        var cutoff = businessCutoffKey(CFG.daysAhead);
        dayKeys = dayKeys.filter(function(k){ return k <= cutoff; });
        if (!dayKeys.length){ renderNoSlots(); return; }
        if (selectedDay >= dayKeys.length) selectedDay = 0;
        renderDayTabs();
        renderSlots();
      })
      .catch(function(){ buildSimCalendar(); });
  }

  function renderNoSlots(){
    document.getElementById('gseDays').innerHTML = '';
    document.getElementById('gseSlots').innerHTML =
      '<p class="gss-fineprint" style="grid-column:1/-1">No openings in the next ' + CFG.daysAhead +
      ' days — your coordinator will reach out with the soonest time.</p>';
    var urg = document.getElementById('gseUrgency'); if (urg) urg.textContent = 'We’ll prioritize your review';
  }

  function renderDayTabs(){
    var tabs = document.getElementById('gseDays');
    tabs.innerHTML = '';
    tabs.style.gridTemplateColumns = 'repeat(' + Math.max(dayKeys.length, 1) + ',1fr)';
    dayKeys.forEach(function(k, i){
      var info = dowDate(k), tag = dayLabel(k);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gss-day' + (i === selectedDay ? ' on' : '');
      b.innerHTML =
        '<div class="gss-day-dow">' + info.dow + '</div>' +
        '<div class="gss-day-date">' + info.date + '</div>' +
        '<div class="gss-day-tag">' + (tag || '&nbsp;') + '</div>';
      b.addEventListener('click', function(){
        selectedDay = i;
        tabs.querySelectorAll('.gss-day').forEach(function(t,j){ t.classList.toggle('on', j === i); });
        renderSlots();
      });
      tabs.appendChild(b);
    });
  }

  function renderSlots(){
    var list = document.getElementById('gseSlots');
    list.innerHTML = '';
    var key = dayKeys[selectedDay];
    var windows = avail.days[key] || [];
    windows.forEach(function(w){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gss-slot';
      btn.innerHTML =
        '<span>' + fmtTimeTZ(w.startISO) + '</span><span class="gss-slot-plan">Plan for at least 1 hour</span>';
      btn.addEventListener('click', function(){ selectSlot(w.startISO, w.endISO); });
      list.appendChild(btn);
    });
    var open = windows.length;
    var isToday = dayLabel(key) === 'Today';
    document.getElementById('gseUrgency').textContent =
      isToday
        ? (open > 0 ? open + ' same-day opening' + (open>1?'s':'') + ' left in your zone' : 'Same-day is full — tomorrow has openings')
        : 'Due to the volume of outages each day, we can only schedule up to 3 business days out.';
  }

  function showConfirm(startISO, endISO, coord, realCoordName){
    closeModal();
    document.getElementById('gseConfWhen').textContent =
      fmtDateTZ(startISO) + ' · ' + fmtTimeTZ(startISO);
    document.getElementById('gseConfCoord').textContent = realCoordName || coord.name;
    document.getElementById('gseConfPlat').textContent = coord.plat;
    confirmBack = false;   // post-booking is the terminal success state — no back arrow
    goTo('confirm');
  }

  /* tapping a slot no longer books — it opens the requirements modal first */
  var pending = null;
  var modalEl = document.getElementById('gseModal');
  function openModal(){ if (modalEl) modalEl.hidden = false; }
  function closeModal(){ if (modalEl) modalEl.hidden = true; }
  if (modalEl) modalEl.addEventListener('click', function(e){ if (e.target === modalEl) closeModal(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modalEl && !modalEl.hidden) closeModal(); });

  /* eligibility criteria popup (VPP card) */
  (function(){
    var cm = document.getElementById('gseCriteriaModal');
    var openBtn = document.getElementById('gseCritBtn');
    var x = document.getElementById('gseCriteriaClose');
    if (!cm || !openBtn) return;
    openBtn.addEventListener('click', function(){ cm.hidden = false; });
    if (x) x.addEventListener('click', function(){ cm.hidden = true; });
    var ok = document.getElementById('gseCriteriaOk'); if (ok) ok.addEventListener('click', function(){ cm.hidden = true; });
    cm.addEventListener('click', function(e){ if (e.target === cm) cm.hidden = true; });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !cm.hidden) cm.hidden = true; });
  })();

  function selectSlot(startISO, endISO){
    pending = { startISO: startISO, endISO: endISO };
    track('timeslot_selected', { startISO: startISO });
    document.getElementById('gseReviewWhen').textContent =
      fmtDateTZ(startISO) + ' · ' + fmtTimeTZ(startISO);
    var err = document.getElementById('gseBookErr'); if (err) err.textContent = '';
    var cb = document.getElementById('gseConfirmBook');
    if (cb){ cb.disabled = false; }
    openModal();
  }

  function confirmBooking(){
    if (!pending) return;
    var startISO = pending.startISO, endISO = pending.endISO;
    var coord = coordinators[Math.floor(Math.random()*coordinators.length)];
    var btn = document.getElementById('gseConfirmBook');
    var err = document.getElementById('gseBookErr'); if (err) err.textContent = '';

    if (!liveMode){
      // preview/testing: no Worker — log + confirm without a real appointment
      track('appointment_booked', { date:startISO.slice(0,10), startISO:startISO, coordinator:coord.name, platform:coord.plat, tier:billTier });
      showConfirm(startISO, endISO, coord, null);
      return;
    }

    if (rescheduleMode) {
      if (btn) btn.disabled = true;
      fetch(CFG.workerBase.replace(/\/$/,'') + '/reschedule', {
        method:'POST', headers:{'Content-Type':'text/plain'},
        body: JSON.stringify({ c: leadCode, appointmentId: rescheduleApptId, startTime: startISO, endTime: endISO })
      })
      .then(function(r){ return r.json().catch(function(){ return {}; }); })
      .then(function(res){
        if (!res || !res.ok) throw new Error('reschedule failed');
        track('appointment_rescheduled', { startISO: startISO, appointmentId: rescheduleApptId });
        rescheduleMode = false;
        showConfirm(startISO, endISO, coord, (bookedAppt && bookedAppt.coordinator) || null);
      })
      .catch(function(){
        if (btn) btn.disabled = false;
        if (err) err.textContent = 'That window was just taken — tap “Pick a different time” to choose another.';
      });
      return;
    }

    if (btn) btn.disabled = true;
    fetch(CFG.workerBase.replace(/\/$/,'') + '/book', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ c: leadCode, startTime: startISO, endTime: endISO, tier: billTier })
    })
    .then(function(r){ return r.json().catch(function(){ return {}; }); })
    .then(function(res){
      if (res && res.ok && res.appointmentId){
        track('appointment_booked', {
          date: startISO.slice(0,10), startISO: startISO,
          coordinator: (res.coordinator || coord.name), platform: coord.plat,
          tier: billTier, appointmentId: res.appointmentId
        });
        showConfirm(startISO, endISO, coord, res.coordinator);
        return;
      }
      if (btn) btn.disabled = false;
      var reason = res && res.reason;
      if (err) err.textContent =
        reason === 'slot_unavailable' ? 'That window was just taken — tap “Pick a different time” to choose another.'
        : reason === 'contact_missing' ? 'We couldn’t find your record — reply to your text or call us and we’ll lock in your time.'
        : 'We couldn’t confirm that time — please try again, or reply to your text and we’ll help.';
    })
    .catch(function(){
      if (btn) btn.disabled = false;
      if (err) err.textContent = 'Network hiccup — please try again in a moment.';
    });
  }

  var _confirmBtn = document.getElementById('gseConfirmBook');
  if (_confirmBtn) _confirmBtn.addEventListener('click', confirmBooking);
  var _changeBtn = document.getElementById('gseChangeTime');
  if (_changeBtn) _changeBtn.addEventListener('click', function(){
    closeModal();
    if (liveMode) fetchSlots();
  });

  /* Secondary path: request a callback instead of scheduling. Flags the contact
     in GHL (rep workflow) + logs to D1; leaves the slots available either way. */
  var _cbBtn = document.getElementById('gseCallbackBtn');
  if (_cbBtn) _cbBtn.addEventListener('click', function(){
    track('callback_requested');
    var wrap = document.getElementById('gseCallbackWrap');
    if (wrap) wrap.innerHTML = '<div class="gss-callback-done">✓ Got it — a representative will reach out by phone shortly. You can still pick a time above if you’d prefer.</div>';
  });

  /* ---- simulated fallback (preview / no worker_base_url) ---- */
  function buildSimCalendar(){
    liveMode = false;
    var SIM = [];
    for (var hh = CFG.dayStartHour; hh + 2 <= CFG.dayEndHour; hh += 2) SIM.push([hh, hh+2]);
    var tabs = document.getElementById('gseDays');
    tabs.innerHTML = '';
    dayKeys = [];
    var now = new Date();
    dayKeys.push(new Date(now));               // today (day 0)
    var walk = new Date(now), added = 0;
    while (added < CFG.daysAhead){ walk.setDate(walk.getDate()+1); var wd = walk.getDay(); if (wd !== 0 && wd !== 6){ dayKeys.push(new Date(walk)); added++; } }
    tabs.style.gridTemplateColumns = 'repeat(' + dayKeys.length + ',1fr)';
    selectedDay = 0;
    dayKeys.forEach(function(d, i){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gss-day' + (i === 0 ? ' on' : '');
      b.innerHTML =
        '<div class="gss-day-dow">' + d.toLocaleDateString('en-US',{weekday:'short'}) + '</div>' +
        '<div class="gss-day-date">' + d.toLocaleDateString('en-US',{month:'short',day:'numeric'}) + '</div>' +
        '<div class="gss-day-tag">' + (i===0 ? 'Today' : i===1 ? 'Tomorrow' : '&nbsp;') + '</div>';
      b.addEventListener('click', function(){
        selectedDay = i;
        tabs.querySelectorAll('.gss-day').forEach(function(t,j){ t.classList.toggle('on', j === i); });
        renderSimSlots(SIM);
      });
      tabs.appendChild(b);
    });
    renderSimSlots(SIM);
  }

  function renderSimSlots(SIM){
    var list = document.getElementById('gseSlots');
    list.innerHTML = '';
    var now = new Date();
    var d = dayKeys[selectedDay];
    var dayRng = seeded(lead.zip + 'd' + selectedDay + now.toDateString());
    var open = 0;
    SIM.forEach(function(se){
      var s = se[0], e = se[1];
      var isToday = selectedDay === 0;
      var past = isToday && (now.getHours() >= s - 1);
      var taken = !past && dayRng() < (isToday ? 0.45 : 0.22);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gss-slot';
      btn.disabled = taken || past;
      btn.innerHTML =
        '<span>' + fmt12(s) + '</span>' +
        (past ? '<span class="gss-slot-note">Passed</span>'
              : taken ? '<span class="gss-slot-note">Taken</span>'
                      : '<span class="gss-slot-plan">Plan for at least 1 hour</span>');
      if (!btn.disabled){
        open++;
        btn.addEventListener('click', function(){
          var sd = new Date(d); sd.setHours(s,0,0,0);
          var ed = new Date(d); ed.setHours(e,0,0,0);
          selectSlot(sd.toISOString(), ed.toISOString());
        });
      }
      list.appendChild(btn);
    });
    document.getElementById('gseUrgency').textContent =
      selectedDay === 0
        ? (open > 0 ? open + ' same-day opening' + (open>1?'s':'') + ' left in your zone' : 'Same-day is full — tomorrow has openings')
        : 'Due to the volume of outages each day, we can only schedule up to 3 business days out.';
  }
})();
